{
  "app": {
    "shellTitle": "TMM Product Admin · Console Plateforme",
    "loading": "Chargement",
    "name": "TMM Product Admin"
  },
  "common": {
    "retry": "Réessayer",
    "close": "Fermer",
    "menu": "Menu",
    "loading": "Chargement",
    "loadingPage": "Chargement…",
    "language": "Langue",
    "noProgress": "Aucune progression",
    "days_one": "{{count, number}} jour",
    "days_other": "{{count, number}} jours",
    "unlimited": "∞",
    "panelError": "Cette section n'a pas pu être affichée.",
    "tryAgain": "Réessayer",
    "outcomeUnknown": "Nous n'avons pas pu confirmer la modification. L'écran a été rechargé — vérifiez avant de réessayer.",
    "cancel": "Annuler",
    "scope": {
      "period": "{{period}} ({{from}} – {{to}}) · {{reseller}}"
    },
    "loadedAt": "Chargé à {{time}}",
    "reload": "Recharger",
    "confirm": "Confirmer"
  },
  "components": {
    "saving": "Enregistrement…",
    "cannotClear": "Ce champ ne peut pas encore être effacé. Saisissez une valeur ou laissez-le tel quel.",
    "copy": "Copier {{identifier}}",
    "copied": "Copié",
    "lastAttemptFailed": "La dernière tentative a échoué.",
    "copyDetails": "Copier les détails pour le support",
    "idLabel": "ID {{id}}",
    "reference": "Référence : {{id}}",
    "loadFailed": "Le chargement a échoué.",
    "clearFilters": "Effacer les filtres",
    "filteredEmpty": "Un filtre est actif. Effacez-le pour tout voir.",
    "moreActions": "Plus d'actions",
    "actionsFor": "Actions pour {{name}}",
    "editDetails": {
      "menu": "Modifier les détails…",
      "title": "Modifier les détails",
      "saved": "Détails enregistrés.",
      "refreshFailed": "Enregistré. Actualisation impossible",
      "nameTaken": "Ce nom est déjà utilisé.",
      "immutable": "{{fields}} ne peuvent pas être modifiés sur un {{entity}} en vigueur. Utilisez Copier pour modifier.",
      "conflict": "Quelqu’un d’autre a modifié ceci. Rechargez pour voir ses modifications.",
      "reload": "Recharger",
      "save": "Enregistrer",
      "futureOffers": "S’applique uniquement aux offres futures.",
      "required": "Obligatoire.",
      "tooLong": "{{max, number}} caractères au maximum.",
      "entity": {
        "commissionPlan": "plan de commission",
        "agreement": "accord",
        "addon": "module complémentaire",
        "reseller": "revendeur"
      },
      "saveError": "Impossible d’enregistrer les détails."
    },
    "breadcrumbs": "Fil d'Ariane",
    "copyFailed": "Copie impossible — sélectionnez le texte.",
    "unsaved": {
      "title": "Quitter sans enregistrer ?",
      "consequence": "Vos modifications de {{name}} seront perdues.",
      "leave": "Quitter",
      "stay": "Rester"
    },
    "errorSummary_one": "{{count, number}} champ à corriger",
    "errorSummary_other": "{{count, number}} champs à corriger"
  },
  "lang": {
    "en": "EN",
    "es": "ES",
    "fr": "FR",
    "pt": "PT"
  },
  "nav": {
    "signOut": "Se déconnecter",
    "dashboard": "Tableau de bord",
    "group": {
      "platform": "Plateforme",
      "pricing": "Tarification",
      "money": "Finances"
    },
    "rateCards": "Grilles tarifaires",
    "addOns": "Catalogue des modules complémentaires",
    "revenue": "Revenus",
    "payouts": "Versements",
    "aiModelPrices": "Prix des modèles d'IA",
    "settings": "Paramètres",
    "partners": "Partenaires",
    "tickets": "Assistance",
    "parkedPayments": "Paiements en attente",
    "billingAttention": "Attention facturation",
    "aiCostReconciliation": "Rapprochement des coûts IA",
    "merchantKnowledge": "Connaissance des commerçants"
  },
  "shell": {
    "scope": "Plateforme — tous les tenants",
    "accountMenu": "Compte",
    "collapseNav": "Réduire la navigation",
    "expandNav": "Développer la navigation",
    "theme": {
      "label": "Thème",
      "light": "Clair",
      "dark": "Sombre",
      "system": "Système"
    },
    "skipToMain": "Aller au contenu principal"
  },
  "palette": {
    "trigger": "Rechercher ou aller à…",
    "triggerLabel": "Rechercher ou aller à… ({{shortcut}})",
    "keysHint": "↑↓ pour se déplacer · Entrée pour ouvrir · Échap pour fermer",
    "resultCount_one": "{{count, number}} résultat",
    "resultCount_other": "{{count, number}} résultats",
    "noMatches": "Aucun résultat pour « {{q}} »",
    "recentGone": "Cet enregistrement n'existe plus.",
    "group": {
      "recent": "Consultés récemment",
      "commands": "Commandes",
      "screens": "Écrans",
      "nextSteps": "Étapes suivantes"
    },
    "command": {
      "newRateCard": "Nouvelle grille tarifaire",
      "theme": "Thème : {{mode}}"
    },
    "type": {
      "affiliate": "Affilié"
    },
    "failed": {},
    "searching": {}
  },
  "page": {
    "dashboard": {
      "title": "Tableau de bord",
      "subtitle": "Chaque tenant de la plateforme, ce qu'il a encaissé et ce que nous conservons."
    },
    "rateCards": {
      "title": "Grilles tarifaires"
    },
    "addOns": {
      "title": "Catalogue des modules complémentaires",
      "subtitle": "Ce que la plateforme vend aux tenants, et qui l'a."
    },
    "revenue": {
      "title": "Revenus",
      "subtitle": "Ce que la flotte a encaissé, notre prix de gros, et la marge et le net de chaque revendeur."
    },
    "payouts": {
      "title": "Versements",
      "subtitle": "Une feuille de course pour les revendeurs et affiliés de tous les tenants."
    },
    "aiModelPrices": {
      "title": "Tarifs des modèles d'IA",
      "subtitle": "Ce que nous coûtent les modèles, et les limites d’IA de la plateforme."
    },
    "settings": {
      "subtitle": "Paramètres à l'échelle de la plateforme pour ce produit.",
      "title": "Paramètres du produit"
    },
    "partners": {
      "title": "Partenaires"
    },
    "billingAttention": {
      "title": "Attention facturation",
      "subtitle": "Problèmes de facturation à examiner. Chaque onglet est un type."
    },
    "parkedEvents": {
      "title": "Événements de paiement en attente",
      "subtitle": "Événements de paiement que tmm-api n’a pas pu appliquer. Réappliquez-en un une fois la cause corrigée, ou écartez-le."
    },
    "aiReconciliation": {
      "title": "Rapprochement des coûts IA",
      "subtitle": "Une ligne par jour UTC et par devise. Les nombres mis en évidence doivent être à zéro."
    },
    "resellers": {},
    "tickets": {
      "title": "Assistance"
    },
    "merchantKnowledge": {
      "title": "Connaissance des commerçants"
    }
  },
  "bootstrap": {
    "error": "Impossible de charger la configuration de l'application.",
    "errorNotRegistered": "Cet hôte n'est pas enregistré. Contactez votre administrateur.",
    "retry": "Réessayer"
  },
  "auth": {
    "redirecting": "Redirection vers la connexion…",
    "returning": "Finalisation de la connexion…",
    "noAccessTitle": "Vous n'avez pas accès à cette console",
    "noAccessBody": "Votre compte est connecté, mais l'accès à cette console d'administration du produit ne lui a pas été accordé. Contactez votre administrateur si vous pensez qu'il s'agit d'une erreur.",
    "productAdminRequired": "Accès administrateur du produit requis",
    "productAdminRequiredBody": "Vous êtes connecté, mais l'accès à cette console d'administration du produit n'a pas été accordé à votre compte.",
    "signedOutTitle": "Vous êtes déconnecté",
    "signedOutBody": "Votre session d'administrateur du produit a pris fin.",
    "signInAgain": "Se connecter à nouveau"
  },
  "errors": {
    "generic": "Quelque chose s'est mal passé. Veuillez réessayer.",
    "notFoundTitle": "Introuvable",
    "notFoundBody": "Nous n'avons pas trouvé ce que vous cherchiez.",
    "field": {
      "rejected": "Cette valeur n’est pas acceptée. Vérifiez-la et réessayez."
    },
    "code": {
      "SESSION_EXPIRED": "Votre session a expiré. Reconnectez-vous.",
      "CSRF_VALIDATION_FAILED": "La requête n’a pas pu être vérifiée. Rechargez la page et réessayez.",
      "INVALID_CREDENTIALS": "Ces identifiants n’ont pas été acceptés.",
      "CODE_INVALID": "Ce lien de connexion n’est plus valide. Reconnectez-vous.",
      "INVALID_RETURN_URL": "Cette adresse de retour n’est pas autorisée.",
      "PRODUCT_ADMIN_REQUIRED": "Vous n’avez pas accès à cette console.",
      "PRODUCT_ADMIN_REVOKED": "Votre accès à cette console a été retiré. Reconnectez-vous.",
      "PRODUCT_CONTEXT_MISMATCH": "Cette session appartient à un autre produit. Reconnectez-vous.",
      "ACTING_USER_NOT_PRODUCT_ADMIN": "Votre accès à cette console a été retiré. Reconnectez-vous.",
      "TENANT_ORIGIN_MISMATCH": "Cette requête provient d’une adresse non autorisée.",
      "RATE_LIMIT_REJECTED": "Trop de requêtes. Patientez un instant, puis réessayez.",
      "RATE_LIMITED": "Trop de requêtes. Patientez un instant, puis réessayez.",
      "INVALID_LOCALE": "Cette langue n’est pas prise en charge.",
      "NETWORK_ERROR": "Impossible de joindre le serveur. Vérifiez votre connexion et réessayez.",
      "VALIDATION_FAILED": "Certaines valeurs n’ont pas été acceptées. Vérifiez-les et réessayez.",
      "SAAS_AUTH_OUTCOME_UNKNOWN": "Nous n’avons pas pu confirmer la modification. Vérifiez avant de réessayer.",
      "CONCURRENT_UPDATE": "Quelqu’un d’autre l’a modifié en même temps. Rechargez et réessayez.",
      "TENANT_CURRENCY_NOT_PRICED": "La devise de ce tenant ne figure pas dans la grille tarifaire de son revendeur.",
      "PRODUCT_HAS_NO_DEFAULT_BRAND": "Le produit n’a pas de marque par défaut à copier. Définissez-en une dans saas-admin, puis réessayez.",
      "HOSTNAME_ALREADY_REGISTERED": "Ce nom d’hôte est déjà enregistré.",
      "WHITELABEL_DOMAIN_INVALID": "Ce domaine n’est pas valide. Vérifiez-le et réessayez.",
      "RESELLER_SUSPENDED_USE_REACTIVATE": "Ce revendeur est suspendu. Utilisez d’abord Réactiver.",
      "RESELLER_SUSPENDED_USE_STATUS": "Ce partenaire est suspendu. Levez d’abord la suspension avec Réactiver sur son statut, puis réessayez.",
      "RESELLER_NOT_DEACTIVATED": "Ce revendeur n’est pas désactivé.",
      "RESELLER_STANDING_CONFLICT": "La situation de ce revendeur a changé. Rechargez et réessayez.",
      "RESELLER_NOT_FOUND": "Ce revendeur est introuvable.",
      "RESELLER_CHARGE_NOT_FOUND": "Ce prélèvement est introuvable.",
      "COMMISSION_PLAN_NAME_TAKEN": "Un autre plan de ce revendeur porte déjà ce nom.",
      "PAYOUT_ON_HOLD": "Ce versement ne peut pas être enregistré tant qu’il est suspendu.",
      "DELETION_ALREADY_REQUESTED": "Une suppression est déjà demandée pour cette personne.",
      "DELETION_CANCELLED": "Cette demande de suppression a été annulée.",
      "DELETION_REQUEST_NOT_FOUND": "Cette demande de suppression est introuvable.",
      "PROMOTION_NOT_APPLIED": "Aucune promotion n’est appliquée à cet abonnement pour le moment.",
      "PROMOTION_ALREADY_APPLIED": "Cet abonnement a déjà une promotion. Terminez-la d’abord pour appliquer un autre code.",
      "PROMOTION_NOT_REDEEMABLE": "Ce code ne peut pas être utilisé pour le moment. Il est peut-être inactif, hors de ses dates ou épuisé.",
      "PLAN_MAPPING_CONFLICT": "Le plan de paiement de cette offre ne correspond pas à pay-api, donc rien n’a été modifié. Réessayer n’y changera rien : demandez à l’équipe de la plateforme de vérifier l’offre.",
      "PLAN_CREATE_FAILED": "pay-api n’a pas pu créer le plan de paiement, donc rien n’a été modifié. Réessayez plus tard. Si l’échec persiste, adressez-vous à l’équipe de la plateforme.",
      "PAY_API_UNAVAILABLE": "pay-api n’est pas disponible pour le moment, donc rien n’a été modifié. Réessayez plus tard.",
      "BILLING_CONNECTION_CONFLICT": "Ce tenant a déjà une connexion d’encaissement différente dans pay-api.",
      "TAX_LOCATION_REQUIRED": "Une adresse de facturation est nécessaire pour calculer la taxe. Demandez à l’abonné d’en ajouter une, puis réessayez.",
      "PARKED_EVENT_STILL_REFUSED": "Refusé à nouveau. Rien n’a été modifié.",
      "PARKED_EVENT_UNAVAILABLE": "pay-api n’a plus cet événement (les événements sont conservés 90 jours, et l’événement d’un membre effacé ne peut pas être relu). S’il a été traité dans pay-api, écartez-le avec une note.",
      "PARKED_EVENT_RESOLVED": "Quelqu’un a déjà résolu cet événement.",
      "PARKED_EVENT_NOT_FOUND": "Cet événement n’est plus en attente.",
      "PARKED_EVENT_BUSY": "Cet événement est occupé pour le moment. Réessayez dans un instant.",
      "AFFILIATE_STATE": "Le statut de cet affilié a changé. Rechargez et réessayez.",
      "TENANT_SLUG_TAKEN": "Ce slug est déjà enregistré. Choisissez-en un autre.",
      "TENANT_SETUP_INCOMPLETE": "Nous n'avons pas pu confirmer que le tenant a été entièrement créé. Vous pouvez réessayer sans risque.",
      "TENANT_CURRENCY_LOCKED": "Verrouillée dès que le tenant a des abonnements.",
      "TENANT_NOT_PRICED": "Ce tenant ne peut pas encore vendre : son revendeur n'a pas d'accord.",
      "BRAND_SLUG_GENERATION_FAILED": "Impossible de générer un nom pour la nouvelle marque. Réessayez.",
      "MERCHANT_OF_RECORD_UNSET": "Le marchand officiel n'est pas défini.",
      "UPSTREAM_UNAVAILABLE": "Le service de connexion n’a pas répondu. Réessayez.",
      "RESELLER_SUSPENDED": "Ce revendeur est suspendu et ne peut pas recevoir de tenants.",
      "RESELLER_DEACTIVATED": "Ce revendeur est désactivé et ne peut pas recevoir de tenants. Choisissez-en un autre.",
      "RESELLER_HAS_TENANT": "Ce revendeur possède déjà un tenant.",
      "RESELLER_SLUG_TAKEN": "Ce slug est déjà utilisé par un autre revendeur.",
      "RESELLER_REQUIRED": "Le revendeur est obligatoire.",
      "RESELLER_CONSOLE_NOT_CONFIGURED": "tmm n’a pas encore de console revendeur : les utilisateurs revendeurs ne peuvent donc pas être invités. L’opérateur de la plateforme la configure dans saas-admin.",
      "RESELLER_CHARGE_NOT_RETRYABLE": "Ce prélèvement ne peut pas être relancé pour le moment.",
      "RATE_CARD_IMMUTABLE": "Seule une grille tarifaire en brouillon peut être modifiée.",
      "COMMISSION_PLAN_IMMUTABLE": "Ce plan n’est plus un brouillon. Copiez-le pour le changer.",
      "PAYOUT_NOT_PAYABLE": "Ce règlement a été prélevé sur la carte du revendeur ; il n’y a rien à payer.",
      "INVITATION_ALREADY_ACCEPTED": "Cette invitation a déjà été acceptée. La liste a été actualisée.",
      "INVITATION_ALREADY_PENDING": "Une invitation est déjà en attente pour cet e-mail.",
      "ALREADY_ACTIVE_MEMBER": "Cette personne fait déjà partie du personnel actif.",
      "LAST_OWNER_PROTECTED": "Cela supprimerait le dernier propriétaire du tenant.",
      "ROLE_CHANGE_CROSSES_TABLES": "Ce changement de rôle n'est pas autorisé pour ce membre du personnel.",
      "GHL_LOCATION_NOT_VERIFIED": "Ce jeton ne peut pas lire cet emplacement — vérifiez l’id de l’emplacement et les autorisations du jeton.",
      "GHL_LOCATION_ALREADY_CLAIMED": "Cet emplacement est déjà connecté ailleurs.",
      "RESELLER_PLATFORM_OWNED": "Ce partenaire appartient à la plateforme et ne peut pas être désactivé.",
      "RESELLER_HAS_TENANTS": "Ce revendeur possède encore un tenant ; il ne peut donc pas être supprimé.",
      "RESELLER_LAST_OWNER": "Cela supprimerait le dernier propriétaire du revendeur.",
      "TENANT_NOT_FOUND": "Ce tenant est introuvable.",
      "ADDON_ACTIVE": "Ce module complémentaire est déjà actif pour ce tenant.",
      "AGREEMENT_REQUIRED": "Ce revendeur n’a pas encore d’accord.",
      "OFFER_NOT_ACTIVE": "Cette offre n’est plus active. Choisissez-en une autre.",
      "RATE_CARD_NOT_ACTIVE": "Activez ou corrigez d’abord la grille.",
      "RATE_CARD_NAME_TAKEN": "Une autre grille tarifaire de ce revendeur porte déjà ce nom.",
      "RATE_CARD_VERSION_CONFLICT": "Quelqu’un d’autre a modifié ceci. Rechargez pour voir ses modifications.",
      "CARD_ADOPTED": "Ce revendeur utilise cette grille. Il doit en adopter une autre avant que cette autorisation puisse être révoquée.",
      "RATE_CARD_NOT_FOUND": "Cette grille tarifaire est introuvable.",
      "COMMISSION_PLAN_VERSION_CONFLICT": "Quelqu’un d’autre a modifié ceci. Rechargez pour voir ses modifications.",
      "RATE_CARD_INVALID": "Cette version ne passe pas encore les vérifications de la grille tarifaire.",
      "NO_RATE_CARD": "Ce revendeur n'a pas adopté de grille tarifaire.",
      "PAYOUTS_MOVED_TO_LEDGER": "Les versements sont passés au grand livre des partenaires. Utilisez le grand livre du partenaire.",
      "HOLD_ALREADY_OPEN": "Un blocage pour motif grave est déjà ouvert sur ce partenaire.",
      "HOLD_NOT_OPEN": "Ce blocage n'est plus ouvert. Le grand livre a été rechargé.",
      "HOLD_NOT_RELEASABLE": "Ce blocage ne peut pas être levé ici.",
      "HOLD_OPS_ONLY": "Seules les opérations peuvent lever ce blocage ; il est en file d'attente.",
      "HOLD_NOT_VOIDABLE": "Seul un blocage pour motif grave peut être annulé.",
      "HOLD_NOT_FOUND": "Ce blocage est introuvable.",
      "NOTHING_TO_VOID": "Le solde n'est pas positif : il n'y a rien à annuler.",
      "SETTLEMENT_IN_FLIGHT": "Un versement ou un recouvrement est en cours. Réessayez une fois terminé.",
      "CONFIRMATION_REQUIRED": "La confirmation ne correspond pas. Saisissez-la telle qu’elle apparaît.",
      "PAYEE_NOT_FOUND": "Ce partenaire n'est pas encore configuré comme bénéficiaire.",
      "PAYEE_RAIL_MISMATCH": "Les paiements manuels ne s'enregistrent que pour un partenaire payé manuellement.",
      "PAYEE_ON_HOLD": "Les versements du partenaire sont bloqués pour motif grave. Levez d’abord le blocage.",
      "STATEMENT_NOT_PAYABLE": "Ce relevé ne peut pas être payé avec ce montant.",
      "STATEMENT_NOT_FOUND": "Ce relevé est introuvable.",
      "TAX_YEAR_CLOSED": "Cette année fiscale est déjà close. L'Opérateur enregistre ce paiement auprès du service de déclaration.",
      "IDEMPOTENCY_CONFLICT": "Ceci a déjà été envoyé avec d’autres données. Rechargez et vérifiez.",
      "LEDGER_CUTOVER_NOT_READY": "Une vérification de préparation échoue. Corrigez-la, puis réessayez cette étape.",
      "TICKET_NOT_FOUND": "Ce ticket n’existe pas.",
      "TICKET_TRANSITION_INVALID": "Ce statut ne peut pas suivre le statut actuel du ticket.",
      "TICKET_DUPLICATE_INVALID": "Impossible de le marquer comme doublon : c’est le même ticket, c’est déjà un doublon ou c’est une demande d’assistance.",
      "ANNOUNCEMENT_NOT_FOUND": "Cette annonce n’existe pas.",
      "ANNOUNCEMENT_TERM_REFUSED": "Elle mentionne un terme interne. Retirez-le pour publier.",
      "ANNOUNCEMENT_NOT_DRAFT": "Cette annonce n’est plus un brouillon, elle ne peut donc pas être modifiée. Dépubliez-la d’abord.",
      "ANNOUNCEMENT_NOT_PUBLISHED": "On ne peut faire expirer qu’une annonce publiée.",
      "MERCHANT_PATTERN_NOT_FOUND": "Ce motif de commerçant n’existe plus.",
      "INSTITUTION_REQUEST_NOT_FOUND": "Cette demande n’existe plus.",
      "MERCHANT_PATTERN_NOT_PROMOTABLE": "Ce motif ne peut pas encore être approuvé. Il ne passe pas tous les contrôles.",
      "MERCHANT_PATTERN_STATE": "Ce motif a changé, cette action est donc impossible.",
      "INSTITUTION_REQUEST_STATE": "Cette demande a déjà été traitée.",
      "INSTITUTION_EXISTS": "Une banque portant ce nom figure déjà au catalogue."
    }
  },
  "help": {
    "ariaLabel": "Aide pour {{label}}"
  },
  "tenants": {
    "pagination": {
      "previous": "Précédent",
      "next": "Suivant",
      "pageOf": "Page {{page, number}} sur {{total, number}}"
    },
    "create": {
      "title": "Créer un tenant",
      "slugLabel": "Slug",
      "slugHelper": "Lettres minuscules, chiffres, tirets — jusqu'à 63 caractères.",
      "slugRequired": "Le slug est obligatoire.",
      "slugInvalid": "Le slug doit être une étiquette DNS valide (minuscules, chiffres, tirets ; jusqu'à 63 caractères).",
      "nameLabel": "Nom",
      "nameRequired": "Le nom est obligatoire.",
      "nameTooLong": "Le nom doit comporter 200 caractères ou moins.",
      "signupModeLabel": "Mode d'inscription",
      "submitButton": "Créer",
      "submitting": "Création…",
      "cancelButton": "Annuler",
      "errorDuplicateSlug": "Ce slug est déjà enregistré. Choisissez-en un autre.",
      "errorGeneric": "Impossible de créer le tenant. Veuillez réessayer.",
      "resellerLabel": "Revendeur",
      "currencyLabel": "Devise",
      "resellerRequired": "Le revendeur est obligatoire.",
      "retrySafe": "Nous n'avons pas pu confirmer que le tenant a été entièrement créé. Vous pouvez réessayer sans risque.",
      "tryAgain": "Réessayer",
      "hasTenant": "Ce revendeur possède déjà un tenant.",
      "onePerReseller": "Chaque revendeur possède un tenant.",
      "billingNotProvisioned": "Le tenant a été créé, mais son encaissement n’est pas encore provisionné : {{reason}}. Ouvrez Configuration → Encaissement pour le provisionner."
    },
    "signupMode": {
      "PUBLIC": "Public",
      "INVITE_ONLY": "Sur invitation uniquement",
      "ADMIN_CREATED_ONLY": "Créé par admin uniquement",
      "DISABLED": "Désactivé"
    },
    "status": {
      "ACTIVE": "Actif",
      "INACTIVE": "Inactif",
      "SUSPENDED": "Suspendu"
    },
    "reseller": {
      "deactivated": "Ce revendeur est désactivé et ne peut pas recevoir de tenants. Choisissez-en un autre.",
      "suspended": "Ce revendeur est suspendu et ne peut pas recevoir de tenants."
    },
    "deleteNote": "Pour suspendre ou supprimer un tenant, adressez-vous à l'opérateur de la plateforme (saas-admin).",
    "sellable": {
      "chip": "Ne peut pas vendre",
      "noReseller": {
        "label": "Aucun revendeur",
        "body": "Ce tenant ne peut pas vendre tant qu’il n’appartient pas à un revendeur."
      },
      "noAgreement": {
        "label": "Aucun accord",
        "body": "Son revendeur n’a pas d’accord en vigueur."
      },
      "currencyNotPriced": {
        "label": "Devise non tarifée",
        "body": "La devise du tenant ({{currency}}) n’est pas celle de la grille tarifaire de son revendeur."
      },
      "unknown": {
        "label": "Ne peut pas vendre ({{code}})",
        "body": "Vérifiez le revendeur, l’accord, la devise et les offres de ce tenant."
      },
      "editTenant": "Modifier le tenant…",
      "noRateCard": {
        "label": "Aucune grille tarifaire",
        "body": "Ce tenant ne peut pas vendre tant que son revendeur n’active pas une grille tarifaire."
      },
      "openCustomerPrices": "Ouvrir la grille tarifaire"
    },
    "notPriced": {
      "currencyMessage": "La devise de ce tenant ({{currency}}) n’est pas tarifée par la grille de son revendeur.",
      "message": "Ce tenant ne peut pas encore vendre : son revendeur n'a pas d'accord.",
      "openAgreement": "Ouvrir l'accord de {{resellerName}}"
    },
    "edit": {
      "aiDefault": "IA activée par défaut",
      "button": "Modifier…",
      "currencyLabel": "Devise",
      "currencyLocked": "Verrouillée dès que le tenant a des abonnements",
      "error": "Impossible de mettre à jour le tenant.",
      "nameLabel": "Nom",
      "nameRequired": "Le nom est obligatoire (200 caractères au maximum).",
      "save": "Enregistrer",
      "signupModeLabel": "Mode d'inscription",
      "statusLabel": "Statut",
      "suspendConfirm": "Ses utilisateurs ne peuvent pas se connecter tant qu'il n'est pas réactivé.",
      "title": "Modifier le tenant"
    },
    "upstreamUnavailable": "Le service de connexion n’a pas répondu entièrement. Rien n’a été modifié — réessayez.",
    "statusFilter": {},
    "resellerFilter": {}
  },
  "tenant": {
    "tab": {
      "affiliates": "Affiliés"
    },
    "section": {}
  },
  "tenantDetail": {
    "notFound": "Tenant introuvable.",
    "identity": {
      "loadError": "Impossible de charger l'identité du tenant.",
      "created": "Créé le {{date}}",
      "status": {}
    },
    "members": {
      "help": "Qui administre ce tenant.",
      "removeConfirmBody": "Cela retire {{email}} du personnel de ce tenant. Son compte n'est pas supprimé.",
      "title": "Administrateurs du tenant",
      "tableAriaLabel": "Personnel du tenant",
      "col": {
        "email": "E-mail",
        "name": "Nom",
        "role": "Rôle",
        "status": "Statut",
        "actions": "Actions"
      },
      "role": {
        "OWNER": "Propriétaire",
        "SUPER_ADMIN": "Super Admin",
        "ADMIN": "Admin",
        "STAFF": "Personnel",
        "USER": "Utilisateur",
        "GUEST": "Invité"
      },
      "status": {
        "ACTIVE": "Actif",
        "INVITED": "Invité",
        "DISABLED": "Désactivé"
      },
      "loadError": "Impossible de charger le personnel.",
      "empty": "Aucun administrateur pour l'instant.",
      "changeRoleLabel": "Rôle pour {{email}}",
      "changeRoleError": "Impossible de changer le rôle. Veuillez réessayer.",
      "disableLabel": "Activé",
      "toggleStatusError": "Impossible de mettre à jour le statut du personnel. Veuillez réessayer.",
      "removeButton": "Retirer",
      "removeConfirmTitle": "Retirer le personnel ?",
      "removeError": "Impossible de retirer le personnel. Veuillez réessayer.",
      "lastOwnerProtected": "Cela supprimerait le dernier propriétaire du tenant.",
      "roleChangeCrossesTables": "Ce changement de rôle n'est pas autorisé pour ce membre du personnel.",
      "addTitle": "Ajouter un administrateur",
      "addEmailLabel": "E-mail",
      "addEmailRequired": "L'e-mail est obligatoire.",
      "addRoleLabel": "Rôle",
      "addButton": "Ajouter",
      "addSuccessMember": "Personnel ajouté.",
      "addSuccessInvitation": "Invitation envoyée.",
      "addErrorAlreadyActive": "Cette personne fait déjà partie du personnel actif.",
      "addErrorAlreadyPending": "Une invitation est déjà en attente pour cet e-mail.",
      "addError": "Impossible d'ajouter le personnel. Veuillez réessayer."
    },
    "customers": {
      "title": "Clients",
      "help": "Utilisateurs finaux de ce tenant. Les détails d'abonnement viendront du backend produit ultérieurement.",
      "tableAriaLabel": "Clients du tenant",
      "searchLabel": "Rechercher des utilisateurs",
      "col": {
        "email": "E-mail",
        "name": "Nom",
        "status": "Statut"
      },
      "loadError": "Impossible de charger les clients.",
      "empty": "Aucun client pour l'instant.",
      "emptySearch": "Aucun client ne correspond à votre recherche.",
      "pagination": {
        "pageOf": "Page {{page, number}} sur {{total, number}}"
      }
    },
    "invitations": {
      "title": "Invitations",
      "tableAriaLabel": "Invitations du tenant",
      "col": {
        "email": "E-mail",
        "role": "Rôle",
        "status": "Statut",
        "created": "Créée",
        "expires": "Expire",
        "actions": "Actions"
      },
      "statusAll": "Tout afficher",
      "status": {
        "PENDING": "En attente",
        "ACCEPTED": "Acceptée",
        "REVOKED": "Retirée",
        "EXPIRED": "Expirée"
      },
      "loadError": "Impossible de charger les invitations.",
      "empty": "Aucune invitation en attente.",
      "emptyAll": "Aucune invitation.",
      "resendButton": "Renvoyer",
      "resendError": "Impossible de renvoyer l'invitation. Veuillez réessayer.",
      "revokeButton": "Révoquer",
      "revokeConfirmTitle": "Révoquer l'invitation ?",
      "revokeConfirmBody": "Cela révoque l'invitation en attente à {{email}}. Elle ne pourra plus l'accepter.",
      "revokeError": "Impossible de révoquer l'invitation. Veuillez réessayer.",
      "alreadyAccepted": "Cette invitation a déjà été acceptée. La liste a été actualisée.",
      "notFound": "Cette invitation est introuvable. La liste a été actualisée."
    },
    "overview": {
      "period": "Période",
      "kpi": {
        "activeSubscribers": "Abonnés actifs",
        "trialing": "Essai",
        "comped": "Offerts",
        "guestSeats": "Sièges invités",
        "chargedSeats_one": "{{shown}} facturé",
        "chargedSeats_other": "{{shown}} facturés",
        "connectedAccounts": "Comptes connectés",
        "retail": "Détail",
        "tenantShare": "Part du tenant",
        "platformShare": "Part de la plateforme",
        "pendingPayout": "Versement en attente",
        "nextClose": "prochaine clôture {{date}}",
        "noData": "—"
      },
      "currency": "Devise",
      "aiDefault": "IA activée par défaut",
      "yes": "Oui",
      "no": "Non",
      "emailFromName": "Nom de l'expéditeur",
      "emailFromAddress": "Adresse de l'expéditeur",
      "emailSupportEmail": "E-mail du support"
    },
    "offers": {
      "tableAria": "Offres du tenant",
      "aiMarkupHelp": "Ce que le client paie au-delà du coût du fournisseur d’IA : notre marge combinée à celle du revendeur.",
      "col": {
        "id": "Offre",
        "status": "Statut",
        "retailBase": "Base détail",
        "seatBands": "Tranches de sièges",
        "aiMarkup": "Marge IA (total client)",
        "trial": "Essai (nouveau / invité)",
        "subscribers": "Abonnés",
        "created": "Créé",
        "closed": "Fermé",
        "rateCard": "Grille tarifaire"
      },
      "current": "Actuelle",
      "empty": "Pas encore d'offres.",
      "loadError": "Impossible de charger les offres.",
      "rateCardById": "Grille tarifaire {{id}}"
    },
    "promotions": {
      "tableAria": "Promotions du tenant",
      "col": {
        "code": "Code",
        "name": "Nom",
        "kind": "Type",
        "value": "Valeur",
        "valid": "Validité",
        "redemptions": "Utilisations",
        "status": "Statut",
        "newOnly": "Nouveaux abonnés uniquement"
      },
      "kind": {
        "OFFER": "Offre",
        "TRIAL_DAYS": "Jours d'essai",
        "PERCENT_OFF_VARIABLE": "Pourcentage de réduction",
        "AMOUNT_OFF_VARIABLE": "Montant de réduction"
      },
      "status": {
        "ACTIVE": "Active",
        "PAUSED": "En pause",
        "ENDED": "Terminée"
      },
      "empty": "Aucune promotion.",
      "loadError": "Impossible de charger les promotions."
    },
    "sections": {},
    "sectionTabs": {}
  },
  "resellers": {
    "loadError": "Impossible de charger les revendeurs.",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "statusFilter": {
      "label": "Statut",
      "all": "Tous",
      "active": "Actif",
      "suspended": "Suspendu"
    },
    "col": {
      "status": "Statut",
      "created": "Créé",
      "actions": "Actions",
      "standing": "Situation"
    },
    "role": {
      "OWNER": "Propriétaire",
      "ADMIN": "Administrateur",
      "STAFF": "Personnel"
    },
    "create": {
      "title": "Créer un revendeur",
      "slugLabel": "Slug",
      "slugHelper": "Lettres minuscules, chiffres, tirets — 63 caractères maximum.",
      "slugRequired": "Le slug est obligatoire.",
      "slugInvalid": "Le slug doit être une étiquette DNS valide (lettres minuscules, chiffres, tirets ; 63 caractères maximum).",
      "slugTaken": "Ce slug est déjà utilisé par un autre revendeur.",
      "nameLabel": "Nom",
      "nameRequired": "Le nom est obligatoire.",
      "nameTooLong": "Le nom doit comporter 200 caractères au maximum.",
      "submitButton": "Créer",
      "submitting": "Création…",
      "errorGeneric": "Impossible de créer le revendeur. Veuillez réessayer."
    },
    "detail": {
      "loadError": "Impossible de charger le revendeur."
    },
    "tab": {
      "agreement": "Accord"
    },
    "standing": {
      "GOOD": "Bonne",
      "PROBATION": "Probation",
      "DEACTIVATION_DUE": "Désactivation due",
      "DEACTIVATED": "Désactivé",
      "unknown": "Inconnu ({{state}})",
      "probationWindow": "Fenêtre de probation",
      "notEvaluated": "Pas encore évalué. Chaque mois depuis le lancement officiel est évalué le 2 du mois suivant.",
      "loadError": "Impossible de charger la situation.",
      "tableAria": "Situation par mois",
      "reactivated": "Réactivé le {{date}}. L’engagement minimum repart de cette date.",
      "saasAuthStatus": "Statut dans saas-auth",
      "saasAuthActive": "Actif",
      "saasAuthSuspended": "Suspendu",
      "saasAuthCaption": "Tel que tmm-api l’a vu en dernier.",
      "col": {
        "month": "Mois",
        "minimum": "Minimum",
        "earned": "Gagné",
        "shortfall": "Manque",
        "shortfallCharge": "Prélèvement du manque"
      },
      "officialLaunch": "Lancement officiel",
      "launchNotSet": "Non défini — aucun mois n’est évalué tant que l’accord n’en fixe pas un.",
      "launchNoneSet": "Aucun lancement officiel n’est fixé.",
      "openAgreement": "Ouvrir l’onglet Accord",
      "probationDeadline": "Échéance de la probation",
      "judgedOn": "Jugé le {{date}}",
      "nextNotice": "Prochain avis",
      "noNotice": "Aucun prévu",
      "notEvaluatedNoLaunch": "Non évalué : il n’y a pas encore de lancement officiel.",
      "viewCharge": "Voir le prélèvement",
      "viewChargeAria": "Voir le prélèvement de {{month}}",
      "endProbation": {
        "button": "Mettre fin à la probation…",
        "title": "Mettre fin à la probation de {{name}} ?",
        "body": "Met fin à la probation maintenant. Le revendeur reçoit un e-mail indiquant qu’il s’est rétabli.",
        "confirm": "Mettre fin à la probation",
        "done": "Probation terminée. Le revendeur est en bonne situation.",
        "conflict": "Ce revendeur n’est plus en probation : il n’y avait rien à terminer. L’écran a été rechargé.",
        "error": "Impossible de mettre fin à la probation."
      }
    },
    "deactivate": {
      "title": "Désactiver le partenaire",
      "confirm": "Désactiver {{from}} ?",
      "submit": "Désactiver",
      "error": "Impossible de désactiver le partenaire.",
      "consequence": "La désactivation suspend les administrateurs de ce partenaire et confie sa gestion à la plateforme. Son tenant continue de vendre. La plateforme conserve les règlements (aucun versement) jusqu’à sa réactivation."
    },
    "reactivate": {
      "button": "Réactiver…",
      "title": "Réactiver {{name}} ?",
      "body": "La réactivation rétablit l’accès des administrateurs de ce partenaire et reprend les versements à partir du prochain règlement. Les règlements déjà retenus le restent.",
      "reason": "Motif",
      "counter_one": "{{count, number}}/{{max, number}}",
      "counter_other": "{{count, number}}/{{max, number}}",
      "confirm": "Réactiver",
      "done": "{{name}} est de nouveau actif.",
      "error": "Impossible de réactiver le revendeur.",
      "conflict": "La réactivation a été refusée car le statut de ce revendeur a changé. L’écran a été rechargé.",
      "notDeactivated": "Ce partenaire n’est pas désactivé. Utilisez Réactiver dans le contrôle de statut pour lever une suspension ordinaire."
    },
    "overview": {
      "updated": "Mis à jour",
      "brand": "Marque",
      "visibility": "Visibilité",
      "ownBrand": "A sa propre marque",
      "productBrand": "Pas de marque propre — ses tenants utilisent la marque du produit.",
      "renameHelper": "La marque du revendeur prend le nouveau nom sauf si elle a été personnalisée.",
      "suspend": "Suspendre",
      "suspendTitle": "Suspendre {{name}} ?",
      "suspendBody": "Ses utilisateurs ne peuvent pas se connecter. Ses tenants continuent de fonctionner.",
      "reactivate": "Réactiver",
      "reactivateTitle": "Réactiver {{name}} ?",
      "reactivateBody": "Ses utilisateurs peuvent de nouveau se connecter.",
      "statusError": "Impossible de changer le statut du revendeur.",
      "statusStandingConflict": "Ce revendeur est désactivé : son statut ne peut pas être changé ici. Utilisez Réactiver… pour le rétablir. L’écran a été rechargé.",
      "delete": "Supprimer…",
      "deleteTitle": "Supprimer {{name}} ?",
      "deleteBody": "Cela supprime le revendeur et sa marque. Cette action est irréversible.",
      "deleteConfirm": "Supprimer",
      "deleteError": "Impossible de supprimer le revendeur.",
      "deactivate": "Désactiver…",
      "deactivationDue": "Ce partenaire n’a pas atteint son minimum pendant la période probatoire. Conservez-le et réexaminez le mois prochain, ou désactivez-le pour que la plateforme le gère sur place.",
      "deactivated": "Ce partenaire est désactivé. Ses administrateurs ne peuvent pas se connecter ; son tenant continue de vendre.",
      "takeoverReactivate": "Ce partenaire peut être réactivé pendant la reprise en main.",
      "deactivatedButActive": "Actif dans saas-auth, donc ses utilisateurs pourraient se connecter. Réactivez-le ici, ou demandez à l’opérateur de la plateforme de le suspendre à nouveau dans saas-admin.",
      "createBrand": "Créer la marque",
      "brandCreated": "Marque créée.",
      "brandCreateError": "Impossible de créer la marque.",
      "brandEditedIn": "La marque se modifie dans saas-admin.",
      "keep": {
        "button": "Garder ce revendeur…",
        "title": "Garder {{name}} ?",
        "body": "Retire le signalement de désactivation. Ses prélèvements de manque restent ouverts.",
        "reason": "Motif",
        "counter_one": "{{count, number}}/{{max, number}}",
        "counter_other": "{{count, number}}/{{max, number}}",
        "confirm": "Garder ce revendeur",
        "done": "Gardé. Le signalement de désactivation est retiré ; ses prélèvements de manque restent ouverts.",
        "error": "Impossible de garder le revendeur.",
        "conflict": "Ce revendeur n’est plus à désactiver : il n’y avait rien à retirer. L’écran a été rechargé.",
        "suspended": "Ce revendeur est suspendu dans saas-auth : lever l’alerte ne suffit pas. Utilisez plutôt Réactiver…"
      },
      "brandNoProductDefault": "Le produit n’a pas de marque par défaut à copier. Définissez-en une dans saas-admin, puis réessayez.",
      "brandSlugFailed": "Impossible de générer un nom pour la nouvelle marque. Réessayez.",
      "probation": "Ce revendeur est en probation pour avoir manqué son minimum. Mettez fin à la probation s’il s’est rétabli.",
      "details": "Détails",
      "card": {
        "standing": "Situation",
        "latestSettlement": "Dernier règlement",
        "none": "Aucun",
        "loadError": "Impossible de charger ceci.",
        "meaning": {
          "GOOD": "Il respecte son minimum.",
          "PROBATION": "Il a manqué son minimum et est en probation.",
          "DEACTIVATION_DUE": "Il a manqué son minimum pendant toute la probation.",
          "DEACTIVATED": "Ses administrateurs perdent l’accès ; son tenant continue de vendre."
        },
        "affiliateAssigned": "{{plans, number}} plans · {{affiliates, number}} affiliés assignés"
      }
    },
    "users": {
      "searchLabel": "Rechercher des utilisateurs",
      "invite": "Inviter un administrateur…",
      "inviteTitle": "Inviter un administrateur",
      "inviteSubmit": "Envoyer l’invitation",
      "emailLabel": "E-mail",
      "roleLabel": "Rôle",
      "emailRequired": "L’e-mail est obligatoire.",
      "invited": "Invitation envoyée.",
      "inviteError": "Impossible d’envoyer l’invitation.",
      "noConsole": "tmm n’a pas encore de console revendeur : les utilisateurs revendeurs ne peuvent donc pas être invités. L’opérateur de la plateforme la configure dans saas-admin.",
      "loadError": "Impossible de charger les utilisateurs.",
      "tableAriaLabel": "Utilisateurs du revendeur",
      "empty": "Aucun utilisateur pour le moment.",
      "col": {
        "email": "E-mail",
        "name": "Nom",
        "role": "Rôle",
        "status": "Statut",
        "mfa": "MFA",
        "password": "Mot de passe"
      },
      "roleFor": "Rôle de {{email}}",
      "roleError": "Impossible de changer le rôle.",
      "mfaOn": "MFA",
      "passwordSet": "Mot de passe",
      "suspend": "Suspendre",
      "reactivate": "Réactiver",
      "statusError": "Impossible de changer le statut.",
      "remove": "Retirer",
      "removeTitle": "Retirer l’utilisateur ?",
      "removeBody": "Cela retire {{email}} de ce revendeur, avec son mot de passe et ses sessions.",
      "removeError": "Impossible de retirer l’utilisateur."
    },
    "invitations": {
      "tableAriaLabel": "Invitations du revendeur"
    },
    "ghl": {
      "title": "Connexion GHL",
      "notConnected": "Non connecté",
      "connect": "Connecter…",
      "connectTitle": "Connecter GHL",
      "edit": "Modifier…",
      "editTitle": "Modifier la connexion GHL",
      "disconnect": "Déconnecter…",
      "disconnectTitle": "Déconnecter GHL ?",
      "disconnectBody": "Cela supprime la connexion GHL du revendeur et son jeton enregistré.",
      "disconnectConfirm": "Déconnecter",
      "disconnected": "Déconnecté.",
      "disconnectError": "Impossible de déconnecter.",
      "loadError": "Impossible de charger la connexion GHL.",
      "locationId": "Id de l’emplacement",
      "locationClaimed": "Cet emplacement est déjà connecté ailleurs.",
      "locationRule": "1 à 64 lettres, chiffres, '_' ou '-'. Laissez vide pour aucun emplacement.",
      "locationNotVerified": "Ce jeton ne peut pas lire cet emplacement — vérifiez l’id de l’emplacement et les autorisations du jeton.",
      "token": "Jeton d’intégration privée",
      "tokenNotSet": "Non défini",
      "tokenHelper": "Laissez vide pour conserver le jeton actuel",
      "active": "Active",
      "yes": "Oui",
      "no": "Non",
      "saved": "Connexion GHL enregistrée.",
      "saveError": "Impossible d’enregistrer la connexion.",
      "diagnose": {
        "button": "Diagnostiquer",
        "running": "Diagnostic en cours",
        "wait": "Vérification de GHL — cela peut prendre quelques secondes.",
        "error": "Impossible d’exécuter le diagnostic.",
        "title": "Diagnostic",
        "unknown": "GoHighLevel a renvoyé un résultat que cette console ne reconnaît pas.",
        "copyDetails": "Copier les détails pour le support",
        "interpretation": {
          "HEALTHY": "Sain",
          "LIKELY_MISSING_SCOPE": "Autorisation manquante",
          "LIKELY_CREDENTIAL_CORRUPT": "Jeton endommagé",
          "LIKELY_CREDENTIAL_INVALID": "Jeton refusé",
          "UPSTREAM_UNAVAILABLE": "GHL indisponible",
          "INDETERMINATE": "Aucun schéma clair"
        },
        "hint": {
          "HEALTHY": "Les deux vérifications ont réussi.",
          "LIKELY_MISSING_SCOPE": "Il manque au jeton une autorisation dont GHL a besoin.",
          "LIKELY_CREDENTIAL_CORRUPT": "Le jeton enregistré semble endommagé — définissez-le à nouveau.",
          "LIKELY_CREDENTIAL_INVALID": "GHL a refusé le jeton — remplacez-le.",
          "UPSTREAM_UNAVAILABLE": "GHL n’a pas répondu — réessayez plus tard.",
          "INDETERMINATE": "Les vérifications ne correspondent à aucun schéma connu — voir les résultats ci-dessous."
        },
        "contacts": "Contacts",
        "customFields": "Champs personnalisés",
        "check": "Vérification",
        "result": "Résultat",
        "ok": "OK",
        "failed": "Échec"
      },
      "saveWait": "Vérification du jeton auprès de GHL — cela peut prendre jusqu’à 30 secondes.",
      "connectionName": "la connexion GHL"
    },
    "agreement": {
      "dialog": {
        "takesEffectNow": "Elle prend effet maintenant.",
        "confirm": "Démarrer une nouvelle version met fin à l'accord actuel et recalcule le prix de chaque tenant de {{reseller}}. Les abonnés conservent l'offre qu'ils ont achetée.",
        "confirmSubmit": "Démarrer la version",
        "connectTenant": "Tenant Connect",
        "createTitle": "Créer un accord",
        "minPayout": "Versement minimum",
        "monthlyMinimum": "Minimum mensuel",
        "newTitle": "Nouvelle version de l'accord",
        "notes": "Notes",
        "probation": "Mois de probation",
        "officialLaunch": "Lancement officiel",
        "launchSetHelp": "Ne peut pas être retiré une fois fixé. Vous pouvez le déplacer à un autre mois.",
        "launchUnsetHelp": "Le 1er du mois choisi. Aucun mois n’est évalué tant qu’il n’est pas fixé.",
        "launchKeep": "{{month}} (actuel)",
        "launchNotSet": "Non défini",
        "launchConfirm": "Le lancement officiel devient {{month}}. Il ne peut pas être retiré une fois fixé.",
        "currency": "Devise"
      },
      "by": "Par",
      "cadence": {
        "MONTHLY": "Mensuel",
        "WEEKLY": "Hebdomadaire"
      },
      "cadenceLabel": "Cadence de versement",
      "col": {
        "cadence": "Cadence",
        "effectiveFrom": "En vigueur depuis",
        "ended": "Terminé",
        "method": "Méthode",
        "monthlyMin": "Minimum mensuel",
        "officialLaunch": "Lancement officiel",
        "currency": "Devise"
      },
      "connectTenant": "Tenant Connect",
      "create": "Créer un accord…",
      "current": "Accord actuel",
      "effectiveFrom": "En vigueur depuis",
      "error": "Impossible de démarrer l'accord.",
      "history": "Historique",
      "historyAria": "Historique de l'accord",
      "historyEmpty": "Aucune version précédente.",
      "loadError": "Impossible de charger l'accord.",
      "methodLabel": "Méthode de versement",
      "minPayout": "Versement minimum",
      "monthlyMinimum": "Minimum mensuel",
      "newVersion": "Nouvelle version…",
      "none": "Aucun accord. Les tenants de ce revendeur ne peuvent pas vendre tant qu'il n'en existe pas.",
      "notes": "Notes",
      "payoutAccount": "Compte de versement",
      "probation": "Mois de probation",
      "probationHint": "Un mois sous le minimum ouvre une probation ; tmm signale le revendeur pour désactivation s'il ne se rétablit pas.",
      "probationInvalid": "Doit être supérieur ou égal à zéro.",
      "taxDocs": {
        "COLLECTED": "Collecté",
        "NOT_REQUIRED": "Non requis",
        "PENDING": "En attente"
      },
      "taxDocsLabel": "Documents fiscaux",
      "taxIdLabel": "Identifiant fiscal",
      "taxIdCurrent": "Identifiant fiscal du partenaire dans pay-api",
      "taxId": {
        "MISMATCH": "Non concordant",
        "NOT_REQUIRED": "Non requis",
        "PENDING": "En attente",
        "VERIFIED": "Vérifié"
      },
      "officialLaunch": "Lancement officiel",
      "launchNotSet": "Non défini",
      "launchNotSetLong": "Non défini — aucun mois n’est évalué tant qu’il n’est pas fixé.",
      "page": {
        "startVersion": "Démarrer une nouvelle version",
        "create": "Créer l’accord"
      },
      "section": {
        "pricing": "Tarification et lancement",
        "payouts": "Versements",
        "minimum": "Minimum mensuel"
      },
      "preview": {
        "minPayout": "Payé à partir de {{amount}}",
        "monthlyMinimum": "Au moins {{amount}} par mois"
      },
      "started": "Version de l’accord démarrée pour {{reseller}}.",
      "currencyHelp": "Par défaut, la devise de la grille tarifaire adoptée.",
      "versionFrom": "Accord depuis le {{date}}",
      "currency": "Devise",
      "currencyNotChosen": "Non choisie",
      "currencyNoAdoption": "Ce revendeur n’a adopté aucune grille tarifaire : choisissez la devise."
    },
    "settlements": {
      "filter": {
        "currency": "Devise",
        "allCurrencies": "Toutes",
        "from": "Du",
        "to": "Au",
        "status": "Statut",
        "allStatuses": "Tous"
      },
      "loadError": "Impossible de charger les règlements.",
      "tableAria": "Règlements",
      "col": {
        "month": "Mois",
        "currency": "Devise",
        "margin": "Marge",
        "affiliates": "Affiliés",
        "net": "Net",
        "outcome": "Résultat",
        "actions": "Actions"
      },
      "empty": "Aucun règlement.",
      "emptyBody": "Chaque mois est clôturé le 2 du mois suivant, un règlement par devise.",
      "expand": "Déplier {{month}}",
      "collapse": "Replier {{month}}",
      "recordAria": "Enregistrer le versement… pour {{month}} {{currency}}",
      "outcome": {
        "PAID": "Payé le {{date}}",
        "PENDING": "À payer",
        "CARRIED": "Reporté (sous le minimum)",
        "CHARGED": "Prélevé sur la carte",
        "RETAINED": "Conservé"
      },
      "viewChargeAria": "Voir le prélèvement de {{month}} {{currency}}",
      "byLineAria": "Règlement par ligne",
      "byLine": {
        "line": "Ligne",
        "retail": "Détail",
        "wholesale": "Gros",
        "margin": "Marge",
        "affiliates": "Affiliés",
        "aiAtOurPrice": "IA à notre prix"
      },
      "events": {
        "aria": "Primes de parrainage et paliers d’affilié",
        "line": "Ligne",
        "amount": "Montant",
        "bounties": "Primes de parrainage d’affilié",
        "milestones": "Paliers d’affilié",
        "recovered": "Reprises récupérées"
      },
      "retainedTooltip": "Conservé par la plateforme pendant qu’elle gère ce partenaire ; aucun versement.",
      "retainedPart": "Retenu {{amount}}",
      "normalPart": "À payer {{amount}}"
    },
    "notices": {
      "sent": "Avis envoyés",
      "filter": {
        "kind": "Type",
        "allKinds": "Tous les types"
      },
      "tableAria": "Avis",
      "col": {
        "when": "Envoyé / créé",
        "kind": "Type",
        "period": "Période",
        "status": "Statut",
        "recipients": "Destinataires"
      },
      "loadError": "Impossible de charger les avis.",
      "empty": "Aucun avis pour le moment.",
      "emptyFiltered": "Aucun avis ne correspond à ce filtre.",
      "expand": "Déplier {{kind}}, {{period}}",
      "collapse": "Replier {{kind}}, {{period}}",
      "created": "Créé, non envoyé",
      "recipients": "{{n, number}} destinataires",
      "factsAria": "Faits : {{kind}}, {{period}}",
      "chargesAria": "Prélèvements de cet avis",
      "kind": {
        "LAUNCH_REMINDER": "Rappel de lancement",
        "PROBATION_STARTED": "Période probatoire commencée",
        "PROBATION_MONTHLY": "Point sur la période probatoire",
        "CHARGE_FAILED": "Prélèvement échoué",
        "CHARGE_ACTION_REQUIRED": "Le prélèvement demande une action",
        "DEACTIVATED": "Désactivé",
        "RECOVERED": "Rétabli"
      },
      "status": {
        "PENDING": "En attente",
        "SENDING": "Envoi en cours",
        "SENT": "Envoyé",
        "SKIPPED": "Ignoré",
        "FAILED": "Échoué"
      },
      "statusHint": {
        "PENDING": "Pas encore envoyé. Le moteur d'avis l'envoie dans l'heure.",
        "SKIPPED": "Non envoyé : messagerie non configurée, aucun destinataire, ou plus nécessaire"
      },
      "fact": {
        "month": "Mois",
        "currency": "Devise",
        "shortfall": "Manque",
        "probationMonths": "Mois de période probatoire",
        "target": "Minimum de la période probatoire",
        "earned": "Gagné jusqu'ici",
        "stillNeeded": "Encore nécessaire",
        "deactivationOn": "Date de désactivation",
        "launchOn": "Lancement officiel",
        "toReseller": "Tenants déplacés vers",
        "tenantsMoved": "Tenants déplacés"
      },
      "charge": {
        "kind": "Prélèvement",
        "amount": "Montant",
        "status": "Statut",
        "holdOn": "Bloque les versements dès le"
      }
    },
    "section": {},
    "sectionCaption": {},
    "actions": {}
  },
  "dashboard": {
    "tabs": {
      "aria": "Sections du tableau de bord",
      "trends": "Tendances",
      "tenants": "Tenants",
      "resellers": "Revendeurs"
    },
    "period": {
      "label": "Période",
      "THIS_MONTH": "Ce mois-ci",
      "LAST_30_DAYS": "30 derniers jours",
      "LAST_MONTH": "Mois dernier"
    },
    "loadError": "Impossible de charger le tableau de bord de la flotte.",
    "kpi": {
      "activeSubscribers": "Abonnés actifs",
      "acrossTenants_one": "sur {{count, number}} tenant",
      "acrossTenants_other": "sur {{count, number}} tenants",
      "trialing": "En période d'essai",
      "newAndChurned": "{{new}} nouveaux · {{churned}} résiliés",
      "retailCollected": "Encaissé au détail",
      "beforeShares": "avant les parts des tenants",
      "platformShare": "Part de la plateforme",
      "reachedUs": "ce qui nous est parvenu",
      "pendingPayouts": "Versements en attente",
      "paidInPeriod": "{{paid}} versés sur la période",
      "addonsActive": "Modules complémentaires actifs",
      "connectedAccounts": "Comptes connectés",
      "guestSeats": "Sièges des invités",
      "tenantShare": "Part du tenant",
      "uplift": "Majoration",
      "wholesale": "Gros"
    },
    "chart": {
      "retailTitle": "Détail par tenant",
      "subscribersTitle": "Abonnés actifs, par jour",
      "subscribersAria": "Abonnés actifs, par jour",
      "empty": "Aucune activité sur cette période.",
      "retailAriaCurrency": "Détail par tenant en {{currency}}, du {{from}} au {{to}}",
      "retailTitleCurrency": "Détail par tenant · {{currency}}"
    },
    "fleet": {
      "subtitle": "Détail : ce que les abonnés ont payé. Plateforme : ce que nous conservons après la part du tenant.",
      "tableAria": "Flotte par tenant",
      "col": {
        "tenant": "Tenant",
        "subscribers": "Abonnés",
        "new": "Nouveaux",
        "churned": "Résiliés",
        "retail": "Détail",
        "wholesale": "Gros",
        "uplift": "Majoration",
        "tenantShare": "Part du tenant",
        "platform": "Plateforme",
        "nextClose": "Prochaine clôture"
      },
      "totalsInCurrency": "Totaux en {{currency}}",
      "empty": "Aucun tenant pour l'instant."
    },
    "standing": {
      "deactivationDue_one": "{{count, number}} revendeur a manqué son minimum pendant la probation et est dû pour désactivation.",
      "deactivationDue_other": "{{count, number}} revendeurs ont manqué leur minimum pendant la probation et sont dus pour désactivation."
    },
    "byReseller": {
      "col": {
        "platform": "Part de la plateforme",
        "reseller": "Revendeur",
        "retail": "Détail",
        "subscribers": "Abonnés actifs",
        "tenants": "Tenants"
      },
      "noReseller": "Aucun revendeur",
      "tableAria": "Flotte par revendeur",
      "title": "Par revendeur"
    },
    "affiliateBonuses": {
      "title": "Primes d’affilié",
      "tableAria": "Primes d’affilié par revendeur",
      "col": {
        "reseller": "Revendeur",
        "currency": "Devise",
        "bounties": "Primes de parrainage",
        "milestones": "Paliers"
      }
    },
    "resellerFilter": {
      "all": "Tous"
    },
    "unpaidCharges": {
      "title": "Prélèvements revendeurs impayés :",
      "item_one": "{{shown}} · {{amount}}",
      "item_other": "{{shown}} · {{amount}}"
    },
    "retainedMargin": {
      "title": "Marge conservée",
      "absorbed": "Absorbé par la plateforme."
    }
  },
  "rateCards": {
    "status": {
      "DRAFT": "Brouillon",
      "ACTIVE": "Active",
      "CLOSED": "Clôturée"
    },
    "ai": "IA",
    "actions": {
      "activate": "Activer",
      "close": "Clôturer",
      "copy": "Copier"
    },
    "form": {
      "name": "Nom",
      "currency": "Devise",
      "trialNew": "Jours d'essai — nouvel abonné",
      "trialGuest": "Jours d'essai — conversion d'invité",
      "nonNegative": "Doit être zéro ou plus.",
      "section": {
        "trials": "Essais"
      }
    },
    "help": {
      "trialNew": {
        "short": "Jours gratuits avant le premier prélèvement pour une personne qui s’abonne directement. 0 = paie dès le premier jour."
      },
      "trialGuest": {
        "short": "Jours gratuits pour un invité qui devient abonné."
      },
      "aiFirstPurchase": {
        "short": "Ce qu’une personne paie la première fois qu’elle active l’IA. Cela active l’IA."
      },
      "aiRechargeTrigger": {
        "short": "Quand le solde IA passe sous ce montant, la carte de l’abonné est débitée du montant de la recharge."
      },
      "aiRechargeAmount": {
        "short": "Ce que facture une recharge automatique. C’est aussi la plus petite recharge manuelle."
      }
    }
  },
  "subscription": {
    "status": {
      "ACTIVE": "Active",
      "TRIALING": "Essai",
      "CANCELLED": "Annulée",
      "ENDING": "Se termine",
      "ENDED": "Terminée",
      "PAST_DUE": "En retard",
      "COMPED": "Offerte"
    }
  },
  "subscriptions": {
    "tabs": {
      "aria": "Sections des abonnements",
      "subscriptions": "Abonnements",
      "pending": "En attente",
      "count": "{{label}} ({{count, number}})"
    },
    "tableAria": "Abonnements du tenant",
    "loadError": "Impossible de charger les abonnements.",
    "empty": "Aucun abonnement.",
    "statusFilter": "Statut",
    "statusAll": "Tous",
    "emailFilter": "E-mail",
    "subscribe": "Abonner",
    "view": "Voir",
    "offerCurrent": "actuelle",
    "col": {
      "email": "E-mail",
      "name": "Nom",
      "status": "Statut",
      "origin": "Origine",
      "offer": "Offre",
      "period": "Période",
      "nextBilling": "Prochaine facturation",
      "card": "Carte",
      "actions": "Actions"
    },
    "origin": {
      "SELF": "Soi-même",
      "ADMIN": "Admin",
      "COMP": "Offert"
    },
    "pending": {
      "title": "Abonnements admin en attente",
      "empty": "Aucun abonnement en attente.",
      "email": "E-mail",
      "status": "Statut",
      "offer": "Offre",
      "trialDays": "Jours d'essai",
      "comp": "Offert jusqu'au {{compedUntil}}",
      "compLabel": "Offert",
      "createdBy": "Créé par",
      "expires": "Expire"
    },
    "pendingStatus": {
      "PENDING": "En attente",
      "COMPLETED": "Finalisé",
      "EXPIRED": "Expiré",
      "CANCELLED": "Annulé"
    },
    "subscribed": {
      "pending": "Invitation envoyée ; l'abonnement commence lorsque {{email}} termine l'inscription.",
      "created": "Abonnement créé."
    },
    "subscribeDialog": {
      "title": "Abonner",
      "email": "E-mail",
      "emailRequired": "L'e-mail est obligatoire.",
      "emailInvalid": "Saisissez un e-mail valide.",
      "trialDays": "Jours d'essai",
      "trialInvalid": "Doit être zéro ou plus.",
      "comp": "Offert",
      "until": "Offert jusqu'au",
      "submit": "Abonner",
      "cancel": "Annuler"
    },
    "detail": {
      "title": "Abonnement",
      "entitlements": "Droits",
      "statements": "Relevés",
      "payApi": "pay-api",
      "noPayApi": "Aucun enregistrement pay-api",
      "close": "Fermer",
      "loadError": "Impossible de charger cet abonnement."
    },
    "entitlement": {
      "kind": "Type",
      "status": "Statut",
      "startsAt": "Début",
      "endsAt": "Fin",
      "sponsor": "Parrain"
    },
    "field": {
      "id": "Id",
      "userId": "Id utilisateur",
      "email": "E-mail",
      "displayName": "Nom",
      "status": "Statut",
      "origin": "Origine",
      "retailOfferId": "Offre",
      "promotion": "Promotion",
      "trialEndsOn": "Fin d'essai",
      "compedUntil": "Offert jusqu'au",
      "currentPeriodStart": "Début de période",
      "currentPeriodEnd": "Fin de période",
      "nextBillingOn": "Prochaine facturation",
      "cardBrand": "Marque de carte",
      "maskedCard": "Carte masquée",
      "payApiSubscriptionId": "Id pay-api",
      "reconciledAt": "Rapprochement",
      "createdBy": "Créé par",
      "createdAt": "Créé",
      "updatedAt": "Mis à jour"
    },
    "payApi": {
      "subscriptionId": "Id",
      "status": "Statut",
      "planMappingId": "Correspondance de plan",
      "contactRef": "Contact",
      "verticalRef": "Verticale",
      "createdAt": "Créé",
      "nextBillingOn": "Prochaine facturation",
      "pauseEffectiveOn": "Pause effective",
      "cardBrand": "Marque de carte",
      "maskedCard": "Carte masquée",
      "pspSubscriptionId": "Id PSP"
    },
    "actions": {
      "cancel": "Annuler…",
      "changeOffer": "Changer d'offre…",
      "comp": "Offrir…",
      "applyPromotion": "Appliquer une promotion…",
      "endPromotion": "Terminer la promotion",
      "aiSuspension": "Suspension IA",
      "moveToCurrent": "Déplacer vers la version actuelle…"
    },
    "move": {
      "title": "Déplacer vers la version actuelle ?",
      "consequence": "{{subscriber}} passe à {{card}} v{{version, number}} (la version actuelle). Un avis est envoyé. Si cette personne y est déjà, rien ne change.",
      "confirm": "Déplacer",
      "moved": "Déplacé vers la v{{version, number}}. Un avis a été envoyé.",
      "already": "Déjà sur la version actuelle. Rien n'a changé.",
      "failed": "Le déplacement n'a pas abouti. Réessayez ; vous pouvez le refaire sans risque.",
      "error": "Impossible de déplacer cet abonnement."
    },
    "cancel": {
      "title": "Annuler l'abonnement",
      "titleNamed": "Annuler l'abonnement de {{subscriber}} ?",
      "mode": "Mode",
      "at_period_end": "À la fin de la période",
      "immediate": "Immédiat",
      "confirm": "Annuler l'abonnement",
      "resultStatus": "Statut",
      "endsAt": "Se termine le",
      "error": "Impossible d’annuler l’abonnement.",
      "keep": "Conserver l'abonnement",
      "consequence": {
        "at_period_end": "Il ne sera pas renouvelé. L'abonné garde l'accès jusqu'à la fin de la période en cours.",
        "immediate": "L'abonné perd l'accès immédiatement, et un relevé et un prélèvement finaux peuvent suivre."
      }
    },
    "changeOffer": {
      "title": "Changer d'offre",
      "offer": "Offre",
      "offerN": "Offre {{id}}",
      "submit": "Changer",
      "none": "Aucune offre ne peut être choisie pour le moment.",
      "unselectable_one": "{{count, number}} offre ne peut pas être choisie",
      "unselectable_other": "{{count, number}} offres ne peuvent pas être choisies",
      "reasonNotActive": "{{name}} : sa grille tarifaire n’est pas active.",
      "closed": "{{name}} : cette version de l’offre est fermée.",
      "unexplained": "{{name}} ne peut pas être choisi pour le moment.",
      "loadError": "Impossible de charger les offres.",
      "offerInactive": "Cette offre n’est plus active. Choisissez-en une autre.",
      "error": "Impossible de changer l’offre."
    },
    "comp": {
      "title": "Offrir l'abonnement",
      "until": "Jusqu'au",
      "submit": "Offrir",
      "error": "Impossible d’offrir l’abonnement."
    },
    "promotion": {
      "applyTitle": "Appliquer une promotion",
      "code": "Code",
      "codeRequired": "Le code est obligatoire.",
      "apply": "Appliquer",
      "endTitle": "Terminer la promotion",
      "codeName": "{{code}} · {{name}}",
      "termsPercent": "{{pct}} de remise sur l’usage",
      "termsAmount": "{{amount}} de remise sur l’usage par relevé",
      "termsOffer": "Prix de l’offre promotionnelle",
      "statementsLeft_one": "{{count, number}} relevé restant",
      "statementsLeft_other": "{{count, number}} relevés restants",
      "untilEnded": "Jusqu’à ce qu’elle soit terminée",
      "appliedOn": "Appliquée le {{date}}",
      "endBodyVariable": "Terminer {{code}} pour {{subscriber}} ? La remise s’arrête à partir du prochain relevé. Les relevés déjà émis la conservent. Vous pouvez appliquer de nouveau le code plus tard tant qu’il est valide.",
      "endBodyOffer": "Terminer {{code}} pour {{subscriber}} ? Son prix ne change pas. Cela vous permet d’appliquer un autre code.",
      "endConfirm": "Terminer la promotion",
      "error": "Impossible d’appliquer la promotion.",
      "endError": "Impossible de terminer la promotion.",
      "endKeep": "Conserver la promotion"
    },
    "ai": {
      "title": "Suspension IA",
      "suspended": "IA suspendue par la plateforme",
      "reason": "Motif",
      "reasonRequired": "Le motif est obligatoire.",
      "confirm": "Confirmer",
      "error": "Impossible de modifier la suspension de l’IA."
    },
    "emailHint": "Recherche par e-mail",
    "subscribeError": "Impossible de créer l’abonnement."
  },
  "statements": {
    "tableAria": "Relevés du tenant",
    "copyDetailsAria": "Copier les détails pour le support du relevé {{id, number}}",
    "loadError": "Impossible de charger les relevés.",
    "empty": "Aucun relevé.",
    "periodFilter": "Période",
    "periodInvalid": "Utilisez AAAA-MM.",
    "statusFilter": "Statut",
    "statusAll": "Tous",
    "expand": "Développer les lignes",
    "collapse": "Replier les lignes",
    "retry": "Réessayer",
    "waive": "Exonérer…",
    "col": {
      "period": "Période",
      "status": "Statut",
      "renewal": "Renouvellement",
      "seats": "Sièges",
      "tax": "Taxe",
      "total": "Total",
      "attempts": "Tentatives",
      "actions": "Actions"
    },
    "lines": {
      "kind": "Type",
      "description": "Description",
      "quantity": "Quantité",
      "unit": "Unité",
      "amount": "Montant",
      "reference": "Référence"
    },
    "kind": {
      "RENEWAL": "Renouvellement",
      "SEAT": "Siège",
      "AI": "IA",
      "PROMOTION": "Promotion",
      "TAX": "Taxe",
      "CONNECTED": "Comptes connectés"
    },
    "chargeStatus": {
      "NONE": "Aucun",
      "PENDING": "En attente",
      "PAID": "Payé",
      "ACTION_REQUIRED": "Action requise",
      "FAILED": "Échoué",
      "ATTENTION": "Attention",
      "WAIVED": "Exonéré"
    },
    "waiveDialog": {
      "title": "Exonérer le relevé",
      "reason": "Motif",
      "reasonRequired": "Le motif est obligatoire.",
      "submit": "Exonérer"
    },
    "retryError": "Impossible de relancer le relevé.",
    "waiveError": "Impossible d’exonérer le relevé."
  },
  "seats": {
    "tableAria": "Sièges du tenant",
    "loadError": "Impossible de charger les sièges.",
    "empty": "Aucun siège invité.",
    "sponsorFilter": "Id du parrain",
    "col": {
      "guest": "Invité",
      "sponsor": "Parrain",
      "status": "Statut",
      "since": "Depuis",
      "ends": "Fin"
    },
    "status": {
      "ACTIVE": "Actif",
      "ENDING": "Se termine",
      "ENDED": "Terminé"
    }
  },
  "revenue": {
    "empty": "Aucun revenu sur cette période.",
    "loadError": "Impossible de charger les revenus.",
    "tableAria": "Revenus par tenant",
    "breakdownAria": "Revenus par type de ligne",
    "expand": "Développer les types de ligne",
    "collapse": "Réduire les types de ligne",
    "kpi": {
      "retail": "Détail",
      "wholesale": "Gros (notre prix)",
      "tax": "Taxe",
      "refunds": "Remboursements",
      "resellerMargin": "Marge du revendeur",
      "resellerNet": "Net du revendeur"
    },
    "col": {
      "tenant": "Tenant",
      "retail": "Détail",
      "wholesale": "Gros (notre prix)",
      "tax": "Taxe",
      "refunds": "Remboursements",
      "line": "Ligne",
      "resellerMargin": "Marge du revendeur",
      "resellerNet": "Net du revendeur (après affiliés)"
    },
    "line": {
      "BASE": "Abonnements",
      "SEAT": "Sièges invités",
      "CONNECTED": "Comptes connectés",
      "AI": "IA",
      "TAX": "Taxe"
    },
    "afterAffiliates": "après affiliés"
  },
  "payouts": {
    "empty": "Aucun relevé de versement.",
    "loadError": "Impossible de charger la feuille de versements.",
    "csvError": "Impossible de télécharger le CSV.",
    "tableAria": "Feuille de versements",
    "linesAria": "Lignes du relevé",
    "expand": "Développer les lignes",
    "collapse": "Réduire les lignes",
    "downloadCsv": "Télécharger le CSV",
    "summary_one": "{{count, number}} relevé · {{payable}} à verser · {{holds, number}} en attente",
    "summary_other": "{{count, number}} relevés · {{payable}} à verser · {{holds, number}} en attente",
    "status": {
      "PENDING": "En attente",
      "CARRIED": "Reporté",
      "PAID": "Payé",
      "groupAria": "Statut de versement",
      "CHARGED": "Prélevé",
      "RETAINED": "Conservé"
    },
    "col": {
      "payee": "Bénéficiaire",
      "tenant": "Tenant",
      "period": "Période",
      "gross": "Brut",
      "carriedIn": "Reporté",
      "payable": "À verser",
      "method": "Méthode",
      "hold": "Blocage",
      "status": "Statut",
      "paid": "Payé",
      "actions": "Actions",
      "collected": "Encaissé",
      "kind": "Type",
      "line": "Ligne",
      "retail": "Détail",
      "wholesale": "Gros",
      "uplift": "Majoration",
      "tenantShare": "Part du tenant",
      "platform": "Plateforme",
      "shareApplied": "Part appliquée",
      "commission": "Commission",
      "payApiRef": "réf. pay-api"
    },
    "payee": {
      "RESELLER": "Revendeur",
      "AFFILIATE": "Affilié"
    },
    "method": {
      "MANUAL": "Manuel",
      "STRIPE_CONNECT_MANUAL": "Stripe Connect (versements manuels)",
      "STRIPE_CONNECT": "Stripe Connect (versements automatiques)"
    },
    "hold": {
      "HOLD_TAX_DOCS": "Documents fiscaux",
      "HOLD_STRIPE_CONNECT": "Stripe Connect",
      "HOLD_TRANSFER_CURRENCY": "Devise du virement",
      "HOLD_TRANSFER_CAP": "Plafond de virement",
      "HOLD_RESELLER_UNPAID": "Prélèvement du revendeur impayé",
      "HOLD_AFFILIATE_REVIEW": "Retenu pour examen (affilié terminé pour motif)"
    },
    "kind": {
      "RENEWAL": "Renouvellement",
      "VARIABLE": "Variable",
      "REFUND": "Remboursement",
      "AFFILIATE_COMMISSION": "Commission d'affilié",
      "ADDON_FEE": "Frais de module complémentaire",
      "BOUNTY": "Primes de parrainage d’affilié",
      "MILESTONE": "Paliers d’affilié",
      "CLAWBACK": "Reprise",
      "RECOVERY": "Reprises récupérées"
    },
    "record": {
      "action": "Enregistrer le versement…",
      "title": "Enregistrer le versement",
      "amount": "Montant",
      "paidAt": "Payé le",
      "ref": "Référence",
      "refRequired": "La référence est obligatoire.",
      "override": "Enregistrer un autre montant",
      "overrideHelp": "Uniquement si le montant versé diffère du montant à payer ; indiquez un motif.",
      "reason": "Motif",
      "reasonRequired": "Le motif est obligatoire.",
      "submit": "Enregistrer",
      "cancel": "Annuler",
      "recorded": "Versement enregistré.",
      "failed": "Impossible d'enregistrer le versement.",
      "holdInfo": "Bloqué ({{hold}}) ; il peut quand même être enregistré.",
      "refusedHold": "Impossible à enregistrer tant que : {{hold}}.",
      "holdUnknown": "bloqué",
      "notPayable": "Ce règlement a été prélevé sur la carte du revendeur ; il n’y a rien à payer."
    },
    "allTenants": "Tous les tenants",
    "paidViaPrefix": "payé via",
    "tenantCaptionNoReseller": "Les versements vont au revendeur du tenant une fois celui-ci attribué. Les relevés listés ici sont antérieurs à ce changement, ainsi que les relevés d’affiliés.",
    "tenantCaptionPrefix": "Les versements vont au revendeur du tenant — voir ",
    "tenantCaptionReseller": "Règlements de {{resellerName}}",
    "tenantCaptionSuffix": ". Les relevés listés ici sont antérieurs à ce changement, ainsi que les relevés d’affiliés.",
    "unattributed": {
      "alert": "Revenus pas encore attribués à un revendeur : {{amounts}}",
      "row": "{{rows, number}} lignes · {{retail}}"
    },
    "exportsStatus": "Exporte les relevés : {{status}}"
  },
  "ai": {
    "asOf": "Au {{date}}",
    "add": "Ajouter un modèle…",
    "added": "Tarif ajouté.",
    "changed": "Prix modifié.",
    "changePrice": "Changer le prix…",
    "changePriceFor": "Changer le prix de {{name}} ({{currency}})",
    "tabs": {
      "models": "Modèles",
      "fast": "Attribution du niveau rapide",
      "deep": "Attribution du niveau approfondi",
      "aria": "Sections des prix des modèles d’IA",
      "naming": "Qualité des noms"
    },
    "loadError": "Impossible de charger les modèles d’IA et leurs tarifs.",
    "inForce": "En vigueur",
    "showHistory": "Afficher l'historique",
    "scheduled": "Programmé",
    "priceInUse": "Une assignation de modèle dépend de ce prix. Changez ou retirez cette assignation d'abord.",
    "withdrawPriceFor": "Retirer le prix qui commence {{when}}",
    "withdrawPriceTitle": "Retirer un prix programmé",
    "withdrawPriceQuestion": "Retirer le prix qui commence {{when}} ?",
    "models": {
      "caption": "Quel modèle chaque niveau appelle. Les changements s'appliquent aux appels d'IA qui commencent ensuite.",
      "fast": "Niveau rapide",
      "deep": "Niveau approfondi",
      "emptyCurrent": "Aucun modèle. L'IA de ce niveau est arrêtée tant qu'aucun n'est assigné.",
      "priced": "Tarifé en {{currencies}}.",
      "missing": "{{model}} n'a pas de prix en {{currencies}}, donc les appels d'IA dans ces devises sont refusés.",
      "addPrice": "Ajoutez le prix dans l'onglet Modèles.",
      "field": "Modèle",
      "fieldHelp": "Le modèle que ce niveau appelle.",
      "notPriced": "{{model}} n'a pas de prix en vigueur à ce moment en {{currencies}}. Ajoutez d'abord le prix, puis programmez de nouveau.",
      "loadError": "Impossible de charger les assignations de modèles.",
      "tierMissing": "Ce niveau n'est pas disponible.",
      "notOnTier": "Ce modèle n’est pas autorisé sur ce niveau. Cochez d’abord le niveau dans l’onglet Modèles.",
      "noneOnTier": "Aucun modèle n’est autorisé sur ce niveau. Ajoutez-en un dans l’onglet Modèles, avec ce niveau coché.",
      "openModels": "Ouvrir l’onglet Modèles",
      "effort": "Effort",
      "effortHelp": "Combien le modèle réfléchit avant de répondre. Un effort plus élevé coûte plus cher et peut manquer de place pour la réponse. Rapide est Faible par défaut, Approfondi est Moyen.",
      "effortVerifyHint": "Vérifiez ce modèle dans l’onglet Modèles pour choisir un autre effort.",
      "effortNotTaken": "Ce modèle n’accepte pas cet effort.",
      "effortVerify": "Vérifiez le modèle dans l’onglet Modèles pour choisir un autre effort.",
      "modelRetired": "Anthropic a retiré ce modèle. Choisissez-en un autre.",
      "effortNone": "Ce modèle n’accepte aucun niveau d’effort. Choisissez un autre modèle.",
      "noEffortWarning": "Anthropic n’indique plus d’effort accepté pour ce modèle ; planifiez un autre modèle.",
      "notVerifiedStructured": "Sortie structurée non vérifiée. Vérifiez le modèle avant de l’assigner.",
      "noStructuredWarning": "Anthropic indique que ce modèle n’accepte plus les sorties structurées ; planifiez un autre modèle.",
      "modelNoStructured": "Ce modèle n’accepte pas les sorties structurées. Choisissez-en un autre.",
      "modelVerifyFirst": "Vérifiez d’abord ce modèle.",
      "verifyModel": "Vérifier {{model}}"
    },
    "hideHistory": "Masquer l'historique",
    "col": {
      "model": "Modèle",
      "currency": "Devise",
      "effectiveFrom": "En vigueur depuis",
      "inForce": "En vigueur",
      "input": "Entrée / Mtok",
      "output": "Sortie / Mtok",
      "cacheRead": "Lecture cache / Mtok",
      "cacheWrite": "Écriture cache / Mtok",
      "added": "Ajouté"
    },
    "form": {
      "title": "Ajouter un tarif : {{name}}",
      "addExplain": "Fixez le tarif dans une devise.",
      "model": "Modèle",
      "currency": "Devise",
      "input": "Entrée / Mtok",
      "output": "Sortie / Mtok",
      "cacheRead": "Lecture cache / Mtok",
      "cacheWrite": "Écriture cache / Mtok",
      "microCaption": "Envoie {{micro}} micro-unités / Mtok",
      "submit": "Ajouter le tarif",
      "changeSubmit": "Changer le prix",
      "changeTitle": "Changer le prix : {{name}} ({{currency}})",
      "changeExplain": "Les prix ne se modifient pas sur place. Ceci commence un nouveau prix ; l’usage d’IA antérieur conserve le prix auquel il a été facturé.",
      "fromDate": "À partir d’une date",
      "dateRequired": "Choisissez une date.",
      "dateAfterToday": "Choisissez une date postérieure à aujourd’hui, ou choisissez Maintenant.",
      "outputAboveInput": "La sortie doit coûter plus que l’entrée.",
      "saveAnyway": "Enregistrer quand même",
      "warn": {
        "cacheRead": "La lecture du cache coûte habituellement moins que l’entrée.",
        "cacheWrite": "L’écriture du cache coûte habituellement plus que l’entrée.",
        "moved": "{{rate}} passe de {{from}} à {{to}}."
      },
      "cancel": "Annuler",
      "required": "Obligatoire.",
      "error": "Impossible d’ajouter le prix.",
      "moreThanZero": "Doit être supérieur à zéro.",
      "modelNotInCatalogue": "Ce modèle n’est pas dans le catalogue. Ajoutez d’abord le modèle dans l’onglet Modèles."
    },
    "attention": {
      "loadError": "Impossible de charger l'attention facturation.",
      "none": "Aucun.",
      "tabsAria": "Sections d’attention facturation",
      "tabCount": "{{label}} ({{count, number}})",
      "tab": {
        "statements": "Relevés",
        "divergences": "Divergences",
        "parked": "Événements de paiement en attente",
        "tax": "Classification fiscale"
      },
      "parked_one": "Événements de paiement en attente ({{count, number}})",
      "parked_other": "Événements de paiement en attente ({{count, number}})",
      "statementsAria": "Relevés nécessitant une attention",
      "divergencesAria": "Divergences de rapprochement",
      "parkedAria": "Événements de paiement en attente",
      "feedStalled": "Le flux de paiements est à l’arrêt depuis {{since}}. L’événement {{seq, number}} est bloqué par un verrou.",
      "lastAttemptFailed": "La dernière tentative a échoué.",
      "copyDetails": "Copier les détails pour le support",
      "copyDetailsAria": "Copier les détails pour le support du relevé {{id, number}}",
      "col": {
        "period": "Période",
        "status": "Statut",
        "total": "Total",
        "attempts": "Tentatives",
        "lastError": "Dernière erreur",
        "subscriptionId": "Id d'abonnement",
        "payApi": "abonnement pay-api",
        "fields": "Champs",
        "seq": "Seq",
        "eventType": "Type d'événement",
        "appliedAt": "Appliqué le",
        "count": "Nombre",
        "oldest": "Plus ancien",
        "product": "Produit",
        "since": "Depuis",
        "details": "Détails",
        "charge": "Prélèvement",
        "chargeId": "Id du prélèvement",
        "tenantId": "Id du tenant",
        "resellerId": "Id du revendeur",
        "failedAt": "Échec le"
      },
      "declare": {
        "action": "Déclarer les produits…",
        "title": "Renvoyer la liste des produits de tmm à pay-api ?",
        "body": "Vous pouvez le répéter sans risque.",
        "confirm": "Déclarer les produits",
        "done": "Produits déclarés.",
        "error": "Impossible de déclarer les produits.",
        "someFailed": "Certains produits n’ont pas pu être déclarés. Réessayez ; vous pouvez répéter sans risque."
      },
      "unhandled": {
        "title": "Événements de paiement non gérés",
        "note": "Événements de paiement que tmm-api ne gère pas encore. Ils sont conservés et appliqués dès qu’une version les gère.",
        "aria": "Événements de paiement non gérés"
      },
      "skuReview": {
        "title": "Produits à examiner",
        "note": "Examinez la classification fiscale du produit dans le registre de pay-api.",
        "aria": "Produits à examiner",
        "copyAria": "Copier les détails pour le support du produit {{identifier}}"
      },
      "taxClassification": {
        "note": "Un produit a besoin d’une classification fiscale dans pay-api avant de pouvoir être facturé.",
        "aria": "Classification fiscale requise",
        "copyAria": "Copier les détails pour le support du prélèvement {{id}}"
      },
      "sku": {
        "tmm_subscription": "Abonnement",
        "tmm_guests": "Invités",
        "tmm_connections": "Connexions",
        "tmm_ai_wallet_credit": "Crédit du portefeuille IA",
        "tmm_partner_addon_custom_ui": "Module complémentaire partenaire : interface personnalisée",
        "tmm_partner_addon_mobile_app": "Module complémentaire partenaire : app mobile",
        "tmm_partner_minimum_shortfall": "Manque au minimum du partenaire",
        "tmm_partner_statement_deficit": "Déficit du relevé du partenaire"
      },
      "chargeKind": {
        "WALLET_CHARGE": "Prélèvement du portefeuille IA",
        "ADDON_CHARGE": "Prélèvement de module complémentaire",
        "RESELLER_CHARGE": "Prélèvement de revendeur"
      }
    },
    "effort": {
      "LOW": "Faible",
      "MEDIUM": "Moyen",
      "HIGH": "Élevé",
      "XHIGH": "Très élevé",
      "MAX": "Maximum"
    },
    "catalog": {
      "tier": {
        "FAST": "Rapide",
        "DEEP": "Approfondi"
      },
      "and": " et ",
      "inUse": "Le niveau {{tiers}} utilise ce modèle. Attribuez-y d’abord un autre modèle.",
      "inUseNoTiers": "Un niveau utilise ce modèle. Attribuez-y d’abord un autre modèle.",
      "unavailable": "Nous n’avons pas pu joindre Anthropic pour vérifier le modèle. Rien n’a été enregistré. Réessayez dans un instant.",
      "form": {
        "tiers": "Niveaux",
        "tierRequired": "Choisissez au moins un niveau.",
        "modelId": "Identifiant du modèle",
        "modelIdRule": "Lettres minuscules, chiffres, points et tirets. Exactement comme Anthropic le nomme."
      },
      "notAtProvider": "Anthropic ne connaît pas cet identifiant de modèle. Vérifiez l’orthographe.",
      "exists": "Ce modèle est déjà dans le catalogue.",
      "add": {
        "title": "Ajouter un modèle",
        "submit": "Ajouter le modèle",
        "consequence": "Nous vérifions l’identifiant auprès d’Anthropic avant de l’enregistrer.",
        "error": "Impossible d’ajouter le modèle."
      },
      "added": "{{model}} ajouté.",
      "edit": {
        "title": "Modifier les niveaux : {{model}}",
        "submit": "Enregistrer",
        "saved": "Niveaux enregistrés.",
        "error": "Impossible de modifier les niveaux."
      },
      "notFound": "Ce modèle est introuvable.",
      "retire": {
        "action": "Mettre hors service…",
        "title": "Mettre un modèle hors service",
        "question": "Mettre {{model}} hors service ? Ses tarifs et son historique sont conservés.",
        "confirm": "Mettre hors service",
        "error": "Impossible de mettre le modèle hors service."
      },
      "retired": "{{model}} mis hors service.",
      "retiredLine": "Mis hors service le {{date}} par {{who}}",
      "verify": "Vérifier",
      "verified": "Vérifié auprès d’Anthropic.",
      "checking": "Vérification auprès d’Anthropic…",
      "goneAtProvider": "Anthropic ne connaît plus ce modèle. Il n’a pas été mis hors service ; mettez-le hors service quand plus rien ne l’utilise.",
      "verifyError": "Impossible de vérifier le modèle.",
      "notVerified": "Non vérifié",
      "pricesFor": "Tarifs de {{model}}",
      "noPrices": "Aucun tarif pour l’instant. Ajoutez-en un avant d’attribuer ce modèle.",
      "showPrices": "Afficher les tarifs de {{model}}",
      "hidePrices": "Masquer les tarifs de {{model}}",
      "addPrice": "Ajouter un tarif…",
      "addPriceFor": "Ajouter un tarif pour {{model}}",
      "editTiers": "Modifier les niveaux…",
      "showRetired": "Afficher les modèles hors service",
      "empty": "Aucun modèle pour l’instant. Ajoutez-en un pour le tarifer et l’attribuer à un niveau.",
      "tableAria": "Catalogue des modèles d’IA",
      "col": {
        "tiers": "Niveaux",
        "usedBy": "Utilisé par",
        "verified": "Vérifié",
        "efforts": "Efforts",
        "structured": "Sortie structurée"
      },
      "showOutside_one": "Afficher {{count, number}} tarif de modèles hors du catalogue",
      "showOutside_other": "Afficher {{count, number}} tarifs de modèles hors du catalogue",
      "hideOutside": "Masquer les tarifs des modèles hors du catalogue",
      "outsideCaption": "Ils ne peuvent pas être attribués. Ajoutez le modèle au catalogue pour l’utiliser.",
      "outsideAria": "Tarifs des modèles hors du catalogue",
      "unavailableAuth": "Anthropic a refusé notre clé d’API. Demandez à l’opérateur de la plateforme de vérifier la clé ; rien n’a été enregistré.",
      "notSupported": {
        "RETIRED": "Anthropic a retiré ce modèle. Il ne peut pas être ajouté.",
        "NO_EFFORT": "Ce modèle n’accepte pas de niveau d’effort, que chaque appel d’IA envoie. Il ne peut pas être ajouté.",
        "NO_STRUCTURED_OUTPUT": "Ce modèle n’accepte pas les sorties structurées, dont chaque appel d’IA a besoin. Il ne peut pas être ajouté."
      },
      "effortsNotChecked": "Non contrôlé",
      "effortsHint": "Vérifier le renseigne.",
      "effortsNone": "Aucun (ne peut pas être assigné)",
      "noEffortChip": "Aucun effort accepté",
      "noEffortReason": "Anthropic n’indique aucun effort accepté ; ce modèle ne peut pas être assigné.",
      "structuredYes": "Oui",
      "structuredNo": "Non (ne peut pas être assigné)",
      "structuredNotChecked": "Non contrôlé",
      "structuredHint": "Vérifier le renseigne.",
      "noStructuredChip": "Sans sortie structurée",
      "noStructuredReason": "Anthropic indique que ce modèle n’accepte pas les sorties structurées ; il ne peut pas être assigné.",
      "lifecycle": {
        "retiresOn": "Retrait prévu le {{date}}",
        "deprecated": "Obsolète",
        "retired": "Retiré par Anthropic"
      },
      "retiredGroup": "Modèles hors service",
      "retiredCaption": "Ce modèle est hors service. Ajoutez-le à nouveau dans cet onglet pour l’utiliser ; ses tarifs sont conservés.",
      "retiredAria": "Tarifs des modèles hors service"
    }
  },
  "parkedEvents": {
    "retention": "La réapplication fonctionne pendant 90 jours après l’événement de paiement.",
    "tabsAria": "Événements de paiement en attente par résolution",
    "tab": {
      "unresolved": "Non résolus",
      "resolved": "Résolus"
    },
    "tableAria": "Événements de paiement en attente",
    "regionAria": "Liste des événements de paiement en attente",
    "loadError": "Impossible de charger les événements de paiement en attente.",
    "empty": "Aucun événement de paiement en attente.",
    "emptyResolved": "Rien n’a encore été résolu.",
    "col": {
      "parked": "En attente depuis",
      "event": "Événement",
      "reason": "Motif",
      "attempts": "Tentatives",
      "payment": "Réf. du paiement",
      "subscription": "Abonnement",
      "resolution": "Résolution",
      "resolved": "Résolu",
      "by": "Par",
      "note": "Note",
      "actions": "Actions"
    },
    "eventType": {
      "subscription_renewed": "Abonnement renouvelé",
      "subscription_payment_failed": "Paiement de l’abonnement échoué",
      "subscription_canceled": "Abonnement annulé",
      "subscription_activated": "Abonnement activé",
      "subscription_payment_method_updated": "Moyen de paiement mis à jour",
      "subscription_paused": "Abonnement mis en pause",
      "subscription_resumed": "Abonnement repris",
      "subscription_plan_changed": "Plan modifié",
      "subscription_renewal_upcoming": "Renouvellement à venir",
      "payment_succeeded": "Paiement réussi",
      "payment_failed": "Paiement échoué",
      "payment_refunded": "Paiement remboursé",
      "connect_account_updated": "Compte connecté mis à jour",
      "transfer_created": "Transfert créé",
      "transfer_failed": "Transfert échoué",
      "transfer_reversed": "Transfert inversé",
      "transfer_reversal_failed": "Inversion du transfert échouée"
    },
    "reason": {
      "REFUND_EXCEEDS_PAYMENT": "Le remboursement est supérieur au paiement.",
      "REFUND_CURRENCY_MISMATCH": "La devise du remboursement diffère de celle du paiement.",
      "REFUND_PARENT_MISSING": "Le remboursement n’indique pas quel paiement il rembourse.",
      "REFUND_PARENT_NOT_MIRRORED": "Le paiement d’origine n’est pas encore enregistré. Réappliquez l’événement une fois qu’il l’est.",
      "REFUND_CURRENCY_MISSING": "Le remboursement n’a pas de devise.",
      "REFUND_FIELDS_MISSING": "Il manque des informations obligatoires au remboursement.",
      "DISPUTE_FIELDS_MISSING": "Il manque des informations obligatoires au litige.",
      "HANDLER_FAILED": "L’application a échoué trois fois."
    },
    "reasonUnknown": "L’événement n’a pas pu être appliqué.",
    "resolution": {
      "REAPPLIED": "Réappliqué",
      "DISMISSED": "Écarté"
    },
    "reapply": {
      "title": "Réappliquer l’événement {{seq, number}} ?",
      "consequence": "tmm-api le récupère dans pay-api et l’applique une seule fois.",
      "confirm": "Réappliquer",
      "rowAria": "Réappliquer l’événement {{seq, number}}",
      "done": "Événement réappliqué.",
      "failed": "Impossible de réappliquer l’événement.",
      "stillRefused": "Refusé à nouveau : {{reason}}.",
      "payApiUnavailable": "pay-api n’est pas disponible pour le moment, donc l’événement ne peut pas être récupéré. Réessayez plus tard."
    },
    "dismiss": {
      "title": "Écarter l’événement {{seq, number}} ?",
      "consequence": "Rien n’est appliqué. À utiliser lorsqu’il a été traité ailleurs, ou lorsque le membre a été effacé.",
      "confirm": "Écarter",
      "rowAria": "Écarter l’événement {{seq, number}}",
      "done": "Événement écarté.",
      "failed": "Impossible d’écarter l’événement."
    },
    "dismissInstead": "Écarter plutôt",
    "lastRefusal": "Dernière réapplication refusée à l’instant : {{reason}}",
    "dialog": {
      "note": "Note",
      "counter": "{{count, number}}/{{max, number}}",
      "noteRule": "Saisissez une note de 3 à 500 caractères."
    },
    "support": {
      "label": "Détails pour le support",
      "rowAria": "Copier les détails pour le support de l’événement {{seq, number}}"
    }
  },
  "deletions": {
    "empty": "Aucune demande de suppression.",
    "loadError": "Impossible de charger les demandes de suppression.",
    "requested": "Suppression demandée.",
    "cancelled": "Demande de suppression annulée.",
    "tableAria": "Demandes de suppression",
    "requestedBy": "par {{who}}",
    "copyDetailsAria": "Copier les détails pour le support de la demande de suppression {{id, number}}",
    "cancel": "Annuler…",
    "counter": "{{n, number}}/200",
    "col": {
      "person": "Personne",
      "requested": "Demandée",
      "coolingOff": "Délai jusqu'au",
      "status": "Statut",
      "erasedAt": "Effacée le",
      "attempts": "Tentatives",
      "actions": "Actions"
    },
    "status": {
      "PENDING": "En attente",
      "CANCELLED": "Annulée",
      "ERASING": "Effacement",
      "ERASED": "Effacée",
      "FAILED": "Échouée"
    },
    "request": {
      "action": "Demander la suppression…",
      "warning": "Tout ce que cette personne possède est effacé après le délai de réflexion. Elle est informée par e-mail et peut annuler.",
      "error": "Impossible de demander la suppression."
    },
    "requestDialog": {
      "title": "Demander la suppression",
      "person": "Personne",
      "personRequired": "La personne est obligatoire.",
      "reason": "Motif",
      "reasonRequired": "Le motif est obligatoire.",
      "submit": "Demander",
      "cancel": "Annuler"
    },
    "cancelDialog": {
      "titleNamed": "Annuler la demande de suppression de {{person}} ?",
      "consequence": "Rien de ce que cette personne possède ne sera effacé.",
      "reason": "Motif",
      "confirm": "Annuler la suppression",
      "error": "Impossible d’annuler la demande de suppression.",
      "keep": "Conserver la demande de suppression"
    },
    "erase": {
      "action": "Effacer maintenant…",
      "title": "Effacer ce compte maintenant ?",
      "body": "Cela supprime définitivement les données de {{person}} maintenant, au lieu de la date prévue. C’est irréversible.",
      "confirm": "Effacer maintenant",
      "erased": "Compte effacé.",
      "retrying": "L’effacement a commencé ; il se terminera en arrière-plan.",
      "cancelledError": "Cette demande a été annulée, elle ne peut donc pas être effacée.",
      "notFoundError": "Cette demande n’existe plus.",
      "error": "Impossible d’effacer le compte.",
      "retryTitle": "Réessayer d’effacer ce compte ?",
      "retryBody": "La dernière tentative a échoué. Cela réessaie maintenant et, une fois réussi, c’est irréversible.",
      "failedAgain": "L’effacement a de nouveau échoué : {{reason}}."
    },
    "errorCode": {
      "ASSOCIATION_HOLD": "L’abonnement du compte n’a pas encore pu être associé dans pay-api.",
      "PAY_API_UNAVAILABLE": "pay-api n’a pas répondu.",
      "PAY_API_REFUSED": "pay-api a refusé la demande.",
      "ERASURE_IN_PROGRESS": "pay-api est encore en train d’effacer les enregistrements de paiement.",
      "IDEMPOTENCY_CONFLICT": "pay-api a signalé un conflit sur la demande d’effacement.",
      "STEP_FAILED": "Une étape de l’effacement a échoué.",
      "UNKNOWN": "L’effacement a échoué."
    }
  },
  "aiUsage": {
    "tabs": {
      "aria": "Sections d'utilisation IA",
      "features": "Par fonction",
      "people": "Par personne"
    },
    "empty": "Aucun usage IA sur cette période.",
    "loadError": "Impossible de charger l'usage IA.",
    "range": "{{from}} – {{to}}",
    "showing": "Affichage de {{person}}",
    "details": "Détails",
    "atOurPriceAbsent": "— signifie qu’aucune offre ne fixe cet usage à notre prix.",
    "atOurPricePartial": "Partiel",
    "atOurPricePartialHelp": "— signifie qu’aucune offre ne fixe cet usage à notre prix. Partiel signifie que l’usage de certaines personnes n’est pas tarifé à notre prix, donc aucun total n’est affiché.",
    "kpi": {
      "requests": "Requêtes",
      "failed": "Échecs",
      "totalTokens": "Jetons totaux"
    },
    "tableAria": {
      "features": "Usage IA par fonction",
      "people": "Usage IA par personne"
    },
    "col": {
      "feature": "Fonction",
      "requests": "Requêtes",
      "failed": "Échecs",
      "input": "Entrée",
      "output": "Sortie",
      "cacheRead": "Lecture cache",
      "cacheWrite": "Écriture cache",
      "totalTokens": "Jetons totaux",
      "cost": "Coût",
      "atOurPrice": "À notre prix",
      "charge": "Facture est.",
      "person": "Personne",
      "actions": "Actions",
      "walletUsage": "Usage du portefeuille",
      "balance": "Solde"
    },
    "feature": {
      "IMPORT_MAPPING": "Correspondance d'import",
      "CATEGORY_SUGGESTION": "Suggestion de catégorie",
      "MEETING_SUMMARY": "Résumé de réunion",
      "MATCH_SUGGESTION": "Suggestion de correspondance",
      "DOMAIN_SETUP": "Configuration du domaine",
      "PAYEE_SUGGESTION": "Suggestion de bénéficiaire",
      "PAYEE_PATTERN": "Modèles de bénéficiaire",
      "ENVELOPE_ANALYSIS": "Analyse des enveloppes",
      "FINANCIAL_ASSISTANT": "Mon Assistant Financier",
      "SUPPORT_ASSISTANT": "Assistant du support"
    },
    "wallet": {
      "toggle": "Portefeuille",
      "purchases": "Achats",
      "recharges": "Recharges",
      "topUps": "Recharges manuelles",
      "monthlyCredits": "Crédits mensuels",
      "adminCredits": "Crédits de l’administrateur",
      "usage": "Usage",
      "balance": "Solde"
    },
    "suspended": "IA suspendue par la plateforme",
    "suspendedSince": "Depuis le {{date}}",
    "credit": {
      "action": "Ajouter un crédit IA…",
      "title": "Ajouter un crédit IA pour {{person}}",
      "amount": "Montant",
      "reason": "Motif",
      "amountRule": "Saisissez un montant supérieur à zéro et d’au plus 10,000,000.00.",
      "reasonRequired": "Le motif est obligatoire.",
      "reasonTooLong": "Utilisez au plus 255 caractères.",
      "consequence": "{{amount}} est ajouté au portefeuille IA de {{person}}. C’est enregistré avec votre motif.",
      "consequenceNoWallet": "{{amount}} dans la devise de son abonnement est ajouté au portefeuille IA de {{person}}. C’est enregistré avec votre motif.",
      "confirm": "Ajouter le crédit",
      "added": "{{amount}} ajouté. Son solde IA est de {{balance}}.",
      "noSubscription": "Cette personne n’a pas d’abonnement actif, son portefeuille IA ne peut donc pas être crédité.",
      "keyConflict": "Ce crédit a déjà été envoyé avec un autre montant. Fermez cette fenêtre et recommencez.",
      "error": "Impossible d’ajouter le crédit IA."
    }
  },
  "customers": {
    "invite": {
      "action": "Inviter un client…",
      "title": "Inviter un client",
      "email": "E-mail",
      "emailRequired": "L'e-mail est obligatoire.",
      "emailInvalid": "Saisissez un e-mail valide.",
      "submit": "Inviter",
      "cancel": "Annuler",
      "sent": "Invitation envoyée à {{email}}.",
      "created": "Invitation créée pour {{email}} ; l'e-mail n'a pas pu être envoyé.",
      "error": "Impossible d'inviter le client."
    }
  },
  "paymentsSetup": {
    "title": "Configuration de l’encaissement",
    "refresh": "Actualiser la configuration de l’encaissement",
    "refreshing": "Actualisation de la configuration de l’encaissement…",
    "refreshed": "Configuration de l’encaissement actualisée.",
    "refreshError": "Impossible d’actualiser la configuration de l’encaissement.",
    "refreshUnavailable": "pay-api n’a pas de configuration de l’encaissement pour ce tenant, ou n’a pas pu être joint. Vérifiez le tenant dans pay-api, puis actualisez à nouveau.",
    "loadError": "Impossible de charger la configuration de l’encaissement.",
    "empty": "Aucune configuration de l’encaissement n’est en cache pour ce tenant. Actualisez pour la lire depuis pay-api.",
    "field": {
      "provider": "Fournisseur",
      "environment": "Environnement",
      "flow": "Flux",
      "stripeAccount": "Compte Stripe",
      "publishableKey": "Clé publiable"
    },
    "connection": {
      "label": "Connexion d’encaissement",
      "provisioned": "Provisionnée le {{date}}",
      "notProvisioned": "Non provisionnée"
    },
    "provision": {
      "open": "Provisionner l’encaissement…",
      "title": "Provisionner l’encaissement de {{name}} ?",
      "consequence": "Cela configure l’encaissement du tenant sur le compte Stripe de la plateforme, dans pay-api, et l’active en {{currency}}. Les paiements hors de la plage configurée sont refusés. Vous pouvez le répéter sans risque.",
      "confirm": "Provisionner l’encaissement",
      "done": "Encaissement provisionné.",
      "error": "Impossible de provisionner l’encaissement.",
      "reason": {
        "CONNECTION_EXISTS": "Ce tenant a déjà une connexion d’encaissement différente dans pay-api : un compte connecté, un autre fournisseur ou l’autre environnement. Quelqu’un doit la supprimer dans pay-api avant que l’encaissement puisse être provisionné ici.",
        "STRIPE_ENVIRONMENT_UNSET": "L’environnement Stripe de tmm-api n’est pas défini, donc rien n’a été envoyé à pay-api. Adressez-vous à l’équipe de la plateforme.",
        "HOUSE_MODE_NOT_ALLOWED": "pay-api n’autorise pas encore tmm à encaisser sur le compte Stripe de la plateforme. Adressez-vous à l’équipe de la plateforme.",
        "HOUSE_MODE_UNAVAILABLE": "pay-api ne prend pas encore en charge l’encaissement sur le compte Stripe de la plateforme. Adressez-vous à l’équipe de la plateforme.",
        "ACTIVATION_REFUSED": "pay-api a refusé d’activer la connexion d’encaissement.",
        "PAY_API_UNAVAILABLE": "pay-api n’est pas disponible pour le moment. Réessayez ; vous pouvez le répéter sans risque."
      }
    }
  },
  "whitelabel": {
    "title": "Domaine personnalisé",
    "none": "Aucun domaine personnalisé. Les tenants utilisent les noms d’hôte de la plateforme.",
    "setUp": "Configurer un domaine…",
    "loadError": "Impossible de charger le domaine personnalisé.",
    "domain": "Domaine",
    "stateLabel": "État",
    "state": {
      "DRAFT": "En attente du DNS",
      "ACTIVE": "En ligne"
    },
    "activatedAt": "Activé",
    "hostnames": "Noms d’hôte",
    "col": {
      "hostname": "Nom d’hôte",
      "type": "Type",
      "app": "App",
      "dns": "DNS"
    },
    "type": {
      "APP": "App",
      "LOGIN": "Connexion",
      "AUTH": "Authentification",
      "API": "API",
      "ASSET": "Ressources",
      "BRAND": "Centre de marque"
    },
    "verified": "Vérifié",
    "notVerified": "Non vérifié",
    "records": {
      "title": "Enregistrements DNS à créer",
      "host": "Hôte",
      "type": "Type",
      "target": "Cible",
      "verified": "Vérifié"
    },
    "copy": "Copier {{value}}",
    "verify": "Vérifier le DNS",
    "verifying": "Vérification du DNS",
    "verifyWait": "Cela peut prendre jusqu’à une minute.",
    "verifyError": "Impossible de vérifier le DNS.",
    "results": {
      "title": "Dernière vérification",
      "thisCheck": "Cette vérification",
      "matched": "Correspond",
      "notMatched": "Ne correspond pas",
      "allVerified": "Tous les noms d’hôte sont vérifiés.",
      "someFailed": "Certains noms d’hôte n’ont pas été vérifiés. Contrôlez les enregistrements DNS et réessayez."
    },
    "change": "Changer de domaine…",
    "remove": "Supprimer…",
    "removeTitle": "Supprimer le domaine personnalisé ?",
    "removeBody": "Le tenant revient aux noms d’hôte de la plateforme. Les enregistrements DNS créés peuvent ensuite être supprimés.",
    "removeConfirm": "Supprimer",
    "removed": "Domaine personnalisé supprimé.",
    "removeError": "Impossible de supprimer le domaine personnalisé.",
    "note": {
      "required": "Obligatoire",
      "optional": "Facultatif"
    },
    "set": {
      "title": "Configurer un domaine",
      "changeTitle": "Changer de domaine",
      "domainLabel": "Domaine",
      "domainHelper": "Le domaine du client, p. ex. example.com",
      "domainRequired": "Le domaine est obligatoire.",
      "domainTooLong": "Le domaine doit comporter 255 caractères au maximum.",
      "include": "Inclure",
      "includeHost": "Inclure {{prefix}}",
      "prefix": "Préfixe",
      "prefixFor": "Préfixe pour {{prefix}}",
      "prefixRequired": "Le préfixe est obligatoire.",
      "prefixTooLong": "Le préfixe doit comporter 63 caractères au maximum.",
      "note": "Remarque",
      "noneChecked": "Choisissez au moins un nom d’hôte.",
      "templateError": "Impossible de charger les noms d’hôte suggérés.",
      "saveError": "Impossible d’enregistrer le domaine.",
      "saved": "Domaine enregistré. Créez les enregistrements DNS, puis vérifiez.",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "refused": "Ce domaine ne peut pas être utilisé. Vérifiez-le et réessayez.",
      "domainName": "le domaine personnalisé"
    }
  },
  "addons": {
    "tabs": {
      "aria": "Sections des modules complémentaires"
    },
    "catalog": {
      "title": "Catalogue",
      "tableAria": "Catalogue des modules complémentaires",
      "empty": "Rien dans le catalogue pour l'instant.",
      "loadError": "Impossible de charger le catalogue.",
      "col": {
        "name": "Nom",
        "period": "Période",
        "price": "Prix",
        "billing": "Facturation",
        "status": "Statut",
        "actions": "Actions"
      }
    },
    "fleet": {
      "title": "Modules complémentaires des tenants",
      "statusAria": "Statut du module complémentaire",
      "all": "Tous",
      "loadError": "Impossible de charger les modules complémentaires des tenants.",
      "tableAria": "Modules complémentaires des tenants",
      "empty": "Aucun module complémentaire de tenant."
    },
    "tenant": {
      "tableAria": "Modules complémentaires du tenant",
      "empty": "Aucun module complémentaire pour ce tenant.",
      "loadError": "Impossible de charger les modules complémentaires.",
      "expand": "Afficher les frais de {{name}}",
      "collapse": "Masquer les frais de {{name}}",
      "cancels": "Résilié le {{date}}"
    },
    "col": {
      "tenant": "Tenant",
      "addon": "Module complémentaire",
      "status": "Statut",
      "billingMode": "Mode de facturation",
      "price": "Prix par période",
      "term": "Durée",
      "autoRenew": "Renouvellement auto",
      "revenueYear": "Revenus de l'année",
      "offered": "Proposé",
      "accepted": "Accepté",
      "actions": "Actions"
    },
    "charges": {
      "empty": "Aucun frais pour l'instant.",
      "tableAria": "Frais de {{name}}",
      "copyDetailsAria": "Copier les détails pour le support des frais {{id, number}}",
      "col": {
        "period": "Période",
        "amount": "Montant",
        "mode": "Mode",
        "status": "Statut",
        "card": "Carte",
        "attempt": "Tentative",
        "lastError": "Dernière erreur",
        "actions": "Actions"
      }
    },
    "catalogStatus": {
      "DRAFT": "Brouillon",
      "ACTIVE": "Actif",
      "RETIRED": "Retiré"
    },
    "period": {
      "ANNUAL": "Annuel",
      "MONTHLY": "Mensuel"
    },
    "perPeriod": {
      "ANNUAL": "/ an",
      "MONTHLY": "/ mois"
    },
    "allowedBilling": {
      "CARD": "Carte",
      "NET_FROM_PAYOUTS": "Déduit des versements",
      "BOTH": "Carte ou déduit des versements"
    },
    "billingMode": {
      "CARD": "Carte",
      "NET_FROM_PAYOUTS": "Déduit des versements"
    },
    "status": {
      "OFFERED": "Proposé",
      "ACTIVE": "Actif",
      "PAST_DUE": "En retard",
      "LAPSED": "Caduc",
      "CANCELLED": "Résilié",
      "DECLINED": "Refusé",
      "WITHDRAWN": "Retiré"
    },
    "chargeStatus": {
      "PENDING": "En attente",
      "PAID": "Payé",
      "FAILED": "Échoué",
      "ACTION_REQUIRED": "Action requise",
      "NETTING": "En déduction",
      "NETTED": "Déduit",
      "WAIVED": "Exonéré",
      "REFUNDED": "Remboursé"
    },
    "chargeMode": {
      "CARD": "Carte",
      "NETTED": "Déduit"
    },
    "yes": "Oui",
    "no": "Non",
    "actions": {
      "new": "Nouveau module complémentaire…",
      "edit": "Modifier…",
      "activate": "Activer",
      "retire": "Retirer",
      "reinstate": "Rétablir…",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "create": "Créer",
      "offer": "Proposer un module complémentaire…",
      "withdraw": "Retirer l'offre",
      "cancelAddon": "Résilier…",
      "waive": "Exonérer les frais…"
    },
    "form": {
      "createTitle": "Nouveau module complémentaire",
      "editTitle": "Modifier le module complémentaire",
      "kind": "Type",
      "kindHelp": "Une clé stable, p. ex. BRANDED_APP. Fixée à la création.",
      "kindInvalid": "Une lettre, puis jusqu'à 31 lettres, chiffres ou tirets bas.",
      "name": "Nom",
      "description": "Description",
      "period": "Période",
      "currency": "Devise",
      "defaultPrice": "Prix par défaut",
      "defaultPriceHelp": "Facultatif.",
      "minorCaption": "Envoie {{minor}} unités mineures",
      "allowedBilling": "Facturation autorisée",
      "required": "Obligatoire.",
      "tooLong": "{{max, number}} caractères au maximum.",
      "nonNegative": "Doit être supérieur ou égal à zéro."
    },
    "activate": {
      "title": "Activer {{name}} ?",
      "confirm": "Il pourra alors être proposé aux tenants."
    },
    "reinstate": {
      "title": "Rétablir {{name}} ?",
      "confirm": "Il pourra de nouveau être proposé aux tenants.",
      "action": "Rétablir"
    },
    "retire": {
      "title": "Retirer {{name}} ?",
      "confirm": "Il ne pourra plus être proposé. Les tenants qui l'ont le conservent."
    },
    "activated": "{{name}} est actif.",
    "retired": "{{name}} est retiré.",
    "created": "{{name}} a été ajouté en brouillon.",
    "updated": "{{name}} a été enregistré.",
    "saveError": "Impossible d'enregistrer le module complémentaire.",
    "actionError": "Impossible de mettre à jour le module complémentaire.",
    "offer": {
      "title": "Proposer un module complémentaire",
      "addon": "Module complémentaire",
      "chooseAddon": "Choisissez un module complémentaire.",
      "noneActive": "Aucun module complémentaire actif dans le catalogue.",
      "price": "Prix par période",
      "termStart": "Début de la durée (facultatif)",
      "autoRenew": "Renouvellement auto",
      "notes": "Notes (facultatif)",
      "submit": "Proposer"
    },
    "withdraw": {
      "title": "Retirer l'offre ?",
      "confirm": "Retirer l'offre de {{name}} ? Le tenant ne pourra plus l'accepter."
    },
    "cancel": {
      "title": "Résilier {{name}} ?",
      "atTermEnd": "À la fin de la durée",
      "termEndCaption": "Le service continue jusqu'au {{date}}.",
      "immediately": "Immédiatement : le service s'arrête maintenant.",
      "reason": "Motif (facultatif)",
      "keep": "Conserver le module complémentaire",
      "submit": "Résilier le module complémentaire",
      "termEndCaptionUnknown": "Le service continue jusqu'à la fin de la période en cours."
    },
    "waive": {
      "title": "Exonérer les frais",
      "reason": "Motif",
      "reasonRequired": "Le motif est obligatoire.",
      "submit": "Exonérer les frais"
    },
    "merchantUnset": "Le marchand officiel n'est pas défini.",
    "openSettings": "Ouvrir les Paramètres"
  },
  "settings": {
    "nav": {
      "commerce": "Commerce",
      "operations": "Opérations",
      "other": "Autre",
      "fees": "Frais de traitement",
      "standingCc": "CC de situation"
    },
    "maintenance": {
      "title": "Maintenance de la facturation",
      "help": "Actions ponctuelles pour la configuration de la facturation.",
      "backfill": {
        "action": "Enregistrer les bénéficiaires…",
        "title": "Enregistrer les partenaires existants comme bénéficiaires dans pay-api ?",
        "body": "Lancez-le une seule fois, après l’adoption de pay-api. L’action est consignée dans l’audit.",
        "confirm": "Enregistrer les bénéficiaires",
        "error": "Impossible de lancer l’enregistrement des bénéficiaires.",
        "done": "Enregistrement des bénéficiaires terminé.",
        "matched": "Associés {{value, number}}",
        "stored": "Enregistrés {{value, number}}",
        "kindFixed": "Type corrigé {{value, number}}",
        "kindUnavailable": "Type pas encore corrigeable {{value, number}}",
        "policySet": "Politique définie {{value, number}}",
        "unmatched": "Non associés {{value, number}}",
        "failed": "Échecs {{value, number}}",
        "failedIds": "Non enregistrés : {{ids}}",
        "runAgain": "Le type de certains bénéficiaires n’a pas encore pu être corrigé. Relancez-le quand pay-api le proposera."
      }
    },
    "col": {
      "key": "Clé",
      "updated": "Mis à jour",
      "value": "Valeur"
    },
    "loadError": "Impossible de charger les paramètres du produit.",
    "merchant": {
      "change": "Modifier…",
      "changeTitle": "Changer le marchand officiel",
      "help": "Le tenant dont le compte de paiement facture les modules complémentaires aux tenants.",
      "saveError": "Impossible d'enregistrer le paramètre.",
      "tenantLabel": "Tenant",
      "title": "Marchand officiel",
      "unset": "Non défini. Les paiements par carte des modules complémentaires sont suspendus jusqu'à ce qu'il soit défini.",
      "concurrent": "Quelqu’un d’autre l’a modifié en même temps. Réessayez."
    },
    "seller": {
      "title": "Vendeur et conditions",
      "name": "Nom du vendeur",
      "legalName": "Raison sociale",
      "version": "Version des conditions",
      "termsUrl": "URL des conditions",
      "privacyUrl": "URL de la politique de confidentialité",
      "versionHint": "Lettres, chiffres, point, tiret bas ou tiret ; 32 au plus. Par exemple 2026-10.",
      "urlHint": "Laissez vide pour n’en afficher aucune.",
      "nameRequired": "Le nom du vendeur est obligatoire.",
      "legalNameRequired": "La raison sociale est obligatoire.",
      "versionRequired": "La version des conditions est obligatoire.",
      "versionInvalid": "Utilisez uniquement des lettres, chiffres, point, tiret bas ou tiret ; 32 au plus.",
      "urlInvalid": "Saisissez une adresse https de {{max, number}} caractères au plus, ou laissez vide.",
      "tooLong": "Au plus {{max, number}} caractères.",
      "saved": "Vendeur et conditions enregistrés.",
      "unchanged": "Rien n’a changé, donc rien n’a été enregistré.",
      "versionConfirm": {
        "title": "Passer la version des conditions à {{termsVersion}} ?",
        "body": "Les nouveaux abonnés doivent accepter la version {{termsVersion}} avant de s’abonner. Les abonnés existants ne sont pas obligés de l’accepter à nouveau ; l’application peut le leur demander. Leurs abonnements continuent.",
        "confirm": "Changer de version"
      }
    },
    "other": {
      "title": "Autres paramètres",
      "empty": "Aucun autre paramètre."
    },
    "updatedAt": "Mis à jour {{when}}",
    "standingCc": {
      "title": "Copie des avis de situation",
      "helper": "Adresses e-mail séparées par des virgules, en copie de chaque avis de situation",
      "invalid": "« {{entry}} » n’est pas une adresse e-mail.",
      "tooLong": "Au plus {{max, number}} caractères au total.",
      "save": "Enregistrer la copie",
      "saved": "Copie des avis enregistrée."
    },
    "processing": {
      "title": "Frais de traitement des cartes",
      "help": "Ce que le processeur de cartes nous facture sur chaque prélèvement encaissé, par devise. Le revendeur paie la part de sa marge. Une modification s’applique dès maintenant.",
      "col": {
        "currency": "Devise",
        "percent": "Pourcentage",
        "fixed": "Fixe par prélèvement",
        "since": "En vigueur depuis"
      },
      "saved": "Frais de traitement des cartes en {{currency}} enregistrés.",
      "invalid": "Vérifiez le pourcentage (0 à 100) et les frais fixes (0 ou plus).",
      "error": "Impossible d'enregistrer les frais de traitement des cartes.",
      "loadError": "Impossible de charger le taux en {{currency}}.",
      "percentLabel": "Pourcentage en {{currency}}",
      "fixedLabel": "Fixe par prélèvement en {{currency}}",
      "save": "Enregistrer",
      "none": "Non défini : aucuns frais de traitement ne sont comptés en {{currency}}.",
      "next": "Prochain : {{percent}} + {{fixed}} à partir du {{when}}",
      "edit": "Modifier {{currency}}…"
    }
  },
  "resellerCards": {
    "col": {
      "actions": "Actions"
    },
    "noncompliant": {
      "label": "Non conforme",
      "since": "Non conforme depuis le {{date}}"
    },
    "form": {
      "annualEmpty": "Laissez vide pour ne proposer que le mensuel."
    }
  },
  "customerRateCards": {
    "versionLabel": "v{{version, number}}",
    "noCurrent": "Aucune version publiée",
    "actions": {
      "editDetails": "Modifier les détails…",
      "newVersion": "Nouvelle version…",
      "publish": "Publier…",
      "saveDraft": "Enregistrer le brouillon",
      "grant": "Accorder à un revendeur…",
      "revoke": "Révoquer…",
      "move": "Déplacer les abonnés…",
      "adopt": "Adopter…"
    },
    "status": {
      "DRAFT": "Brouillon",
      "PUBLISHED": "Publiée",
      "RETIRED": "Retirée"
    },
    "chip": {
      "current": "Actuelle"
    },
    "tabs": {
      "versions": "Versions",
      "grants": "Autorisations",
      "controls": "Contrôles"
    },
    "versions": {
      "tableAria": "Versions",
      "version": "Version",
      "state": "État",
      "published": "Publiée",
      "subscribers": "Abonnés",
      "empty": "Aucune version pour le moment.",
      "newError": "Impossible d’ajouter une version."
    },
    "grants": {
      "reseller": "Revendeur",
      "adoption": "Adoption",
      "adopted": "Adopte cette grille",
      "notAdopted": "Accordée",
      "empty": "Aucun revendeur n’a cette grille.",
      "unpublished": "Les revendeurs ne peuvent pas voir cette grille tant qu’une version n’est pas publiée."
    },
    "create": {
      "submit": "Créer la grille",
      "nameRequired": "Le nom est obligatoire."
    },
    "publish": {
      "title": "Publier la version {{version, number}}",
      "consequence": "Publier la version {{version, number}} ? Les nouvelles ventes l’utilisent. Les abonnés existants restent sur leur version jusqu’à ce que vous les déplaciez.",
      "confirm": "Publier"
    },
    "move": {
      "title": "Déplacer les abonnés",
      "consequence": "Déplacer les abonnés de cette grille qui sont sur une version antérieure vers la version {{version, number}} ? Chaque abonné déplacé reçoit un avis.",
      "confirm": "Déplacer les abonnés",
      "result": "Déplacés {{moved, number}}. Déjà sur cette version : {{already, number}}. Échecs : {{failed, number}}.",
      "failedWarning": "Certains abonnés n’ont pas été déplacés.",
      "error": "Impossible de déplacer les abonnés."
    },
    "grant": {
      "title": "Accorder à un revendeur",
      "reseller": "Revendeur",
      "confirm": "Accorder",
      "empty": "Chaque revendeur a déjà cette grille."
    },
    "revoke": {
      "title": "Révoquer l’autorisation",
      "consequence": "Révoquer cette autorisation pour {{reseller}} ?",
      "confirm": "Révoquer",
      "error": "Impossible de révoquer cette autorisation.",
      "adopted": "{{reseller}} utilise cette grille. Il doit en adopter une autre avant que cette autorisation puisse être révoquée."
    },
    "adopt": {
      "title": "Adopter la grille tarifaire",
      "confirm": "Adopter",
      "consequence": "Adopter {{name}} pour ce revendeur ?",
      "notPublished": "Cette grille n’a pas de version publiée.",
      "empty": "Aucune grille adoptée",
      "noneGranted": "Aucune grille tarifaire n’est accordée à ce revendeur.",
      "error": "Impossible d’adopter cette grille tarifaire."
    },
    "errors": {
      "save": "Impossible d’enregistrer cette version.",
      "immutable": "Seule une version brouillon peut être modifiée."
    },
    "form": {
      "aiFirstPurchase": "Premier achat d’IA",
      "aiRechargeTrigger": "Recharger quand le solde passe sous",
      "moreThanZero": "Doit être supérieur à zéro.",
      "moreThanTrigger": "Doit être supérieur au seuil de recharge.",
      "between0And100": "Doit être entre 0 et 100."
    },
    "toast": {
      "published": "La version {{version, number}} est publiée.",
      "granted": "Accordée à {{reseller}}.",
      "revoked": "Autorisation révoquée.",
      "versionAdded": "La version {{version, number}} est un nouveau brouillon.",
      "adopted": "{{name}} est la grille adoptée."
    }
  },
  "tenantRateCard": {
    "activateOrFix": "Activez ou corrigez d’abord la grille."
  },
  "resellerBilling": {
    "cardTitle": "Carte enregistrée",
    "noCard": "Aucune carte enregistrée. Le revendeur en ajoute une dans sa console ; d’ici là, les déficits et manques ne peuvent pas être prélevés.",
    "brand": "Marque",
    "number": "Numéro",
    "last4": "•••• {{last4}}",
    "expiry": "Expire",
    "expiryValue": "{{mm}}/{{yyyy}}",
    "status": "Statut",
    "cardReadOnly": "Lecture seule. Le revendeur gère sa carte.",
    "cardStatus": {
      "ACTIVE": "Active",
      "EXPIRED": "Carte expirée",
      "requires_action": "Nécessite la confirmation du revendeur"
    },
    "theCard": "la carte enregistrée",
    "chargesTitle": "Prélèvements",
    "col": {
      "period": "Période",
      "kind": "Type",
      "amount": "Montant",
      "status": "Statut",
      "attempt": "Tentative",
      "nextRetry": "Prochaine tentative",
      "holdsPayouts": "Bloque les versements",
      "failure": "Échec",
      "actions": "Actions"
    },
    "noCharges": "Aucun prélèvement.",
    "kind": {
      "MINIMUM_SHORTFALL": "Manque au minimum",
      "STATEMENT_DEFICIT": "Déficit du règlement"
    },
    "chargeStatus": {
      "PENDING": "En attente",
      "REQUESTED": "En cours",
      "SUCCEEDED": "Prélèvement encaissé",
      "FAILED": "Échoué",
      "REQUIRES_ACTION": "Action requise"
    },
    "holdingPayouts": "Versements bloqués",
    "linkedCharge": "Prélèvement lié",
    "failure": {
      "NO_CARD": "Aucune carte enregistrée",
      "REVERIFY_CARD": "La banque demande de confirmer la carte ; le revendeur doit l’ajouter à nouveau",
      "PSP_ERROR": "Le prestataire de paiement a rencontré une erreur",
      "FAILED": "Refusé"
    },
    "retry": "Réessayer",
    "retryAria": "Réessayer le prélèvement de {{period}}",
    "confirm": {
      "title": "Réessayer de prélever {{amount}} sur la carte enregistrée ?",
      "body": "Le prélèvement est envoyé maintenant sur {{card}}.",
      "noCard": "Aucune carte n’est enregistrée : cette tentative échouera immédiatement."
    },
    "retried": "Prélèvement relancé : {{status}}.",
    "loadError": "Impossible de charger la facturation.",
    "errors": {
      "notRetryable": "Ce prélèvement ne peut pas être relancé pour le moment.",
      "notFound": "Ce prélèvement est introuvable. La liste a été rechargée.",
      "concurrent": "Le prélèvement était mis à jour au même moment. Réessayez.",
      "retry": "Impossible de relancer le prélèvement."
    },
    "retryFailed": "La relance n’a pas abouti : {{failure}}",
    "noFailureReason": "Aucun motif d’échec indiqué"
  },
  "commissionPlans": {
    "title": "Plans de commission",
    "help": {
      "short": "Les revendeurs conçoivent leurs propres plans de commission d’affiliés ; il n’y a pas de plans de la plateforme.",
      "body": "Un affilié garde le plan qui lui est attribué, et chaque parrainage garde à vie le plan sous lequel il a été fait. Les modifications faites ici le sont au nom du revendeur et sont auditées à votre nom.",
      "schedule": "Le mois 1 est le premier mois payé du parrainage ; les essais ne comptent pas.",
      "coolOff": "La commission est retenue pendant ce délai après chaque paiement et annulée si le paiement est remboursé pendant ce délai. Plus long est plus sûr ; plus court est plus attractif.",
      "afterEnd": "Ce qu’il advient de la commission sur les parrainages existants une fois l’affilié terminé."
    },
    "actions": {
      "new": "Nouveau plan de commission",
      "edit": "Modifier…",
      "fix": "Corriger ce plan",
      "saveDraft": "Enregistrer le brouillon",
      "check": "Vérifier",
      "onThisPlan": "Affiliés sur ce plan"
    },
    "assigned": {
      "title": "Attribué à",
      "empty": "Aucun affilié n'est sur ce plan.",
      "affiliate": "Affilié",
      "tenant": "Tenant",
      "status": "Statut",
      "tableAria": "Affiliés attribués à {{name}}",
      "loadError": "Impossible de charger les affiliés."
    },
    "limits": "Limites de {{card}} : récurrent jusqu’à {{pct}}, délai de carence jusqu’à {{days, number}} jours.",
    "limitsError": "Impossible de charger les limites de la grille tarifaire adoptée.",
    "noAgreement": "Ce revendeur a besoin d’un accord avant de pouvoir avoir des plans de commission.",
    "openAgreement": "Ouvrir l’onglet Accord",
    "empty": "Aucun plan de commission pour l’instant.",
    "tableAria": "Les plans de commission du revendeur",
    "loadError": "Impossible de charger les plans de commission de ce revendeur.",
    "col": {
      "name": "Nom",
      "mode": "Mode",
      "terms": "Conditions",
      "appliesTo": "S’applique à",
      "coolOff": "Délai de carence",
      "afterEnd": "Après la fin",
      "status": "Statut",
      "actions": "Actions"
    },
    "collapse": "Réduire {{name}}",
    "expand": "Développer {{name}}",
    "mode": {
      "SIMPLE": "Simple",
      "ADVANCED": "Avancé"
    },
    "appliesTo": {
      "BASE": "Prix de base",
      "ALL": "Toutes les lignes"
    },
    "afterEnd": {
      "STOP": "Arrêter",
      "HONOR": "Honorer"
    },
    "terms": {
      "life": "{{rate}} à vie",
      "oneMonth": "{{rate}} pendant 1 mois",
      "months_one": "{{rate}} pendant {{count, number}} mois",
      "months_other": "{{rate}} pendant {{count, number}} mois",
      "phases_one": "{{count, number}} phase : {{rates}}",
      "phases_other": "{{count, number}} phases : {{rates}}",
      "bounty": "{{amount}} au paiement {{n, number}}",
      "milestones_one": "{{count, number}} palier",
      "milestones_other": "{{count, number}} paliers",
      "perReferralCap": "Par parrainage, au plus {{amount}}",
      "perAffiliateMonthCap": "Par affilié et par mois, au plus {{amount}}"
    },
    "noncompliant": {
      "explanation": "Dépasse une limite depuis le {{date}}. Il ne peut plus être attribué à d’autres affiliés ; les affiliés qui l’ont le gardent."
    },
    "activate": {
      "confirm": "Activer {{name}} ? Un plan actif ne peut pas être modifié ; copiez-le pour le changer.",
      "title": "Activer {{name}} ?"
    },
    "close": {
      "confirm": "Fermer {{name}} ? Il ne pourra plus être attribué à d’autres affiliés ; les affiliés qui l’ont le gardent.",
      "title": "Fermer {{name}} ?"
    },
    "toast": {
      "created": "{{name}} est un nouveau brouillon. Modifiez-le, puis activez-le.",
      "copied": "{{name}} est un nouveau brouillon. Modifiez-le, puis activez-le.",
      "activated": "Plan activé. Il peut maintenant être attribué aux affiliés.",
      "closed": "{{name}} est fermé. Les affiliés qui l’ont le gardent.",
      "saved": "{{name}} enregistré. Activez-le quand il est prêt."
    },
    "errors": {
      "immutable": "Ce plan n’est plus un brouillon. Copiez-le pour le changer.",
      "nameTaken": "Un autre plan de ce revendeur s’appelle « {{name}} ».",
      "overLimit": "Ce plan dépasse une limite. Modifiez-le pour le corriger.",
      "create": "Impossible de créer le plan de commission.",
      "copy": "Impossible de copier le plan de commission.",
      "activate": "Impossible d’activer le plan de commission.",
      "close": "Impossible de fermer le plan de commission.",
      "save": "Impossible d’enregistrer le plan de commission."
    },
    "detail": {
      "phasesAria": "Phases de {{name}}",
      "currency": "Devise",
      "created": "Créé",
      "activated": "Activé",
      "closed": "Fermé",
      "noncompliantSince": "Dépasse une limite depuis",
      "fromMonth": "À partir du mois",
      "toMonth": "Jusqu’au mois",
      "rate": "Taux",
      "onward": "Et au-delà",
      "bounty": "Prime de parrainage",
      "onPayment": "au paiement {{n, number}}",
      "none": "Aucune",
      "noCap": "Pas de plafond",
      "perReferralCap": "Par parrainage",
      "perAffiliateMonthCap": "Par affilié et par mois",
      "milestones": "Paliers",
      "milestonesAria": "Paliers de {{name}}",
      "qualifiedReferrals": "Parrainages qualifiés",
      "bonus": "Prime"
    },
    "form": {
      "loadError": "Impossible de charger ce plan de commission.",
      "title": "Modifier {{name}}",
      "loadingTitle": "Plan de commission",
      "notDraft": "Seul un plan brouillon peut être modifié. Copiez-le pour faire des changements.",
      "rate": "Taux (%)",
      "months": "Nombre de mois",
      "schedule": "Calendrier",
      "phaseRate": "Taux de la phase {{n, number}} (%)",
      "phaseTo": "Phase {{n, number}} jusqu’au mois",
      "phaseFrom": "Phase {{n, number}} à partir du mois",
      "name": "Nom",
      "mode": "Mode",
      "appliesTo": "S’applique à",
      "coolOff": "Délai de carence (jours)",
      "afterEnd": "Après la fin de l’affilié",
      "rateRange": "Saisissez un taux de 0 à 100.",
      "nameRequired": "Le nom est obligatoire.",
      "nameLong": "Utilisez au plus {{max, number}} caractères.",
      "monthsRange": "Saisissez un nombre entier de mois, 1 ou plus.",
      "onlyLastOpen": "Seule la dernière phase peut être sans fin.",
      "toRange": "Saisissez un mois à partir de {{from, number}}.",
      "coolOffRange": "Saisissez un nombre entier de 0 à {{max, number}}.",
      "fixedFrom": "Copié de {{name}}. Ramenez-le dans les limites, activez-le, puis passez les affiliés dessus.",
      "warnMargin": "Un taux récurrent ne paie jamais plus que la marge du revendeur sur cette ligne. Au prix de notre gros, la commission récurrente est de 0.",
      "warnAnnual": "Les abonnements annuels sont commissionnés selon la phase de la date de paiement, sur le montant annuel entier.",
      "section": {
        "plan": "Plan",
        "terms": "Conditions",
        "advanced": "Prime de parrainage, paliers et plafonds"
      },
      "simpleBlocked": "Supprimez d’abord les phases en trop",
      "simpleBlockedEconomics": "Supprimez d’abord la prime de parrainage, les paliers et les plafonds",
      "leaveEmpty": "Laissez vide pour aucun",
      "appliesToBase": "Le prix de l’abonnement seulement.",
      "appliesToAll": "Base, places, comptes connectés et IA (jamais les taxes).",
      "afterEndStop": "Plus rien n’est gagné après la date de fin de l’affilié.",
      "afterEndHonor": "Les parrainages existants continuent de rapporter.",
      "duration": "Durée",
      "forMonths": "Pendant un nombre de mois",
      "forLife": "À vie",
      "phases": "Phases",
      "rowActions": "Supprimer",
      "removePhase": "Supprimer la phase {{n, number}}",
      "addPhase": "Ajouter une phase",
      "bounty": "Prime de parrainage",
      "bountyOnPayment": "Payée au paiement n° du parrainage",
      "bountyHelp": "Un montant unique, payé quand le parrainage effectue ce nombre de paiements de base, après le délai de carence. Annulée si un paiement est remboursé avant.",
      "bountyOnPaymentRange": "Saisissez un nombre entier de 1 à {{max, number}}.",
      "milestones": "Paliers",
      "milestonesHelp": "Payée une fois chacune quand le nombre de parrainages qualifiés de l’affilié (payés, délai de carence passé, encore abonnés) atteint le nombre pour la première fois, à la clôture du mois du revendeur.",
      "milestoneQualified": "Parrainages qualifiés du palier {{n, number}}",
      "milestoneBonus": "Prime de palier {{n, number}}",
      "qualifiedRange": "Saisissez un nombre entier, 1 ou plus.",
      "amountInvalid": "Saisissez un montant.",
      "addMilestone": "Ajouter un palier",
      "removeMilestone": "Supprimer le palier {{n, number}}",
      "perReferralCap": "Par parrainage, au plus",
      "perReferralCapHelp": "Le plus qu’un parrainage peut jamais rapporter à l’affilié.",
      "perAffiliateMonthCap": "Par affilié et par mois, au plus",
      "perAffiliateMonthCapHelp": "Le plus qu’un affilié peut gagner auprès de vous en un mois.",
      "noCap": "Pas de plafond",
      "upTo": "Jusqu’à {{amount}}.",
      "eachUpTo": "Chacun jusqu’à {{amount}}.",
      "warnNotLimited": "Les primes de parrainage et les paliers ne sont pas limités par la marge. Ils sont facturés dans le règlement mensuel du revendeur, et un mois négatif est facturé sur la carte du revendeur."
    },
    "preview": {
      "title": "Vérifier par rapport aux limites",
      "cardsError": "Impossible de charger les grilles tarifaires.",
      "card": "Grille pour l’exemple",
      "error": "Impossible de vérifier le plan.",
      "noCard": "Ajoutez une grille pour ce revendeur pour voir un exemple.",
      "loadingCards": "Chargement des grilles…",
      "fixFields": "Corrigez les champs en surbrillance pour vérifier ce plan.",
      "checking": "Vérification…",
      "empty": "Modifiez un champ ou choisissez Vérifier pour voir si le plan respecte les limites et ce qu’il verse.",
      "valid": "Ce plan respecte les limites.",
      "invalid": "Ce plan enfreint une limite ou une règle du calendrier. Chaque champ concerné dit pourquoi.",
      "noExample": "Corrigez le calendrier pour voir un exemple.",
      "exampleAria": "Exemple par mois",
      "exampleTitle": "Un abonné à {{amount}} par mois sur {{card}}",
      "exampleCaption": "Mois payés 1–24, le premier encaissé aujourd’hui. Payable après un délai de carence de {{days, number}} jours.",
      "col": {
        "month": "Mois",
        "collected": "Encaissé",
        "rate": "Taux",
        "commission": "Commission",
        "marginBefore": "Marge du revendeur avant",
        "marginAfter": "Marge du revendeur après",
        "payableOn": "Payable le",
        "bounty": "Prime de parrainage",
        "capped": "Plafonné"
      },
      "capped": "Plafonné"
    }
  },
  "affiliates": {
    "tabs": {
      "aria": "Sections de l'affilié"
    },
    "absent": "—",
    "filter": {
      "all": "Tous"
    },
    "list": {
      "title": "Affiliés",
      "help": "Les affiliés appartiennent à ce tenant et sont gérés par son revendeur. Vous pouvez les consulter, et en mettre un en pause ou y mettre fin pour motif.",
      "aria": "Affiliés",
      "empty": "Pas encore d’affiliés.",
      "filteredEmpty": "Aucun affilié ne correspond à ce filtre.",
      "loadError": "Impossible de charger les affiliés.",
      "filterAria": "Statut de l’affilié"
    },
    "col": {
      "name": "Nom",
      "email": "E-mail",
      "status": "Statut",
      "plan": "Plan",
      "referredActive": "Parrainages actifs",
      "last30": "30 derniers jours",
      "subscriber": "Abonné",
      "offer": "Offre",
      "since": "Depuis",
      "firstPaid": "Premier paiement",
      "thisPeriod": "Cette période",
      "code": "Code",
      "label": "Libellé",
      "link": "Lien",
      "week": "Semaine",
      "signups": "Inscriptions",
      "currency": "Devise",
      "revenue30": "Revenu parrainé, 30 jours",
      "revenueToDate": "Revenu parrainé, à ce jour",
      "commission30": "Commission, 30 jours",
      "commissionToDate": "Commission, à ce jour",
      "effective": "En vigueur",
      "ended": "Terminé",
      "cadence": "Cadence",
      "minimum": "Versement minimum",
      "method": "Méthode",
      "taxDocs": "Documents fiscaux"
    },
    "status": {
      "APPLIED": "Demandé",
      "ACTIVE": "Actif",
      "PAUSED": "En pause",
      "ENDED": "Terminé"
    },
    "referralStatus": {
      "ACTIVE": "Actif",
      "ENDED": "Terminé",
      "SUPERSEDED": "Remplacé",
      "VOIDED": "Annulé"
    },
    "codeStatus": {
      "ACTIVE": "Actif",
      "PAUSED": "En pause"
    },
    "plan": {
      "noAgreement": "Pas d’accord",
      "fallback": "Plan n° {{id}}",
      "noncompliant": "Au-dessus d’une limite. Il ne peut plus être attribué à d’autres affiliés ; ceux qui l’ont le gardent."
    },
    "last30": {
      "revenue": "de revenu",
      "commission": "de commission"
    },
    "held": {
      "chip": "Retenu pour examen"
    },
    "page": {
      "notFound": "Affilié introuvable",
      "loadError": "Impossible de charger cet affilié.",
      "copyId": "Copier l’ID {{id}}"
    },
    "dates": {
      "applied": "Demandé le {{date}}",
      "approved": "Approuvé le {{date}}",
      "ended": "Terminé le {{date}}",
      "effective": "En vigueur le {{date}}",
      "endedOn": "Terminé le {{date}}"
    },
    "stateChanged": "Le statut de cet affilié a changé",
    "pause": {
      "action": "Mettre en pause",
      "title": "Mettre {{name}} en pause ?",
      "words": "Les nouveaux parrainages ne sont plus attribués ; les existants continuent à rapporter.",
      "confirm": "Mettre en pause",
      "failed": "Impossible de mettre cet affilié en pause."
    },
    "resume": {
      "action": "Reprendre",
      "title": "Reprendre {{name}} ?",
      "words": "Les nouveaux parrainages peuvent de nouveau être attribués.",
      "confirm": "Reprendre",
      "failed": "Impossible de reprendre cet affilié."
    },
    "end": {
      "action": "Mettre fin pour motif…",
      "title": "Mettre fin à {{name}} pour motif",
      "words": "Y mettre fin ici arrête tout gain et retient la commission impayée pour examen. C’est irréversible.",
      "confirm": "Mettre fin pour motif",
      "failed": "Impossible de mettre fin à cet affilié."
    },
    "release": {
      "action": "Lever la retenue…",
      "title": "Lever la retenue",
      "words": "Libérer la commission impayée de {{name}} pour versement ?",
      "confirm": "Lever la retenue",
      "row": "Lever la retenue de {{name}}",
      "done": "Retenue levée. Les relevés impayés peuvent être versés.",
      "failed": "Impossible de lever la retenue."
    },
    "reason": {
      "label": "Motif",
      "length": "Utilisez de 3 à 500 caractères."
    },
    "hold": {
      "alert": "Versements retenus pour examen depuis le {{date}} : {{reason}} (par {{by}})"
    },
    "performance": {
      "title": "Performance",
      "aria": "Revenu parrainé et commission par devise",
      "empty": "Pas encore de revenu parrainé.",
      "summary_one": "{{active, number}} sur {{count, number}} abonné parrainé",
      "summary_other": "{{active, number}} sur {{count, number}} abonnés parrainés"
    },
    "earnings": {
      "title": "Gains",
      "aria": "Gains par mois en {{currency}}",
      "empty": "Pas encore de gains.",
      "loadError": "Impossible de charger les gains.",
      "col": {
        "month": "Mois",
        "recurring": "Récurrent",
        "bounty": "Prime de parrainage",
        "milestone": "Palier",
        "pending": "En attente",
        "payable": "Payable",
        "voided": "Annulé",
        "clawedBack": "Repris",
        "recovered": "Récupéré"
      }
    },
    "signups": {
      "title": "Inscriptions hebdomadaires",
      "aria": "Inscriptions hebdomadaires",
      "empty": "Pas encore d’inscriptions hebdomadaires."
    },
    "agreement": {
      "title": "Accord",
      "none": "Pas d’accord",
      "history": "Historique",
      "historyAria": "Historique de l’accord",
      "loadError": "Impossible de charger l’accord.",
      "inForceAria": "Accord en vigueur"
    },
    "referrals": {
      "title": "Parrainages",
      "aria": "Parrainages",
      "empty": "Pas encore de parrainages.",
      "filteredEmpty": "Aucun parrainage ne correspond à ce filtre.",
      "loadError": "Impossible de charger les parrainages.",
      "filterAria": "Statut du parrainage",
      "notYetPaid": "Pas encore payé"
    },
    "codes": {
      "title": "Codes",
      "aria": "Codes",
      "empty": "Pas encore de codes.",
      "loadError": "Impossible de charger les codes.",
      "copy": "Copier le lien de {{code}}"
    }
  },
  "partners": {
    "singular": "Partenaire",
    "new": "Nouveau partenaire…",
    "subtitle": "Les partenaires et leurs activités, réunis en un seul endroit.",
    "search": "Rechercher des partenaires",
    "searchPlaceholder": "Rechercher un partenaire ou slug",
    "searchHint": "Recherche dans le nom et le slug du partenaire",
    "empty": "Aucun partenaire pour le moment.",
    "emptySearch": "Aucun partenaire ne correspond à la recherche.",
    "noTenant": "Pas encore de tenant",
    "canSell": "Peut vendre",
    "createTenant": "Créer un tenant…",
    "createTenantSuspended": "Ce partenaire est suspendu. Réactivez-le avant de créer son tenant.",
    "createTenantDeactivated": "Ce partenaire est désactivé.",
    "createTenantHasTenant": "Ce partenaire possède déjà un tenant.",
    "notFound": "Partenaire introuvable",
    "loadingTitle": "Partenaire",
    "resolveError": "Impossible de trouver ce partenaire.",
    "tenantIdentity": "Tenant : {{name}} ({{slug}})",
    "perMonth": "par mois",
    "step1": "Étape 1 sur 2 — Créer le partenaire",
    "step2": "Étape 2 sur 2 — Créer le tenant",
    "tenantFailed": "Partenaire créé. Impossible de confirmer la création du tenant. Vérifiez la page du partenaire avant de réessayer.",
    "paletteFailed": "Impossible de rechercher les partenaires — réessayer",
    "searchList": "Rechercher dans la liste des partenaires",
    "scopeAll": "Tous les partenaires",
    "scope": "Partenaire : {{name}}",
    "number": "Partenaire n° {{id}}",
    "sectionsAria": "Sections du partenaire",
    "partnerAdministrators": {
      "caption": "Connectez-vous à la console revendeur pour gérer ce partenaire."
    },
    "tenantAdministrators": {
      "caption": "Connectez-vous à l’application du tenant pour gérer l’activité."
    },
    "section": {
      "overview": "Vue d’ensemble",
      "reports": "Rapports",
      "settings": "Réglages"
    },
    "caption": {
      "overview": "Qu’est-ce qui demande votre attention, et comment se porte ce partenaire ?",
      "reports": "Ce qui se passe, dans le temps.",
      "settings": "Comment ce partenaire est configuré."
    },
    "tab": {
      "overview": "Vue d’ensemble",
      "agreement": "Accord",
      "standing": "Situation",
      "billing": "Prélèvements",
      "settlements": "Règlements",
      "priceCard": "Grille tarifaire",
      "offers": "Offres",
      "promotions": "Promotions",
      "addons": "Modules complémentaires",
      "subscriptions": "Abonnements",
      "statements": "Relevés",
      "seats": "Places",
      "aiUsage": "Utilisation IA",
      "revenue": "Revenus",
      "deletions": "Suppressions",
      "affiliates": "Affiliés",
      "commissionPlans": "Plans de commission",
      "affiliatePayouts": "Versements aux affiliés",
      "partnerAdministrators": "Administrateurs du partenaire",
      "tenantAdministrators": "Administrateurs du tenant",
      "customers": "Clients",
      "domain": "Domaine",
      "ghl": "Connexion GHL",
      "payments": "Encaissement",
      "details": "Détails et marque",
      "cardOnFile": "Carte enregistrée",
      "ledger": "Solde et blocages",
      "notices": "Avis envoyés",
      "ledgerStatements": "Relevés",
      "ledgerUnassigned": "Lignes non affectées"
    },
    "sellableReason": {
      "NO_RESELLER": "Sans revendeur",
      "NO_AGREEMENT": "Sans accord",
      "NO_RATE_CARD": "Sans grille tarifaire",
      "CURRENCY_NOT_PRICED": "Devise non tarifée"
    },
    "searching": "Recherche de partenaires",
    "platformManaged": {
      "chip": "Géré par la plateforme",
      "alert": "Géré par la plateforme depuis le {{date}}. Les règlements sont conservés ; réactivez pour reprendre les versements."
    },
    "house": {
      "chip": "Interne",
      "mark": "Marquer comme partenaire interne…",
      "unmark": "Retirer le statut de partenaire interne…",
      "markTitle": "Marquer {{partner}} comme partenaire interne ?",
      "unmarkTitle": "Retirer à {{partner}} le statut de partenaire interne ?",
      "consequence": "Le partenaire interne nous appartient : il n’est jamais évalué ni désactivé.",
      "error": "Impossible de modifier le statut de partenaire interne.",
      "standingConflict": "Un partenaire en cours de désactivation ne peut pas devenir interne. Réactivez-le d’abord."
    },
    "creationWarning": {
      "openPayments": "Ouvrir Encaissement"
    },
    "group": {
      "standing": "Situation",
      "money": "Finances",
      "subscribers": "Abonnés",
      "affiliates": "Affiliés",
      "terms": "Conditions",
      "pricing": "Tarification",
      "profile": "Profil",
      "access": "Accès",
      "connections": "Connexions"
    },
    "needsYou": {
      "title": "Demande votre attention",
      "caption": "Ce qui bloque ce partenaire maintenant. Chaque élément ouvre l’endroit où le corriger.",
      "empty": "Rien ne demande votre attention pour le moment.",
      "checking": "Vérification de ce qui demande votre attention…",
      "count_one": ", {{count, number}} demande votre attention",
      "count_other": ", {{count, number}} demandent votre attention",
      "dot": " — demande votre attention",
      "openAgreement": "Ouvrir l’accord",
      "openCharges": "Ouvrir les prélèvements",
      "launch": {
        "title": "Lancement officiel non défini",
        "body": "Aucun mois n’est comparé au minimum tant qu’un mois de lancement n’est pas défini."
      },
      "charges": {
        "title_one": "{{count, number}} prélèvement peut être retenté",
        "title_other": "{{count, number}} prélèvements peuvent être retentés",
        "body": "Un prélèvement sur la carte de ce partenaire a échoué. Vous pouvez le retenter.",
        "loadError": "Impossible de vérifier les prélèvements de ce partenaire."
      }
    },
    "atAGlance": {
      "title": "En un coup d’œil",
      "caption": "Lecture seule. Ouvrez une carte pour voir son rapport."
    }
  },
  "aiReconciliation": {
    "from": "Du (UTC)",
    "to": "Au (UTC)",
    "range": {
      "order": "Le début doit être identique ou antérieur à la fin.",
      "tooLong": "Choisissez au plus 366 jours.",
      "refused": "Ces dates ne peuvent pas être affichées. Choisissez au plus 366 jours, avec un début identique ou antérieur à la fin."
    },
    "loadError": "Impossible de charger le rapprochement des coûts IA.",
    "empty": "Aucune ligne de rapprochement pour ces jours.",
    "regionAria": "Tableau du rapprochement des coûts IA",
    "tableAria": "Rapprochement des coûts IA",
    "mustBeZero": "doit être à 0",
    "shouldBeZero": "devrait être à 0",
    "legend": "† Doit être à 0.",
    "breached": "Dépassé",
    "col": {
      "day": "Jour",
      "currency": "Devise",
      "sent": "Envoyées",
      "settledActual": "Réglées à l’usage",
      "settledAtHold": "Réglées à la réservation",
      "holdExpiredCharged": "Réservation expirée, facturée",
      "providerRejected": "Refusées par le fournisseur",
      "providerRejectedAuth": "Refusées : authentification",
      "releasedAfterSend": "Libérées après l’envoi",
      "costOverHold": "Coût supérieur à la réservation",
      "sentUnsettled": "Envoyées, non réglées",
      "providerCost": "Coût du fournisseur",
      "customerUsage": "Usage client",
      "platformCost": "Coût payé par la plateforme",
      "reconciledAt": "Rapproché le",
      "truncated": "Tronquées",
      "refused": "Refusées"
    },
    "help": {
      "truncated": "Réponses coupées à la limite de jetons. Facturées selon leur utilisation.",
      "refused": "Demandes que le modèle a refusées."
    }
  },
  "cardSettings": {
    "controls": {
      "title": "Contrôles",
      "maxAiSpend": "Dépense IA maximale par personne et par mois",
      "maxAiSpendHelp": "Le maximum qu’une personne peut dépenser en IA sur un mois. La limite plus basse que la personne s’est fixée s’applique toujours.",
      "aiDailyCap": "Plafond IA quotidien",
      "aiDailyCapHelp": "Le nombre maximal d’appels IA qu’une personne peut faire en un jour.",
      "aiMaxInflight": "Appels IA simultanés",
      "aiMaxInflightHelp": "Combien d’appels IA une personne peut avoir en cours en même temps.",
      "autoRecharges": "Recharges automatiques par 30 jours",
      "autoRechargesHelp": "0 signifie que le portefeuille ne se recharge jamais seul ; la personne recharge à la main.",
      "graceDays": "Jours de grâce après la fin d’un abonnement",
      "graceDaysHelp": "Lu au début de la période de grâce. Un abonnement déjà en période de grâce garde sa date de fin.",
      "reviewSuggested": "Cette grille tarifaire n’est pas en USD et a encore la dépense IA maximale de départ. Vérifiez-la et planifiez le bon montant.",
      "affiliateRecurringMax": "Taux récurrent maximal des affiliés",
      "affiliateRecurringMaxHelp": "Le taux le plus élevé dans une phase d'un plan de commission du revendeur. Vérifié à la création ou à l'activation d'un plan ; les plans actifs ne changent pas.",
      "affiliateBountyMax": "Prime de parrainage maximale",
      "affiliateBountyMaxHelp": "La prime de parrainage la plus élevée qu'un plan de commission peut offrir par filleul.",
      "affiliateMilestoneMax": "Prime de palier maximale",
      "affiliateMilestoneMaxHelp": "La prime de palier la plus élevée qu'un plan de commission peut offrir.",
      "affiliateCoolOffMax": "Délai de carence maximal des affiliés",
      "affiliateCoolOffMaxHelp": "Le délai de carence le plus long, en jours, qu'un plan de commission peut fixer."
    }
  },
  "platformAiControls": {
    "title": "Contrôles IA de la plateforme",
    "help": "L’IA de l’assistant de domaine est payée par la plateforme. Ces plafonds la limitent.",
    "resellerDaily": "Appels IA de configuration de domaine par revendeur et par jour",
    "platformDaily": "Appels IA de configuration de domaine sur toute la plateforme par jour"
  },
  "datedSettings": {
    "current": "En vigueur",
    "inEffectSince": "En vigueur depuis {{when}}",
    "setBy": "Défini par {{who}}",
    "noteLine": "Note : {{note}}",
    "scheduled": "Planifiés",
    "noneScheduled": "Aucun changement planifié.",
    "scheduledAria": "{{title}} : changements planifiés",
    "history": "Historique",
    "noHistory": "Aucun réglage antérieur.",
    "historyAria": "{{title}} : historique",
    "withdraw": "Retirer…",
    "withdrawRow": "Retirer le changement qui commence le {{when}}",
    "withdrawn": "Retiré",
    "withdrawnBy": "par {{who}}",
    "past": "Passé",
    "schedule": "Planifier un changement…",
    "scheduleTitle": "Planifier un changement : {{title}}",
    "withdrawTitle": "Retirer un changement planifié",
    "withdrawConsequence": "Retirer le changement qui commence le {{when}} ?",
    "withdrawConfirm": "Retirer",
    "form": {
      "required": "Obligatoire.",
      "tooLong": "Utilisez au plus {{max, number}} caractères.",
      "between": "Doit être entre {{min, number}} et {{max, number}}.",
      "atLeast": "Doit être au moins {{min, number}}.",
      "atMost": "Doit être au plus {{max, number}}.",
      "number": "Saisissez un nombre.",
      "whole": "Doit être un nombre entier.",
      "whenRequired": "Choisissez une date et une heure.",
      "when": "Quand",
      "now": "Maintenant",
      "at": "À partir d’une date et d’une heure",
      "date": "Date (UTC)",
      "time": "Heure (UTC)",
      "note": "Note (facultative)",
      "submit": "Planifier"
    },
    "errors": {
      "taken": "Un autre changement commence déjà à cette heure. Choisissez une autre heure.",
      "future": "Doit être dans le futur. Choisissez Maintenant pour l’appliquer tout de suite.",
      "notLater": "Choisissez une heure postérieure à maintenant (UTC), ou choisissez Maintenant.",
      "schedule": "Impossible de planifier ce changement.",
      "notFound": "Ce réglage est introuvable.",
      "inEffect": "Ce changement est déjà en vigueur, il ne peut donc pas être retiré. La liste a été rechargée.",
      "rowInForce": "Ce réglage est déjà en vigueur et ne peut pas être retiré. Planifiez plutôt une nouvelle valeur.",
      "lastRow": "C’est la seule ligne de ce réglage, elle ne peut donc pas être retirée.",
      "withdraw": "Impossible de retirer ce changement."
    },
    "loadError": "Impossible de charger ces réglages.",
    "col": {
      "starts": "Début",
      "setBy": "Défini par",
      "note": "Note",
      "actions": "Actions",
      "status": "Statut"
    }
  },
  "rateCard": {
    "prices": {
      "readOnly": "Une version publiée est en lecture seule. Utilisez Nouvelle version… pour modifier ses prix.",
      "editTitle": "Prix de la version {{version, number}}",
      "ourCost": "Notre coût",
      "wholesale": "Gros",
      "retail": "Détail",
      "annualWholesale": "Gros par an",
      "annualRetail": "Détail par an",
      "guestsIncluded": "Invités inclus",
      "perGuestCost": "Notre coût par invité",
      "perGuestWholesale": "Gros par invité",
      "perGuestRetail": "Détail par invité",
      "connectionsIncluded": "Connexions bancaires incluses",
      "perConnectionCost": "Notre coût par connexion",
      "perConnectionWholesale": "Gros par connexion",
      "perConnectionRetail": "Détail par connexion",
      "aiWholesaleMarkup": "Majoration de gros sur le coût du fournisseur (%)",
      "aiRetailMarkup": "Majoration de détail sur le prix de gros (%)",
      "creditAtCost": "Crédit IA mensuel, à notre coût",
      "creditAtRetail": "Crédit IA mensuel, au prix client",
      "creditShare": "Part du crédit que nous prenons en charge (%)",
      "rechargeAmount": "Montant de recharge du portefeuille",
      "help": {
        "ourCost": "Ce qu'un abonné nous coûte chaque mois. Seul l'administrateur du produit le voit ; une perte est permise et apparaît dans la feuille de calcul.",
        "wholesale": "Ce que le revendeur nous paie chaque mois pour un abonné.",
        "retail": "Ce que le client paie chaque mois.",
        "annualWholesale": "Ce que le revendeur nous paie pour un forfait annuel.",
        "annualRetail": "Ce que le client paie pour un an. Laissez vide pour proposer le mensuel uniquement.",
        "included": "Combien sont gratuits pour le client et pour le revendeur. Nous prenons leur coût en charge.",
        "unitCost": "Ce que chacun nous coûte, inclus ou non.",
        "unitWholesale": "Ce que le revendeur nous paie pour chacun au-delà des inclus.",
        "unitRetail": "Ce que le client paie pour chacun au-delà des inclus.",
        "aiWholesaleMarkup": "Notre majoration sur le coût du fournisseur d'IA : le prix de l'IA pour le revendeur.",
        "aiRetailMarkup": "La majoration sur le prix de gros de l'IA : le prix de l'IA pour le client.",
        "credit": "L'IA que le client reçoit chaque mois. Fixez-la au prix client ou selon ce qu'elle nous coûte ; nous convertissons notre coût avec les majorations et enregistrons le prix client.",
        "creditShare": "La part du crédit que nous prenons en charge. Le revendeur prend en charge le reste."
      },
      "tiered": "Cette version a des tranches progressives. Elles sont affichées en lecture seule et l'enregistrement les conserve telles quelles.",
      "section": {
        "base": "Base, par mois",
        "annual": "Base, par an",
        "guests": "Invités",
        "connections": "Connexions bancaires"
      },
      "annualCostNote": "Notre coût annuel est le coût mensuel × 12 ; la feuille de calcul l’utilise.",
      "creditBy": "Fixer le crédit mensuel selon",
      "creditByRetail": "Prix client",
      "creditByCost": "Notre coût",
      "creditCostCaption": "Nous convertissons notre coût avec les majorations ci-dessus. Enregistré actuellement : {{amount}} au prix client.",
      "creditRetailCaption": "Le crédit au prix client.",
      "bandsAria": "Tranches",
      "bandFrom": "De",
      "bandTo": "À",
      "bandRetail": "Détail forfait + par unité",
      "bandWholesale": "Gros forfait + par unité",
      "bandCost": "Notre coût forfait + par unité",
      "bandOpen": "et plus",
      "summaryAria": "Prix",
      "line": "Ligne",
      "aiSummary": "IA : majoration de gros de {{wholesale}} sur le coût du fournisseur, majoration de détail de {{retail}} sur le prix de gros. Crédit mensuel de {{credit}} au prix client ; nous prenons en charge {{share}}.",
      "rule": {
        "notNegative": "Doit être supérieur ou égal à zéro.",
        "checkBand": "Vérifiez les prix de cette tranche.",
        "wholesale": "Doit être supérieur à zéro et ne pas dépasser le prix de détail.",
        "aboveZero": "Doit être supérieur à zéro."
      }
    },
    "grid": {
      "perGuestOver": "Par invité au-delà de {{n, number}}",
      "perConnectionOver": "Par connexion au-delà de {{n, number}}",
      "monthly": "Mensuel",
      "annual": "Annuel"
    },
    "singular": "Grille tarifaire",
    "notFound": "Cette grille tarifaire est introuvable.",
    "loadError": "Impossible de charger cette grille tarifaire.",
    "draftOnly": "brouillon",
    "actions": {
      "publishVersion": "Publier la version {{version, number}}…",
      "worksheet": "Feuille de calcul",
      "editPrices": "Modifier les prix…"
    },
    "tabs": {
      "aria": "Sections de la grille tarifaire",
      "worksheet": "Feuille de calcul",
      "prices": "Prix",
      "resellers": "Revendeurs"
    },
    "versionPicker": "Version",
    "publishRefused": "La version {{version, number}} ne peut pas encore être publiée. Corrigez les prix signalés, enregistrez le brouillon, puis publiez.",
    "publishRefusedOther": "Certaines des vérifications en échec n'ont pas de champ sur cette page.",
    "toast": {
      "saved": "Prix enregistrés."
    },
    "grant": {
      "error": "Impossible d’accorder cette grille tarifaire."
    },
    "resellers": {
      "adoptHint": "Un revendeur adopte une grille accordée sur sa page partenaire."
    },
    "list": {
      "subtitle": "Chaque grille contient notre coût, le prix de gros et le prix de détail. Accordez-la aux revendeurs ; chaque revendeur en adopte une.",
      "filterAria": "Statut de la grille tarifaire",
      "filter": {
        "active": "Actives",
        "drafts": "Brouillons",
        "all": "Toutes"
      },
      "search": "Rechercher par nom",
      "loadError": "Impossible de charger les grilles tarifaires.",
      "filteredEmpty": "Aucune grille tarifaire ne correspond. Essayez Toutes ou un autre nom.",
      "add": "Ajouter une grille tarifaire",
      "cardLink": "{{name}}, {{currency}} · {{versionLabel}}",
      "notGranted": "Pas encore accordée",
      "resellers": "{{granted, number}} accordées, {{adopted, number}} adoptées",
      "pillAdopted": "{{name}} (adopté)",
      "pillGranted": "{{name}}"
    },
    "create": {
      "nameClash": "Une autre grille tarifaire porte ce nom.",
      "error": "Impossible de créer la grille tarifaire.",
      "hint": "Le premier brouillon s’ouvre sur Prix, où vous fixez notre coût, le prix de gros et le prix de détail.",
      "setControls": "Définir les contrôles maintenant",
      "controlsOn": "Prérempli avec les valeurs standard. Un champ laissé vide prend la valeur standard.",
      "controlsOff": "La grille tarifaire démarre avec les contrôles standard. Vous pouvez programmer un changement dans son onglet Contrôles."
    },
    "worksheet": {
      "subscriber": "Un abonné hypothétique",
      "mode": "Mode de facturation",
      "monthly": "Mensuel",
      "annual": "Annuel",
      "noAnnual": "Cette version n'a pas de prix annuel.",
      "guests": "Invités",
      "countRange": "Un nombre entier de 0 à 50.",
      "connections": "Comptes bancaires connectés",
      "aiUsed": "IA utilisée par mois (prix client)",
      "updating": "Mise à jour de la feuille de calcul",
      "loadError": "Impossible de calculer cette feuille de calcul.",
      "fixInputs": "Corrigez les données pour voir la feuille de calcul.",
      "billYearly": "La facture du client (facturée annuellement)",
      "billMonthly": "La facture du client (facturée mensuellement)",
      "billAria": "La facture du client",
      "col": {
        "line": "Ligne",
        "quantity": "Qté",
        "amount": "Montant",
        "unitPrice": "Prix unitaire"
      },
      "line": {
        "BASE": "Base",
        "GUESTS": "Invités",
        "CONNECTIONS": "Connexions bancaires",
        "SUBSCRIPTION_PROCESSING": "Frais de carte sur l'abonnement",
        "AI_PAID": "IA payée par le client",
        "AI_CREDIT": "IA couverte par le crédit",
        "RECHARGE_PROCESSING": "Frais de carte sur les recharges",
        "TOTAL": "Total"
      },
      "charge": {
        "BASE": "Forfait de base",
        "ADD_ONS": "Invités et connexions",
        "RECHARGE": "Recharge du portefeuille"
      },
      "steps": "Comment c’est calculé",
      "chargesPerYear": "Prélèvements d'abonnement par an : {{n, number}}.",
      "chargeLine": "{{kind}} : {{gross}} prélevés {{perYear, number}} fois par an. Frais de carte {{fee}} : le revendeur paie {{reseller}}, nous payons {{platform}}.",
      "noRate": "Aucun taux de frais de carte n'est défini pour {{currency}}, donc aucun frais n'est compté.",
      "rate": "Frais de carte : {{percent}} + {{fixed}} par prélèvement.",
      "recharges": "Recharges automatiques du portefeuille par mois : {{n, number}}.",
      "creditCost": "Le crédit IA mensuel nous coûte {{amount}}.",
      "customerPays": "Le client paie",
      "resellerProfit": "Bénéfice du revendeur",
      "ourProfit": "Notre bénéfice",
      "profitPercent": "{{percent}} de ce que paie le client",
      "earningsAnnual": "Qui gagne quoi, par mois (le forfait annuel ÷ 12)",
      "earnings": "Qui gagne quoi, par mois",
      "earningsAria": "Qui gagne quoi, par ligne",
      "resellerCosts": "Coûts du revendeur",
      "ourCost": "Notre coût",
      "note": "Bénéfice du revendeur = ce que paie le client + coûts du revendeur. Notre bénéfice = le prix de gros que nous paie le revendeur + notre coût. La commission des affiliés sort du bénéfice du revendeur.",
      "bill": {
        "BASE": "Abonnement de base",
        "BASE_YEAR": "Abonnement de base, 1 an",
        "GUESTS": "Invités",
        "GUESTS_YEAR": "Invités, 12 mois",
        "CONNECTIONS": "Connexions bancaires",
        "CONNECTIONS_YEAR": "Connexions bancaires, 12 mois",
        "AI_USAGE": "Utilisation de l’IA ce mois-ci (portefeuille)",
        "AI_CREDIT": "Crédit IA mensuel",
        "flatAndUnit": "{{flat}} + {{unit}} l’unité",
        "subtotalMonth": "Abonnement, par mois",
        "subtotalYear": "Abonnement, par an",
        "aiNet": "IA payée depuis le portefeuille, par mois"
      }
    },
    "status": {
      "active": "Active",
      "closed": "Fermée",
      "draft": "Brouillon"
    },
    "searchFailed": "Impossible de rechercher les grilles tarifaires — réessayez",
    "searching": "Recherche des grilles tarifaires",
    "publishRefusedNoField": "La version {{version, number}} ne peut pas encore être publiée.",
    "violations": {
      "summary_one": "Cette version a {{count, number}} problème ; la publication sera refusée tant que vous ne l’aurez pas corrigé.",
      "summary_other": "Cette version a {{count, number}} problèmes ; la publication sera refusée tant que vous ne les aurez pas corrigés.",
      "chip_one": "{{count, number}} problème",
      "chip_other": "{{count, number}} problèmes",
      "item": "{{label}} : {{message}}",
      "band": "{{section}}, tranche {{n, number}}",
      "other": "Un autre prix de cette version",
      "summaryPublished_one": "Cette version enfreint {{count, number}} règle de publication. Elle reste en vente ; corrigez-la dans une nouvelle version.",
      "summaryPublished_other": "Cette version enfreint {{count, number}} règles de publication. Elle reste en vente ; corrigez-les dans une nouvelle version.",
      "checkValue": "Vérifiez cette valeur."
    }
  },
  "ledger": {
    "title": "Grand livre",
    "notAvailable": "Le grand livre du partenaire n'est pas encore disponible.",
    "loadError": "Impossible de charger le grand livre.",
    "payeeLoadError": "Impossible de lire le bénéficiaire de ce partenaire.",
    "noPayee": "Ce partenaire n'est pas encore configuré comme bénéficiaire.",
    "noPayeeLink": "Voir le statut du bénéficiaire",
    "loadMore": "Charger plus",
    "currency": "Devise",
    "amount": {
      "label": "Montant",
      "invalid": "Saisissez un montant supérieur à zéro, sans plus de décimales que n'en a la devise."
    },
    "reason": {
      "label": "Motif",
      "help": "Enregistré dans le journal d'audit.",
      "length": "Utilisez de 3 à 500 caractères."
    },
    "summary": {
      "title": "Solde et blocages",
      "balance": "Solde :"
    },
    "holds": {
      "title": "Blocages ouverts",
      "none": "Aucun blocage ouvert.",
      "overCap": "au-dessus du plafond",
      "since": "depuis le {{date}}"
    },
    "last": {
      "title": "Dernier relevé",
      "none": "Aucun relevé n'a encore été clôturé."
    },
    "statements": {
      "title": "Relevés",
      "empty": "Aucun relevé pour le moment.",
      "loadError": "Impossible de charger les relevés.",
      "open": "Ouvrir le relevé",
      "openRow": "Ouvrir le relevé de {{period}}",
      "col": {
        "period": "Période",
        "status": "Statut",
        "opening": "Ouverture",
        "lines": "Lignes",
        "closing": "Clôture",
        "paid": "Payé le",
        "actions": "Actions"
      }
    },
    "statement": {
      "title": "Relevé de {{period}}",
      "titleLoading": "Relevé",
      "notFound": "Ce relevé n'est pas disponible.",
      "loadError": "Impossible de charger le relevé.",
      "paidOn": "Payé le {{date}}",
      "noLines": "Ce relevé n'a aucune ligne.",
      "close": "Fermer le relevé"
    },
    "unassigned": {
      "title": "Lignes non affectées",
      "help": "Lignes qu'aucun relevé n'a encore reprises. Le prochain relevé les reprend.",
      "empty": "Aucune ligne non affectée."
    },
    "lines": {
      "loadError": "Impossible de charger les lignes.",
      "col": {
        "date": "Date",
        "kind": "Type",
        "description": "Description",
        "amount": "Montant"
      },
      "reverses": "Annule la ligne {{id}}"
    },
    "statementStatus": {
      "CARRIED": "Reporté",
      "HELD": "Bloqué",
      "NEGATIVE": "Négatif",
      "PAYABLE": "Payable",
      "PAYOUT_FAILED": "Versement échoué",
      "COLLECTING": "Recouvrement en cours",
      "PAYING": "Paiement en cours",
      "PAID": "Payé",
      "PAID_EXTERNALLY": "Payé en externe",
      "COLLECTED": "Recouvré",
      "SETTLED": "Soldé"
    },
    "holdKind": {
      "FOR_CAUSE": "Pour motif grave",
      "REVIEW": "Examen",
      "TAX_ID_UNVERIFIED": "Identifiant fiscal non vérifié",
      "PAYOUT_RETURNED": "Versement retourné",
      "OTHER": "Autre : {{kind}}",
      "COLLECTION_CONFLICT": "Conflit de recouvrement"
    },
    "lineKind": {
      "REVENUE_SHARE": "Partage des revenus",
      "MARGIN": "Marge",
      "AFFILIATE_COMMISSION": "Commission d'affilié",
      "COMMISSION_DEDUCTION": "Déduction de commission",
      "PROCESSING_FEE": "Frais de traitement",
      "AFFILIATE_BONUS": "Prime d'affilié",
      "MINIMUM_SHORTFALL": "Manque au minimum",
      "ADJUSTMENT": "Ajustement",
      "REVERSAL": "Contre-passation",
      "VOID": "Annulation",
      "PAYOUT": "Versement",
      "PAYOUT_MANUAL": "Paiement manuel",
      "PAYOUT_RETURNED": "Versement retourné",
      "COLLECTION": "Recouvrement"
    },
    "mode": {
      "OFF": "Désactivé",
      "SHADOW": "Fantôme",
      "LIVE": "En production"
    },
    "hold": {
      "action": "Bloquer pour motif grave…",
      "title": "Bloquer les versements de {{name}} pour motif grave ?",
      "words": "Aucun versement n'a lieu tant que le blocage est ouvert, et les relevés clôturés entre-temps sont bloqués. Levez-le une fois le motif résolu.",
      "confirm": "Bloquer les versements",
      "failed": "Impossible d'ouvrir le blocage.",
      "done": "Versements bloqués pour motif grave."
    },
    "release": {
      "action": "Lever…",
      "title": "Lever le blocage « {{kind}} » sur les versements de {{name}} ?",
      "words": "Les versements que le blocage retenait pourront reprendre au prochain versement.",
      "confirm": "Lever le blocage",
      "failed": "Impossible de lever le blocage.",
      "opsOnly": "Seules les opérations peuvent lever ce blocage ; il est en file d'attente.",
      "notReleasable": "Ce blocage ne peut pas être levé ici : un examen au-dessus du plafond de virement est levé par les opérations, et un blocage d'identifiant fiscal se lève de lui-même une fois l'identifiant vérifié.",
      "done": "Blocage levé."
    },
    "void": {
      "action": "Annuler…",
      "title": "Annuler le solde de {{name}} ?",
      "words": "Le solde positif du partenaire est annulé et ne sera pas versé. Les lignes déjà payées ne sont pas modifiées. C'est irréversible. Le blocage reste ouvert jusqu'à ce que vous le leviez.",
      "typeName": "Saisissez {{name}} pour confirmer",
      "confirm": "Annuler le solde",
      "mismatch": "Le nom ne correspond pas. Saisissez le nom du partenaire tel qu’il apparaît.",
      "failed": "Impossible d'annuler le solde.",
      "done": "Solde annulé."
    },
    "payment": {
      "action": "Enregistrer un paiement manuel…",
      "title": "Enregistrer un paiement manuel à {{name}}",
      "words": "Enregistrez un paiement effectué hors de pay-api. Le relevé est marqué payé en externe.",
      "statement": "Relevé",
      "reference": "Pour référence : clôture",
      "balance": "solde",
      "paidOn": "Payé le",
      "paidOnRequired": "Saisissez la date du paiement.",
      "referenceLabel": "Référence du paiement",
      "referenceRequired": "Saisissez la référence du paiement.",
      "payableIs": "Le montant payable sur ce relevé est de {{amount}}.",
      "notPayable": "Ce montant ne peut pas être payé sur ce relevé. Il peut être au plus la dernière clôture ou le solde, selon le plus bas.",
      "confirm": "Enregistrer le paiement",
      "failed": "Impossible d'enregistrer le paiement.",
      "done": "Paiement manuel enregistré."
    },
    "adjustment": {
      "action": "Passer un ajustement…",
      "title": "Passer un ajustement pour {{name}}",
      "words": "Un ajustement corrige le solde du partenaire. Il remplace l'exonération d'un prélèvement et son marquage comme recouvré.",
      "direction": "Sens",
      "credit": "Créditer le partenaire (ajoute à son solde)",
      "charge": "Débiter le partenaire (retire de son solde)",
      "directionRequired": "Choisissez crédit ou débit.",
      "continue": "Continuer",
      "back": "Retour",
      "confirmCreditTitle": "Créditer {{name}} de {{amount}} ?",
      "confirmChargeTitle": "Débiter {{name}} de {{amount}} ?",
      "confirmCreditWords": "Cela ajoute {{amount}} au solde de {{name}}. Il est passé comme ajustement et audité.",
      "confirmChargeWords": "Cela retire {{amount}} du solde de {{name}}. Il est passé comme ajustement et audité.",
      "post": "Passer l'ajustement",
      "failed": "Impossible de passer l'ajustement.",
      "done": "Ajustement passé."
    },
    "frozen": {
      "banner": "Ceci est l'historique d'avant le grand livre des partenaires.",
      "link": "Utilisez le grand livre du partenaire.",
      "open": "Ouvrir le grand livre"
    },
    "cutover": {
      "title": "Bascule vers le grand livre",
      "notAvailable": "La bascule vers le grand livre n'est pas encore disponible.",
      "loadError": "Impossible de charger l’état de préparation de la bascule.",
      "mode": "Mode du grand livre : {{mode}}",
      "modeHelp": "Passer en LIVE est un changement d'environnement de l'Opérateur sur les deux wars de tmm-api.",
      "readiness": "Préparation",
      "passed": "Réussi",
      "failing": "Non rempli",
      "failures": "Pas prêt : {{names}}",
      "refused": "Pas encore : la préparation ci-dessus indique ce qui manque.",
      "outbox": "Lignes en attente dans la file d'envoi : {{periods}}",
      "outboxNone": "Aucune ligne en attente dans la file d'envoi.",
      "check": {
        "A2_CONFIRMED": "A2 de pay-api confirmée en production",
        "OLD_STATEMENTS_SETTLED": "Le dernier ancien relevé généré et payé",
        "PAYEES_READY": "Chaque partenaire configuré comme bénéficiaire",
        "OPENING_COMPUTED": "Ajustements d'ouverture calculés",
        "DEACTIVATION_WINDOWS_RESOLVED": "Fenêtres de désactivation résolues"
      },
      "checkHint": {
        "DEACTIVATION_WINDOWS_RESOLVED": "Les lignes du grand livre dans la fenêtre de désactivation d'un revendeur ont été reconstruites."
      },
      "notReadyYet": "Pas encore prêt :",
      "failureKind": {
        "REFUND_OF_COVERED_SALE": "Un remboursement d'une vente que l'ouverture compte déjà.",
        "CLAWBACK": "Une commission reprise.",
        "RECOVERY": "Un recouvrement.",
        "UNPOSTED_PAYMENT": "Un paiement qui n'est pas encore passé.",
        "UNPOSTED_COMMISSION": "Une commission qui n'est pas encore passée.",
        "UNPOSTED_SHORTFALL": "Un manque au minimum qui n'est pas encore passé.",
        "NETTING_ADDON": "Un module complémentaire en déduction.",
        "SENT_BEFORE": "Envoyé avant la bascule.",
        "MISMATCH": "Le rapprochement ne concorde pas.",
        "NO_PAYEE": "Aucun bénéficiaire n'est configuré pour ce partenaire.",
        "OTHER_CURRENCY": "Une ligne dans une autre devise.",
        "TENANT_WITHOUT_RESELLER": "Le tenant de ce partenaire n'a pas encore de revendeur. Corrigez le tenant, puis relancez l'aperçu."
      },
      "openingFailures": {
        "intro": "Pour chaque ligne, passez un ajustement pour ce partenaire, puis relancez l'aperçu.",
        "table": "Échecs du contrôle d'ouverture",
        "col": {
          "partner": "Partenaire",
          "what": "Quoi",
          "source": "Source",
          "amount": "Montant"
        }
      },
      "a2": {
        "action": "Confirmer que A2 de pay-api est en production…",
        "title": "Confirmer que A2 de pay-api est en production ?",
        "words": "Confirmez seulement après avoir vérifié que la version A2 de pay-api est en production. C’est audité.",
        "confirm": "Confirmer A2",
        "failed": "Impossible d'enregistrer la confirmation.",
        "done": "A2 de pay-api confirmée.",
        "recorded": "A2 de pay-api confirmée le {{when}}"
      },
      "freeze": {
        "action": "Geler la machinerie de versement de tmm…",
        "title": "Geler la machinerie de versement de tmm ?",
        "words": "Les virements, la clôture et l'exécution des versements, et le prélèvement des déficits et manques s'arrêtent, avec leurs nouvelles tentatives. Rien n'est supprimé. Le relancer ne change rien.",
        "confirm": "Geler les versements",
        "failed": "Impossible de geler la machinerie de versement.",
        "done": "Machinerie de versement gelée.",
        "recorded": "Machinerie de versement gelée le {{when}}"
      },
      "verticals": {
        "action": "Confirmer que tmm-api est dans les verticales actives de pay-api…",
        "title": "Confirmer que tmm-api est dans les verticales actives de pay-api ?",
        "words": "Confirmez seulement quand tmm-api est dans PAYAPI_SETTLEMENT_LIVE_VERTICALS sur les deux wars de pay-api. tmm-api ne peut pas lire ce paramètre. C’est audité.",
        "confirm": "Confirmer les verticales actives",
        "failed": "Impossible d'enregistrer la confirmation.",
        "done": "Verticales actives confirmées.",
        "recorded": "Verticales actives confirmées le {{when}}"
      },
      "opening": {
        "title": "Ajustements d'ouverture",
        "help": "L'ouverture de chaque partenaire est le solde reporté sur le dernier relevé payé de tmm. Prévisualisez-la d'abord ; rien n'est passé tant que vous ne le passez pas.",
        "preview": "Aperçu",
        "previewFailed": "Impossible de prévisualiser les ajustements d'ouverture.",
        "post": "Passer les ajustements d'ouverture…",
        "confirmTitle": "Passer les ajustements d'ouverture ?",
        "confirmWords": "Un ajustement d'ouverture est passé pour chaque partenaire, au montant que tmm-api calcule au moment où vous le passez ; l'aperçu montre ces montants à cet instant. C'est audité et passé une seule fois.",
        "confirm": "Passer les ajustements",
        "failed": "Impossible de passer les ajustements d'ouverture.",
        "done": "Ajustements d'ouverture passés.",
        "recorded": "Ajustements d'ouverture passés le {{when}}",
        "posted": "Passé.",
        "dryRun": "Aperçu uniquement : rien n'a été passé.",
        "none": "Aucun partenaire n'a de montant d'ouverture.",
        "matches": "Concordant",
        "mismatch": "Écart constaté",
        "col": {
          "partner": "Partenaire",
          "figure": "Ouverture",
          "reconciliation": "Rapprochement",
          "expected": "Ancien système",
          "ledger": "Grand livre"
        }
      }
    }
  },
  "tickets": {
    "subtitle": "Demandes d’assistance, demandes de fonctionnalités et annonces pour les membres de tous les tenants.",
    "tabsAria": "Sections de l’assistance",
    "tab": {
      "support": "Demandes d’assistance",
      "features": "Demandes de fonctionnalités",
      "announcements": "Annonces"
    },
    "filter": {
      "search": "Rechercher des tickets",
      "searchHint": "Recherche dans le titre et la description",
      "status": "Statut",
      "allStatuses": "Tous les statuts",
      "tenant": "Tenant",
      "allTenants": "Tous les tenants",
      "created": "Créé"
    },
    "created": {
      "ANY": "Toutes les dates",
      "LAST_7_DAYS": "7 derniers jours",
      "LAST_30_DAYS": "30 derniers jours",
      "LAST_90_DAYS": "90 derniers jours"
    },
    "loadError": "Impossible de charger les tickets.",
    "empty": {
      "support": "Aucune demande d’assistance.",
      "features": "Aucune demande de fonctionnalité."
    },
    "regionAria": "Liste des tickets",
    "col": {
      "number": "Numéro",
      "title": "Titre",
      "tenant": "Tenant",
      "requester": "Demandeur",
      "status": "Statut",
      "followers": "Abonnés",
      "created": "Créé",
      "updated": "Mis à jour"
    },
    "status": {
      "OPEN": "Ouvert",
      "IN_PROGRESS": "En cours",
      "WAITING_ON_YOU": "En attente du membre",
      "RESOLVED": "Résolu",
      "CLOSED": "Fermé",
      "SUBMITTED": "Soumise",
      "UNDER_REVIEW": "En examen",
      "PLANNED": "Planifiée",
      "SHIPPED": "Livrée",
      "NOT_PLANNED": "Non planifiée",
      "DUPLICATE": "Doublon"
    },
    "type": {
      "SUPPORT_CASE": "Demande d’assistance",
      "FEATURE_REQUEST": "Demande de fonctionnalité"
    },
    "notAvailable": "Les tickets ne sont pas encore disponibles.",
    "notFound": "Ce ticket n’existe pas.",
    "ticket": "Ticket",
    "ticketLoadError": "Impossible de charger ce ticket.",
    "internalNote": "Note interne : le membre ne la voit jamais.",
    "composer": {
      "title": "Ajouter à la conversation",
      "visibility": "Qui la voit",
      "internal": "Note interne",
      "public": "Répondre au membre",
      "publicWarning": "Le membre reçoit cette réponse par e-mail.",
      "noteLabel": "Note",
      "replyLabel": "Réponse",
      "counter": "{{used, number}} sur {{max, number}} caractères",
      "required": "Écrivez quelque chose à publier.",
      "tooLong": "{{max, number}} caractères au maximum.",
      "postNote": "Publier la note interne",
      "postReply": "Publier la réponse au membre",
      "error": "Impossible de publier."
    },
    "changeStatus": {
      "action": "Changer le statut…",
      "title": "Changer le statut de {{ticket}}",
      "current": "Actuel : {{status}}",
      "new": "Nouveau statut",
      "required": "Choisissez un statut.",
      "emailed": "Le membre reçoit un e-mail à propos de ce changement.",
      "confirm": "Changer le statut",
      "conflict": "Ce statut ne peut pas suivre {{status}}.",
      "error": "Impossible de changer le statut."
    },
    "duplicate": {
      "action": "Marquer comme doublon…",
      "title": "Marquer {{ticket}} comme doublon",
      "canonical": "Doublon de",
      "hint": "Recherchez par numéro ou par titre",
      "noOptions": "Aucun ticket correspondant",
      "required": "Choisissez le ticket qu’il duplique.",
      "consequence": "{{ticket}} renverra vers {{canonical}} ; son demandeur suit ce ticket.",
      "confirm": "Marquer comme doublon",
      "error": "Impossible de le marquer comme doublon."
    },
    "shippedIn": {
      "action": "Définir « livré dans »…",
      "title": "Définir « livré dans » pour {{ticket}}",
      "label": "Livré dans",
      "hint": "Une version ou une publication, en texte libre. Laissez vide pour l’effacer.",
      "confirm": "Enregistrer",
      "error": "Impossible d’enregistrer « livré dans »."
    },
    "page": {
      "tabsAria": "Sections du ticket",
      "conversation": "Conversation",
      "details": "Détails"
    },
    "meta": {
      "requester": "Demandé par {{person}}",
      "created": "Créé {{when}}",
      "updated": "Mis à jour {{when}}",
      "followers_one": "{{count, number}} abonné",
      "followers_other": "{{count, number}} abonnés",
      "shippedIn": "Livré dans {{shippedIn}}",
      "duplicateOf": "Doublon de"
    },
    "conversation": {
      "empty": "Aucune mise à jour pour l’instant.",
      "statusChanged": "Statut passé à {{status}}",
      "public": "Publique : le membre la voit"
    },
    "author": {
      "MEMBER": "Membre",
      "STAFF": "Équipe",
      "SYSTEM": "Système"
    },
    "details": {
      "title": "Détails",
      "description": "Description",
      "type": "Type",
      "email": "E-mail",
      "origin": "Origine",
      "drafted": "Rédigé avec l’assistant"
    },
    "attachments": {
      "title": "Pièces jointes",
      "onUpdate": "Fichiers joints",
      "meta": "{{type}} · {{size}}",
      "download": "Télécharger",
      "downloadAria": "Télécharger {{name}}",
      "hint": "Les fichiers sont seulement téléchargés, jamais ouverts ici.",
      "gone": "Ce fichier n’est plus disponible.",
      "error": "Impossible de télécharger ce fichier."
    }
  },
  "announcements": {
    "notAvailable": "Les annonces ne sont pas encore disponibles.",
    "notFound": "Cette annonce n’existe pas.",
    "loadError": "Impossible de charger les annonces.",
    "itemLoadError": "Impossible de charger cette annonce.",
    "new": "Nouvelle annonce",
    "empty": "Aucune annonce pour l’instant.",
    "emptyFiltered": "Aucune annonce ne correspond à ces filtres.",
    "regionAria": "Liste des annonces",
    "filter": {
      "state": "État",
      "allStates": "Tous les états",
      "kind": "Type",
      "allKinds": "Tous les types"
    },
    "col": {
      "title": "Titre",
      "kind": "Type",
      "audience": "Public",
      "state": "État",
      "publishAt": "Publication",
      "expiresAt": "Expiration",
      "shownAs": "Affichage",
      "related": "Ticket lié",
      "reads": "Lectures"
    },
    "audienceAll": "Tous les clients",
    "audienceTenants_one": "{{count, number}} tenant",
    "audienceTenants_other": "{{count, number}} tenants",
    "pinned": "Épinglée",
    "popup": "Fenêtre contextuelle",
    "kind": {
      "NEWS": "Actualité",
      "FEATURE": "Nouvelle fonctionnalité",
      "MAINTENANCE": "Maintenance",
      "IMPORTANT": "Important"
    },
    "state": {
      "DRAFT": "Brouillon",
      "SCHEDULED": "Programmée",
      "PUBLISHED": "Publiée",
      "EXPIRED": "Expirée"
    },
    "editor": {
      "sectionContent": "Contenu",
      "sectionAudience": "Public et dates",
      "sectionDisplay": "Affichage",
      "title": "Titre",
      "titleRequired": "Saisissez un titre.",
      "body": "Texte",
      "bodyRequired": "Rédigez l’annonce.",
      "bodyHint": "Markdown : # titres, **gras**, *italique*, listes et [liens](https://…). {productName} devient le nom du produit de chaque client.",
      "bodyView": "Affichage du texte",
      "edit": "Modifier",
      "preview": "Aperçu",
      "previewEmpty": "Rien à prévisualiser pour l’instant.",
      "previewNote": "Ici, {productName} s’affiche tel quel ; chaque client voit le nom de son produit.",
      "kind": "Type",
      "audience": "Public",
      "audienceChosen": "Tenants choisis",
      "tenants": "Tenants",
      "tenantsHint": "Seuls les membres de ces tenants la voient.",
      "tenantsRequired": "Choisissez au moins un tenant.",
      "tenantsLoadError": "Impossible de charger les tenants. Choisissez Tous les clients ou réessayez plus tard.",
      "publishWhen": "Quand publier",
      "schedule": "Programmer",
      "publishAt": "Publier le (votre heure)",
      "publishAtRequired": "Choisissez une date et une heure.",
      "publishAtPast": "Choisissez une heure à venir, ou choisissez Maintenant.",
      "expires": "Expiration (facultative, votre heure)",
      "expiresHint": "Laissez vide pour la garder jusqu’à ce que vous la fassiez expirer.",
      "expiresPast": "Choisissez une heure à venir.",
      "expiresBeforePublish": "Choisissez une heure postérieure à la publication.",
      "pinned": "Épingler en haut",
      "pinnedHint": "Les annonces épinglées apparaissent en premier.",
      "popup": "Afficher en fenêtre contextuelle",
      "popupWarning": "Affichée une fois, en fenêtre contextuelle, à tout le public lors de sa prochaine visite.",
      "related": "Demande de fonctionnalité liée (facultative)",
      "relatedHint": "Ses abonnés voient cette annonce. Recherchez par numéro ou par titre.",
      "noOptions": "Aucune demande de fonctionnalité correspondante",
      "termRefused": "Elle mentionne « {{term}} », un terme interne. Retirez-le pour publier.",
      "saveDraft": "Enregistrer le brouillon",
      "saved": "Brouillon enregistré.",
      "saveError": "Impossible d’enregistrer le brouillon.",
      "publishAction": "Publier…",
      "scheduleAction": "Programmer…",
      "readOnly": "Seul un brouillon peut être modifié. Dépubliez-la d’abord pour la changer.",
      "expiredReadOnly": "Une annonce expirée ne peut pas être modifiée.",
      "details": "Détails",
      "author": "Rédigée par",
      "noExpiry": "Sans expiration",
      "notScheduled": "Non programmée"
    },
    "confirm": {
      "publishTitle": "Publier « {{title}} » ?",
      "scheduleTitle": "Programmer « {{title}} » ?",
      "whenNow": "Elle est publiée maintenant.",
      "whenAt": "Elle est publiée le {{when}}.",
      "toAll": "Public : tous les clients.",
      "toTenants_one": "Public : {{count, number}} tenant ({{names}}).",
      "toTenants_other": "Public : {{count, number}} tenants ({{names}}).",
      "popupYes": "Elle s’affiche une fois en fenêtre contextuelle pour tout le public lors de sa prochaine visite.",
      "popupNo": "Elle ne s’affiche pas en fenêtre contextuelle : les membres la trouvent dans leur panneau Assistance et fonctionnalités.",
      "expiresAt": "Elle expire le {{when}}.",
      "publish": "Publier",
      "schedule": "Programmer",
      "error": "Impossible de la publier.",
      "published": "Annonce publiée.",
      "scheduled": "Annonce programmée."
    },
    "delete": {
      "action": "Supprimer le brouillon…",
      "title": "Supprimer le brouillon « {{title}} » ?",
      "consequence": "Le brouillon est supprimé. Cette action est irréversible.",
      "confirm": "Supprimer le brouillon",
      "done": "Brouillon supprimé.",
      "error": "Impossible de supprimer le brouillon."
    },
    "unpublish": {
      "action": "Dépublier…",
      "title": "Dépublier « {{title}} » ?",
      "consequence": "Les membres ne la voient plus, et elle redevient un brouillon que vous pouvez modifier.",
      "confirm": "Dépublier",
      "done": "Annonce dépubliée.",
      "error": "Impossible de la dépublier."
    },
    "expire": {
      "action": "Faire expirer maintenant…",
      "title": "Faire expirer « {{title}} » maintenant ?",
      "consequence": "Les membres ne la voient plus. Elle reste dans cette liste comme expirée.",
      "confirm": "Faire expirer maintenant",
      "done": "Annonce expirée.",
      "error": "Impossible de la faire expirer.",
      "notPublished": "On ne peut faire expirer qu’une annonce publiée. {{stateWords}}",
      "nowState": {
        "DRAFT": "Celle-ci est un brouillon.",
        "SCHEDULED": "Celle-ci est programmée.",
        "PUBLISHED": "Celle-ci est publiée.",
        "EXPIRED": "Celle-ci a déjà expiré."
      }
    }
  },
  "knowledge": {
    "subtitle": "Noms de commerçants et banques appris des membres, partagés seulement quand vous les approuvez.",
    "tabsAria": "Sections de la connaissance des commerçants",
    "tab": {
      "patterns": "Motifs de commerçants",
      "banks": "Banques non répertoriées"
    },
    "notAvailable": {
      "patterns": "Les motifs de commerçants ne sont pas encore disponibles.",
      "banks": "Les banques non répertoriées ne sont pas encore disponibles.",
      "naming": "La qualité des noms n’est pas encore disponible."
    },
    "gate": {
      "NOT_P2P": "Pas un paiement entre particuliers",
      "MOSTLY_BUSINESS": "Surtout confirmé comme une entreprise",
      "MERCHANT_MARKERS": "Marqueurs de commerçant",
      "NOT_PERSONAL_NAME": "Pas un nom de personne",
      "THRESHOLD": "Seuil atteint",
      "REDACTED": "Données masquées"
    },
    "gateResult": {
      "passed": "Validé",
      "notPassed": "Non validé"
    },
    "gatesTally": "{{passed, number}} sur {{total, number}}",
    "noProposedName": "Aucun nom proposé",
    "stateNow": {
      "CANDIDATE": "Ce motif est maintenant candidat, cette action est donc impossible.",
      "APPROVED": "Ce motif est maintenant approuvé, cette action est donc impossible.",
      "RETIRED": "Ce motif est maintenant retiré, cette action est donc impossible."
    },
    "kind": {
      "VENDOR": "Entreprise",
      "OTHER": "Autre",
      "PERSON": "Personne"
    },
    "institutionKind": {
      "BANK": "Banque",
      "CREDIT_UNION": "Coopérative de crédit",
      "OTHER": "Autre"
    },
    "source": {
      "KNOWN_MERCHANT": "Commerçants connus",
      "BANK_TEXT": "Texte de la banque",
      "AI": "IA"
    },
    "view": {
      "aria": "Files des motifs de commerçants",
      "ready": "Prêts à examiner",
      "short": "Encore incomplets",
      "approved": "Approuvés",
      "retired": "Retirés"
    },
    "search": "Rechercher des motifs",
    "searchHint": "Recherche dans le motif et le nom proposé",
    "loadError": "Impossible de charger les motifs de commerçants.",
    "regionAria": "Liste des motifs de commerçants",
    "empty": {
      "ready": "Aucun candidat prêt à examiner.",
      "short": "Aucun candidat encore incomplet.",
      "approved": "Aucun motif approuvé.",
      "retired": "Aucun motif retiré."
    },
    "col": {
      "pattern": "Motif",
      "proposedName": "Nom proposé",
      "kind": "Type",
      "confirmations": "Confirmations",
      "edits": "Modifications",
      "forgets": "Oublis",
      "members": "Membres",
      "tenants": "Tenants",
      "gates": "Contrôles validés",
      "actions": "Actions"
    },
    "detail": {
      "open": "Ouvrir",
      "pattern": "Motif",
      "kind": "Type",
      "evidence": "Éléments",
      "gates": "Contrôles",
      "noGates": "Aucun résultat de contrôle n’a été envoyé."
    },
    "approve": {
      "open": "Approuver…",
      "title": "Approuver un motif de commerçant",
      "name": "Nom",
      "nameHint": "Corrigez l’orthographe si besoin.",
      "nameRequired": "Saisissez un nom.",
      "kind": "Type",
      "kindRequired": "Choisissez un type.",
      "consequence": "Les membres dont le texte bancaire correspond à ce motif le verront nommé « {{name}} » ({{kind}}).",
      "error": "Impossible d’approuver le motif.",
      "notPromotable": "Ce motif ne peut pas encore être approuvé. Il ne passe pas : {{gates}}.",
      "confirm": "Approuver",
      "done": "Motif approuvé."
    },
    "reject": {
      "open": "Rejeter…",
      "title": "Rejeter « {{name}} »",
      "reason": "Motif du rejet",
      "hint": "Conservé avec la trace d’audit. Les membres ne le voient jamais. {{used, number}} sur {{max, number}} caractères.",
      "required": "Saisissez un motif du rejet.",
      "tooLong": "Utilisez {{max, number}} caractères au maximum.",
      "error": "Impossible de rejeter le motif.",
      "confirm": "Rejeter",
      "done": "Motif rejeté."
    },
    "retire": {
      "open": "Retirer…",
      "title": "Retirer « {{name}} » ?",
      "consequence": "Les noms des membres n’utilisent plus ce motif, qui passe dans Retirés.",
      "confirm": "Retirer",
      "error": "Impossible de retirer le motif.",
      "done": "Motif retiré."
    },
    "banks": {
      "loadError": "Impossible de charger les banques non répertoriées.",
      "empty": "Aucune banque non répertoriée à examiner.",
      "regionAria": "Liste des banques non répertoriées",
      "newest": "Affichage des {{max, number}} plus récentes.",
      "requests_one": "{{count, number}} demande",
      "requests_other": "{{count, number}} demandes",
      "col": {
        "typedName": "Nom saisi",
        "country": "Pays",
        "count": "Demandes",
        "requestedAt": "Dernière demande"
      },
      "add": {
        "open": "Ajouter au catalogue…",
        "title": "Ajouter « {{name}} » au catalogue",
        "name": "Nom",
        "nameHint": "Tel que les membres doivent le voir.",
        "nameRequired": "Saisissez un nom.",
        "country": "Pays",
        "countryInvalid": "Saisissez le code pays à deux lettres, par exemple CR ou US.",
        "city": "Ville (facultatif)",
        "kind": "Type",
        "kindRequired": "Choisissez un type.",
        "error": "Impossible d’ajouter la banque au catalogue.",
        "confirm": "Ajouter au catalogue",
        "done": "{{name}} ajoutée au catalogue.",
        "exists": "Déjà répertoriée. Une banque portant ce nom figure déjà au catalogue pour {{country}}. Écartez plutôt cette demande.",
        "dismissInstead": "Écarter la demande"
      },
      "dismiss": {
        "open": "Écarter…",
        "title": "Écarter « {{name}} » ?",
        "consequence_one": "La demande de {{country}} est clôturée. Rien n’est ajouté au catalogue.",
        "consequence_other": "Les {{count, number}} demandes de {{country}} sont clôturées. Rien n’est ajouté au catalogue.",
        "confirm": "Écarter",
        "error": "Impossible d’écarter la demande.",
        "done": "Demande écartée."
      }
    }
  },
  "namingQuality": {
    "intro": "Les noms s’améliorent-ils ? À quelle fréquence les membres acceptent, modifient ou oublient les noms proposés.",
    "noInstitution": "Aucune banque du catalogue",
    "loadError": "Impossible de charger le rapport sur la qualité des noms.",
    "empty": "Aucun nom sur cette période.",
    "by": {
      "aria": "Sections de la qualité des noms",
      "source": "Par origine du nom",
      "institution": "Par établissement",
      "model": "Par modèle et version du prompt"
    },
    "col": {
      "source": "Origine du nom",
      "institution": "Établissement",
      "model": "Modèle",
      "promptVersion": "Version du prompt",
      "named": "Noms",
      "accepted": "Acceptés",
      "edited": "Modifiés",
      "forgotten": "Oubliés",
      "acceptanceRate": "Taux d’acceptation",
      "editRate": "Taux de modification",
      "forgetRate": "Taux d’oubli"
    }
  }
}
